var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurrency(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-93"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.25,356l-8.77-5.07s-5.22-21.7-3.14-41.22c2.93-27.45,21-37.77,27.86-35.41s8.86,10.36-2.51,26.7C455,310.65,446.75,330.74,448.25,356Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.25,356l-8.77-5.07s-5.22-21.7-3.14-41.22c2.93-27.45,21-37.77,27.86-35.41s8.86,10.36-2.51,26.7C455,310.65,446.75,330.74,448.25,356Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M444.62,345.34h.08a.62.62,0,0,0,.49-.71c-4.81-25.32,4-53.77,15-65.6a.61.61,0,1,0-.89-.83c-11.15,12.05-20.17,41-15.29,66.65A.61.61,0,0,0,444.62,345.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.33,368.74c1.31.67,4.8-2.31,5.77-3a12.19,12.19,0,0,0,3.81-4.84,11.45,11.45,0,0,0,.67-6.89,28,28,0,0,0-1.05-3.6l-1.2-3.48a8.85,8.85,0,0,1-.69-3.53c.18-2.43,2.24-4.23,4.12-5.79,2.07-1.72,4.21-4,4.05-6.87a10.21,10.21,0,0,0-2.87-6c-1.48-1.69-3.21-3.17-4.56-5a7.19,7.19,0,0,1-1.69-4.44,7.53,7.53,0,0,1,.84-2.88c.93-1.94,2.2-3.74,2.81-5.81s.37-4.6-1.29-6c-1.36-1.13-3.3-1.2-5.06-1a11.36,11.36,0,0,0-4.57,1.87c-4.49,2.8-6.85,8.4-11.65,10.62a48.65,48.65,0,0,1-5.85,1.75c-1.94.62-3.9,1.72-4.72,3.59-1.62,3.68,1.94,7.94.87,11.82-.95,3.43-4.16,4.88-5.85,8a7.24,7.24,0,0,0-.64,4.45,21.43,21.43,0,0,0,2.24,7.37,66.46,66.46,0,0,0,4.43,6.82S470.13,368.64,470.33,368.74Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.33,368.74c1.31.67,4.8-2.31,5.77-3a12.19,12.19,0,0,0,3.81-4.84,11.45,11.45,0,0,0,.67-6.89,28,28,0,0,0-1.05-3.6l-1.2-3.48a8.85,8.85,0,0,1-.69-3.53c.18-2.43,2.24-4.23,4.12-5.79,2.07-1.72,4.21-4,4.05-6.87a10.21,10.21,0,0,0-2.87-6c-1.48-1.69-3.21-3.17-4.56-5a7.19,7.19,0,0,1-1.69-4.44,7.53,7.53,0,0,1,.84-2.88c.93-1.94,2.2-3.74,2.81-5.81s.37-4.6-1.29-6c-1.36-1.13-3.3-1.2-5.06-1a11.36,11.36,0,0,0-4.57,1.87c-4.49,2.8-6.85,8.4-11.65,10.62a48.65,48.65,0,0,1-5.85,1.75c-1.94.62-3.9,1.72-4.72,3.59-1.62,3.68,1.94,7.94.87,11.82-.95,3.43-4.16,4.88-5.85,8a7.24,7.24,0,0,0-.64,4.45,21.43,21.43,0,0,0,2.24,7.37,66.46,66.46,0,0,0,4.43,6.82S470.13,368.64,470.33,368.74Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M457.63,362.12h0a.58.58,0,0,0,.53-.62c-2.1-22.77,7.38-48.5,14.83-56.22a.57.57,0,0,0,0-.81.58.58,0,0,0-.81,0c-7.6,7.87-17.28,34-15.15,57.12A.57.57,0,0,0,457.63,362.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.9,334.05a.45.45,0,0,0,.16,0,77.38,77.38,0,0,1,16.43-3.51.58.58,0,0,0,.52-.63.56.56,0,0,0-.63-.52,79.27,79.27,0,0,0-16.71,3.57.58.58,0,0,0,.23,1.12Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.44,356l8.77-5.07s5.22-21.7,3.14-41.22c-2.92-27.45-21-37.77-27.86-35.41S25.63,284.66,37,301C43.71,310.65,51.94,330.74,50.44,356Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.44,356l8.77-5.07s5.22-21.7,3.14-41.22c-2.92-27.45-21-37.77-27.86-35.41S25.63,284.66,37,301C43.71,310.65,51.94,330.74,50.44,356Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.08,345.34H54a.6.6,0,0,1-.48-.71c4.81-25.32-4-53.77-15-65.6a.61.61,0,0,1,.9-.83c11.15,12.05,20.16,41,15.28,66.65A.6.6,0,0,1,54.08,345.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.36,368.74c-1.31.67-4.79-2.31-5.77-3a12.17,12.17,0,0,1-3.8-4.84,11.38,11.38,0,0,1-.67-6.89,26.49,26.49,0,0,1,1.05-3.6c.39-1.16.79-2.32,1.19-3.48a9,9,0,0,0,.7-3.53c-.19-2.43-2.25-4.23-4.12-5.79-2.08-1.72-4.21-4-4.05-6.87a10.19,10.19,0,0,1,2.86-6c1.48-1.69,3.21-3.17,4.56-5A7.13,7.13,0,0,0,22,315.34a7.53,7.53,0,0,0-.84-2.88c-.93-1.94-2.2-3.74-2.8-5.81s-.38-4.6,1.28-6c1.36-1.13,3.31-1.2,5.07-1a11.48,11.48,0,0,1,4.57,1.87c4.48,2.8,6.84,8.4,11.64,10.62a48.65,48.65,0,0,0,5.85,1.75c1.95.62,3.9,1.72,4.72,3.59,1.62,3.68-1.94,7.94-.87,11.82,1,3.43,4.16,4.88,5.85,8a7.17,7.17,0,0,1,.64,4.45,21,21,0,0,1-2.24,7.37A66.46,66.46,0,0,1,50.44,356S28.56,368.64,28.36,368.74Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.36,368.74c-1.31.67-4.79-2.31-5.77-3a12.17,12.17,0,0,1-3.8-4.84,11.38,11.38,0,0,1-.67-6.89,26.49,26.49,0,0,1,1.05-3.6c.39-1.16.79-2.32,1.19-3.48a9,9,0,0,0,.7-3.53c-.19-2.43-2.25-4.23-4.12-5.79-2.08-1.72-4.21-4-4.05-6.87a10.19,10.19,0,0,1,2.86-6c1.48-1.69,3.21-3.17,4.56-5A7.13,7.13,0,0,0,22,315.34a7.53,7.53,0,0,0-.84-2.88c-.93-1.94-2.2-3.74-2.8-5.81s-.38-4.6,1.28-6c1.36-1.13,3.31-1.2,5.07-1a11.48,11.48,0,0,1,4.57,1.87c4.48,2.8,6.84,8.4,11.64,10.62a48.65,48.65,0,0,0,5.85,1.75c1.95.62,3.9,1.72,4.72,3.59,1.62,3.68-1.94,7.94-.87,11.82,1,3.43,4.16,4.88,5.85,8a7.17,7.17,0,0,1,.64,4.45,21,21,0,0,1-2.24,7.37A66.46,66.46,0,0,1,50.44,356S28.56,368.64,28.36,368.74Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.06,362.12h0a.57.57,0,0,1-.52-.62c2.1-22.77-7.38-48.5-14.83-56.22a.57.57,0,0,1,0-.81.58.58,0,0,1,.81,0c7.6,7.87,17.28,34,15.15,57.12A.57.57,0,0,1,41.06,362.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8,334.05a.47.47,0,0,1-.17,0,77.35,77.35,0,0,0-16.42-3.51.59.59,0,0,1-.53-.63.57.57,0,0,1,.63-.52A79.15,79.15,0,0,1,39,332.93a.58.58,0,0,1-.22,1.12Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sparkles--inject-93"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shine--inject-93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.23,78.76c0,4.71-.12,9.25-6.93,10.3,7.19-.09,6.65,4.44,7,10.12.19-5.68.69-9.75,6.3-10C475.8,88.2,476,85.51,475.23,78.76Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.73,266.05c0,4.72-.12,9.25-6.93,10.31,7.19-.1,6.65,4.44,7,10.11.19-5.67.69-9.75,6.3-10C365.3,275.49,365.46,272.81,364.73,266.05Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.15,253.46c0,4.72-.12,9.25-6.93,10.31,7.19-.1,6.65,4.44,7,10.11.19-5.67.69-9.75,6.3-10C138.72,262.9,138.87,260.22,138.15,253.46Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.59,292c.08,6.82-.17,13.37-10,14.9,10.4-.14,9.61,6.41,10.12,14.61.28-8.2,1-14.09,9.1-14.47C392.42,305.6,392.64,301.71,391.59,292Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.21,289.28c.07,6.81-.17,13.37-10,14.9,10.39-.14,9.6,6.41,10.11,14.61.28-8.2,1-14.09,9.1-14.48C93,302.93,93.26,299,92.21,289.28Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.18,95.74c.05,4.72-.12,9.25-6.92,10.31,7.19-.09,6.64,4.44,7,10.12.19-5.68.69-9.76,6.29-10C29.76,105.19,29.91,102.5,29.18,95.74Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.8,28.19c.06,5.54-.14,10.87-8.15,12.12,8.46-.12,7.82,5.21,8.23,11.89.23-6.68.82-11.47,7.41-11.78C122.47,39.29,122.65,36.13,121.8,28.19Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.75,26.84c.06,5.54-.13,10.88-8.14,12.12,8.46-.11,7.82,5.22,8.23,11.9.23-6.68.81-11.47,7.41-11.79C42.43,37.94,42.61,34.78,41.75,26.84Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.72,164.15c.08,7.2-.18,14.12-10.58,15.74,11-.15,10.15,6.77,10.69,15.44.29-8.67,1.06-14.89,9.61-15.3C420.59,178.57,420.83,174.47,419.72,164.15Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.23,31.64c.07,6-.15,11.86-8.88,13.21,9.22-.12,8.53,5.69,9,13,.24-7.28.88-12.5,8.07-12.85C390,43.74,390.17,40.3,389.23,31.64Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7,195.59c.08,7.26-.18,14.26-10.68,15.89,11.09-.15,10.25,6.84,10.79,15.59.3-8.75,2.25-15.33,10.89-15.74C39.76,209.85,38.82,206,37.7,195.59Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.25,195.71c.05,5.12-1,10.26-8.43,11.41,7.82-.11,8.12,4.61,8.51,10.78.2-6.17,1.89-10.92,8-11.22C463,205.64,462,203.05,461.25,195.71Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.39,67c0,5.13-.13,10.06-7.53,11.21,7.82-.11,7.23,4.82,7.61,11,.21-6.17.75-10.6,6.84-10.89C83,77.27,83.18,74.35,82.39,67Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.32,69.14c.06,5.12-.13,10-7.53,11.2,7.82-.1,7.23,4.83,7.61,11,.21-6.17.75-10.6,6.84-10.89C422.94,79.4,423.11,76.48,422.32,69.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.37,25.69c.06,5.12-.13,10.05-7.53,11.2,7.82-.11,7.23,4.82,7.61,11,.21-6.17.75-10.6,6.84-10.89C462,36,462.16,33,461.37,25.69Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,196.4c0-5.12-.13-9.7-7.53-10.85,7.82.11,7.23-5.18,7.61-11.35.21,6.17,1.15,11.46,7.24,11.75C96,187,95.8,189.06,95,196.4Z",
    style: {
      fill: "#f5f5f5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--World--inject-93"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--world--inject-93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.76,254.27a130.52,130.52,0,1,0-42.31-113.33A130.53,130.53,0,0,0,162.76,254.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.66,191.56c-.38-.29-3.5-3.46-3.47-3.5a.48.48,0,0,0,.08-.53c-.08-.14-.85-.44-1.43-.84q.54,2.34,1.17,4.65c.66.46,1.63.83,2.13,1.14.66.4,2.07,2,2.77,1.81C130.1,193.92,128,191.85,127.66,191.56Zm10.65-98a4.2,4.2,0,0,0,1.86-.12,1.38,1.38,0,0,1,.81,0c.74.33-.13,2.41.49,2.88.38.29,1.06,0,1.59-.18a10.52,10.52,0,0,0,2.38-.75,7.16,7.16,0,0,0,1.37-1,28,28,0,0,1,3.44-2.16,2.1,2.1,0,0,0,1.2-2.53c-.22-.92-1-.7-1.92-.17-1.2.71-2.54,1.74-2.9,1.92s-.54.2-.47-.1c.13-.59,1.58-1.47,1.83-1.67.57-.43,1.12-.87,1.67-1.3.91-.71,2-1.4,2.42-1.72a5.53,5.53,0,0,0,.81-.67,5.73,5.73,0,0,0,1-1.32c.47-1-.17-1.36.28-2.3a7.06,7.06,0,0,1,1.55-1.83,19.56,19.56,0,0,0,1.67-1.81c.95-1.31.59-2.49,1.16-3.93a8.23,8.23,0,0,1,1.32-2.2c.79-.95,1.9-2.11,2.48-2.86l1-1.34a9.32,9.32,0,0,0,1.09-1.79c.19-.42.34-.91.52-1.32a3,3,0,0,1,.7-1,6.28,6.28,0,0,0,1.71-3.2c.27-1.58-.72-.93-1-1.17-.53-.4-1.19-.16-1.91.16-1.57.7-3.33,2-5.14,3.08q-3.33,3.21-6.47,6.7c-1.8,2-3.5,4.06-5.15,6.13a3.63,3.63,0,0,0,1.47.13c1.2,0,2.76-1.69,4.12-2.57.61-.39,2.41-1.83,2.69-1.24.44.91-1.53,2.66-2,3a2.78,2.78,0,0,0-.87,1.07c-.38.88-1,2.12-1.77,1.87a3.12,3.12,0,0,0-1.32-.36.83.83,0,0,0-.75.67c-.25.8-1.24,2.25-1.66,1.51-.25-.44-.38-1.11-.81-1.21s-.77,0-1.08-.08a.69.69,0,0,1-.17-.1c-1.63,2.15-3.17,4.34-4.64,6.57a2.3,2.3,0,0,0,.63.44,3.8,3.8,0,0,0,2.47.12,6.87,6.87,0,0,0,1.3-.61c.51-.3,1.57-1.47,2-1.41s.07,1.47-.27,2.29a12,12,0,0,1-2.42,3.49c-1.55,1.49-2.57,1.88-3.81,1.94-.43,0-2.18,0-2.68.8S137.94,93.42,138.31,93.56Zm-5.66,15.07c1.53.4,2.8-1.52,3.37-3.17.73-2.09-1.26-1.65-.65-2.48.44-.58,1-1.29.63-1.51-.09-.08-.28,0-.38-.1s-1,.14-2.2,1.27-1.26,2.6-2.16,3.32S131.64,108.36,132.65,108.63ZM136,97.9c.13-.34.78-2.32.2-3-.28-.32-.67-.16-1,.18-.39.73-.76,1.46-1.14,2.18a4.73,4.73,0,0,0,.7,1.11C135.05,99,135.85,98.23,136,97.9Zm31.82-32.54c-.23,1.56-1.92,1.69-2.45,2.11a4.14,4.14,0,0,0-.73.76A4.24,4.24,0,0,0,164.2,71c.09.29.08.57-.57,1.54a23.7,23.7,0,0,1-2.79,3.36A6,6,0,0,0,159.19,79c-.26,1.24.13,1.11.54,1.37a1.65,1.65,0,0,1,.52.53c.24.38.58,1.51,1.14,1.54s2-1.12,3.11-1.91c1.86-1.33,3.67-2.39,5.09-.94a4.14,4.14,0,0,1,1,1.81,20.42,20.42,0,0,1,.19,5.38,4,4,0,0,0,.33,2.32c.8,1.08,2.26.68,3.12,1.92a5.83,5.83,0,0,1,.37,4.18c-.35,1.72-1.13,2.52-1.66,4s.14,2.86.3,4.23a13.3,13.3,0,0,0,1.56,4.7,38.58,38.58,0,0,0,2.85,4.52,6,6,0,0,0,1.39,1.47c.87.6,2.74.27,3.95-.38a4.37,4.37,0,0,0,1.9-2c1-2,0-4.52,0-6.72a5.5,5.5,0,0,1,1.84-4.36c1.05-1,2.55-1.82,3.24-3.36.57-1.26.64-3,1.28-4.2.86-1.61,2.74-2.06,3.91-3,.81-.65,2.39-2.09,2.19-3.5-.1-.77-.48-1.08-.32-1.88a2.83,2.83,0,0,1,.76-1.22,7.28,7.28,0,0,1,.62-.48c.34-.27.23-1.24-.17-1.63a9.15,9.15,0,0,1-.74-.68c-1.17-1.4-1.63-2.66-.64-3.91.84-1,2.26-3.08,1.32-5-.57-1.13-1.36-1.39-1.69-2.72a5.14,5.14,0,0,1-.14-1.53,14.74,14.74,0,0,1,.65-2.54,1.58,1.58,0,0,0-.22-1.37c-.55-.83-1.43-.67-2-1.11-3-2.23,3-9.76,1.92-10.9a1.06,1.06,0,0,0-.76-.26,6.67,6.67,0,0,0-1.69.2,2.24,2.24,0,0,0-1.72,1.65c-.37.84-.87,1.79-1.15,1.62-.1-.07-.21-.27-.47-.51-.73-.68-.62,0-1.16.48-.26.25-1.31.64-1.63-.29s.42-2.21.57-2.81a2.5,2.5,0,0,1,.63-1.16c.46-.44.05-1.72-1-2.24a5.89,5.89,0,0,0-3-.51A8.8,8.8,0,0,0,180,50.14a13.09,13.09,0,0,0-2.33,2.48c-1,1.35-1.55,4-2.65,5.52a2.11,2.11,0,0,1-2.15.94c-1.38,0-3.15,0-4.8,3C167,64,168,63.83,167.79,65.36Zm204,87.33a6.88,6.88,0,0,0,1.46,3.63,6.76,6.76,0,0,0,1.85,2.12,3.23,3.23,0,0,0,5-1.91c.14-.57.19-1.67.39-2.38q-.06-2.67-.24-5.34a2.06,2.06,0,0,1-.46-2.2c.4-1.3.13-2.87-1.14-2.74s-1.51,1.56-2.16,2.77a25.6,25.6,0,0,1-2.75,4C373.12,151.46,371.67,151.18,371.77,152.69Zm-151.94-101c.41.25.81.63,1.22.91a6.16,6.16,0,0,0,1.53.75,14.32,14.32,0,0,1,1.83.72l.23.2c.27.29.12.25.17.5.08.46.44.65.95.78a12.66,12.66,0,0,1,1.3.45c.72.26,1.92.13,1.95-.56a5,5,0,0,0-.21-1.35,10.51,10.51,0,0,1-.48-2.23c0-.07,0-.19,0-.32s.32-.5.93-.35c.43.1.88.26,1.13.32s.34.07.44.11c.25.08.33.42.35.54a.4.4,0,0,0,.15.2.94.94,0,0,0,.5.17,5.52,5.52,0,0,0,1.72.17,2.22,2.22,0,0,0,.63-.19.64.64,0,0,0-.15-1.1,19,19,0,0,1-2.66-.63,6,6,0,0,1-1.63-1c-.94-.84-.24-1.23.37-1.39a7.22,7.22,0,0,0,1.44-.52,3.21,3.21,0,0,0,1.62-1.57,1.54,1.54,0,0,0-.36-1.13l-.11-.08a2.18,2.18,0,0,0-2.12-.09c-.77.27-1.63.52-2.45.72A5.62,5.62,0,0,1,227,46a2.73,2.73,0,0,0-.87.06,3.69,3.69,0,0,0-1.22.94,2.71,2.71,0,0,1-1.51.9c-.35.07-1,0-.89.45.12.63,1,1,1.33,1.56s-.34.38-.77.11-.55-.8-.94-1-.57,0-.58.16c0,.35.19.8-.52.55-.4-.14-.63-.41-1-.43-.71,0-2,.82-1.15,1.84A3.64,3.64,0,0,0,219.83,51.68Zm56.32,9a18.79,18.79,0,0,0,1.89.61,2.33,2.33,0,0,0,2.23-.61c.29-.43-.43-1.12-.88-1.64-.18-.2-.36-.38-.54-.56a6.35,6.35,0,0,1-1.12-2.11,5.39,5.39,0,0,1-.21-1.44,5.57,5.57,0,0,1,.8-2.77,16.53,16.53,0,0,1,3.07-3.45c.56-.47,1.15-.92,1.74-1.35.37-.26.74-.52,1.12-.77a6.74,6.74,0,0,0,.93-.48,1,1,0,0,0-.49-1.72,1.61,1.61,0,0,0-.44-.1,1.26,1.26,0,0,0-1,.37,8.77,8.77,0,0,1-2.47,1.3c-3.68,1.31-6.38,3.46-6.75,7.18a19.26,19.26,0,0,0-.19,4c.1.48.18,1-.29,1.16-.3.13-.42.27-.19.66A4.79,4.79,0,0,0,276.15,60.73ZM213.67,93c.4-2-2.43-4.11-3.29-3.73-.52.22-.9.86-1.3,1.17a9.4,9.4,0,0,1-1.72.66c-1,.37-1.54,2-2.49,1.27s-.83,2.4.63,3.85C208.86,99.59,213.07,96,213.67,93Zm164.05,70.22a20.7,20.7,0,0,0-3.19.83,4.19,4.19,0,0,1-1.78.16,1.76,1.76,0,0,1-.89-.43c-.61-.54-.63-1.51-.77-2.44A3.52,3.52,0,0,0,369.7,159c-.3-.26-.61-.56-.91-.8-.5-.4-1.08-.48-1.57-.9a3,3,0,0,1-1.08-1.66,1.84,1.84,0,0,1,.23-1.17,3.37,3.37,0,0,0-.21-2.51c-.26-.43-.56-.83-.77-1.14a14.47,14.47,0,0,0-1.28-1.6c-.22-.26-.5-.38-.72-.63a14.08,14.08,0,0,1-3.19-6.48c-.09-.71,0-1.47.58-1.59a1,1,0,0,1,.56.07,6.29,6.29,0,0,1,1.37,1c.38.33.75.65.85.62,1.18-.4,2.36,4,3.5,1.77.35-.69,1-1.19,1.34-1.87a9,9,0,0,0,.43-.88,6.85,6.85,0,0,0,.42-2.67,5.61,5.61,0,0,0-.4-1.65,9,9,0,0,0-2-2.91,8.84,8.84,0,0,0-1.46-1.3c-.54-.34-.87-.48-1.09-1.25-.47-1.63.45-3.87,2-3.73a2.33,2.33,0,0,0,2.46-1.15,11.29,11.29,0,0,1,2.22-3.06c1.27-1,3-2.13,3.82-3.65q.11-.2.21-.42a128.08,128.08,0,0,0-5.63-15.25c-.23-.53-.63-1.4-1-2.15a131,131,0,0,0-53.69-58.3,7.13,7.13,0,0,1-.78.26,19.39,19.39,0,0,0-3.6,1.15,3.37,3.37,0,0,0-1.56,2.44,3,3,0,0,1-.69,1.65,3.37,3.37,0,0,1-1.84.86c-.52.12-1.53.32-1.11,1.12s2,1.54,2.6,2.19c1.45,1.44-1.25.64-1.94.43a6.76,6.76,0,0,0-2.33-.4c-.43,0-1.44,0-1.35.5s.76,1,1.11,1.41c.51.54.62.74.19,1s-1,.47-1.41.72a3.76,3.76,0,0,1-5.58-1.31,3.48,3.48,0,0,0-1.47-1.29,3.14,3.14,0,0,0-1.68-.33c-1.1.17-1,1.24-.51,2.26s-.41,1.57.15,2.5a7.2,7.2,0,0,0,2.59,2.1c.79.47,2.11,1.08,2,1.88-.14,1.17-1.8.71-3,.33-1.57-.53-3.13-.84-4.72-1.38a8.65,8.65,0,0,0-4-.32c-.7.1-1,.56,0,1.2.47.3,1.93.68,2,1.41s-1.54.92-2,1.09a17.16,17.16,0,0,1-4.16,1.21c-1.12.12-2.4-.05-3.34.41a6,6,0,0,0-1.23.8,3.42,3.42,0,0,0-.87,1.81.7.7,0,0,1-.28.45,1.9,1.9,0,0,1-.5.3,1.68,1.68,0,0,1-1.85-1c-.2-.63-.36-1.32-1-1.55a2.77,2.77,0,0,0-2.2.36.87.87,0,0,0-.25.77c.06.52.71,1.8.84,2.78a2.22,2.22,0,0,1-.26,1.55,6.3,6.3,0,0,1-1,.82,2.52,2.52,0,0,0-.76,1.57c-.24,1.19-.4,2.25-1.41,2.76s-1.93.29-3.27-.59a25.36,25.36,0,0,1-2.8-2c-1.32-1.16.88-1,1.45-1,.85,0,1.63-.28,2.45-.37a8.49,8.49,0,0,0,2-.45c.5-.19,1.39-.54,1.09-1.38-.65-1.85-4.9-2.93-6.15-3.3-.6-.18-1.2-.33-1.79-.48-1-.23-2.66-.59-3.73-.8a5.34,5.34,0,0,0-1.86-.11c-.9.19-1.27,1.56-2.74,0a2.79,2.79,0,0,0-2.35-1.15,9,9,0,0,0-5.08,1.64,5,5,0,0,0-1,1.1c-.49.68-.88,1.88-1.3,2.27a1.7,1.7,0,0,1-1,.46c-2.2.36-2.43,2.48-1.93,5.13.13.71.38,1.5.45,2.2a4.76,4.76,0,0,1-.07,1.2c-.11.63-.41,2.07-.61,3.27-.13.72-.27,1.45-.39,2.22-.35,2.12-.83,4.33-1.32,6.62a7.85,7.85,0,0,0,.23,5,5,5,0,0,0,2.89,2.41,3.4,3.4,0,0,0,3.47-.72c1.44-1,2.37-.42,3.68,1.32a5.5,5.5,0,0,0,2,2,3,3,0,0,0,2.55-.27c.78-.55.82-1.59.4-2.68a3.26,3.26,0,0,1-.11-2.77,2.69,2.69,0,0,0-.53-2.61c-.92-1.35-2.53-3-3-3.88a4.35,4.35,0,0,1-.54-1.7,7.35,7.35,0,0,1,0-1.49c.09-.77.76-2.3,1.17-3.67a8.12,8.12,0,0,0,.35-2.73,4,4,0,0,1,.09-1.28,1.77,1.77,0,0,1,1.72-1,1.64,1.64,0,0,1,1.22.61,3.73,3.73,0,0,1,.5,2.82c-.15,1-.88,1.44-1.12,2.39a7.54,7.54,0,0,0,.62,3.5c.37,1.09.75,2.57,1.63,3.32,1.11.95,2.54.23,3.51-.13.43-.16.93-.35,1.44-.49a5.3,5.3,0,0,1,2.25-.17c.4.11,1,1,.72,1.27a2.13,2.13,0,0,1-.66.37c-.95.41-2,.59-3,1-.61.23-1.63.47-1.45,1.47.14.77,1,1.19,1.56,1.54s1.14.74,1.2,1.44a.6.6,0,0,1-.56.69,2.94,2.94,0,0,1-1.62-.53c-.33-.19-.82-.62-1.1-.36-.44.43.4,2.2.61,2.78a5.41,5.41,0,0,1,.4,3.07c-.58,2-2.74,2.53-4.45,3a17.39,17.39,0,0,1-3.25.29,5.47,5.47,0,0,1-2.13-.08c-1.65-.61-1.66-3.39-2.4-4.82-.88-1.69-2,0-2,1.14.06,1.8,2,3.37,1.88,5.11-.07,1.2-1.37,1.61-2.12,2.2a3.73,3.73,0,0,0-1,3.68,3.37,3.37,0,0,1-.57,2c-.38.85-.88,1.61-1.31,2.4a2.4,2.4,0,0,1-1.4,1.29c-.41.12-1.09,0-1.32.36s.15,1-.39,1.39-1.52.39-2.18.69c-.45.2-1,.73-.41,1.19a6.86,6.86,0,0,0,2.18.6,4.31,4.31,0,0,1,2.56,2.86c.72,1.82.7,3.45-1,4.13s-3.47.8-5,2.1c-1.31,1.14-.4,4,.08,5.66a3.26,3.26,0,0,0,1.06,1.73c.41.4.71,1,1.2,1.26a2.57,2.57,0,0,0,2,0,2.33,2.33,0,0,1,2,.14,3.6,3.6,0,0,0,.48.19c.28.05.42-.7.89-1a3.07,3.07,0,0,1,.91-.25,2.69,2.69,0,0,0,.9-.21c.28-.15.32-.49.5-.63a3,3,0,0,0,.88-2.54c0-.48,0-1,0-1.44s.25-1,.33-1.61a7.62,7.62,0,0,1,.1-1.18c.22-.76.82-.82,1.36-1.19a2,2,0,0,0,.82-2.09c-.08-.71-.34-1.48.22-1.95s1.17-.16,1.72-.3c.94-.25,1.49-1.13,2.15-1.79,1.3-1.34,2.72-1.21,4.19.16a14.26,14.26,0,0,0,2.09,1.72c.58.36,1.21.48,1.79.84.73.47,1.54.74,2.25,1.18a3.42,3.42,0,0,1,1.1,2.69c0,.37-.08,1,.26,1.25s.65-.2.78-.49c.46-.93.06-1.79-.25-2.83-.14-.47-.38-1,0-1.27.15-.11.38-.06.58-.06s0-1-.8-1.31a2.73,2.73,0,0,0-1.41-.21c-.33.07-1.52-.85-1.87-1a20.86,20.86,0,0,1-2.52-1.64,4.24,4.24,0,0,1-1.55-1.84c-.34-1.16.84-1.41,1.62-1.09s.88.92,1.35,1.42c1.05,1.09,2.46,1,3.66,1.34.84.27,1,.91,1.57,1.66a11.25,11.25,0,0,1,1.3,1.7c.23.47.22.55.64.83a8.45,8.45,0,0,0,1.23.64,5.18,5.18,0,0,1,1.16.51c.38.29.26.29.31.7.13.88.35,1.75,1.26,2s.62-1.35.73-2.05a1.61,1.61,0,0,0-.17-1.42c-.29-.41-.83-.56-1.15-.94-.79-1,.27-1.17.66-1.68s.94-1.64,2-1.24c.61.23.62.64.74,1.22a5.29,5.29,0,0,0,.95,1.7,7.34,7.34,0,0,0,1,1.66,4.55,4.55,0,0,0,4.08,1c.57-.16,1-.76,1.55-.78.25,0,.48.15.72.18a2.8,2.8,0,0,0,1.28-.23c.54-.19,1-.53,1.58-.7.9-.27,1.24-.09,1.33,1a37.84,37.84,0,0,0,.55,5.05c.13.62.74,2.09.49,2.63s-1.46,0-2-.12a8.65,8.65,0,0,0-4.35.54,19.05,19.05,0,0,1-2.18.7,4.07,4.07,0,0,1-2.16.19c-1.31-.52-4.75-2.11-5.35,0-.41,1.43.66,3.59-1.29,3.78a8.93,8.93,0,0,1-2.78-.52,20.32,20.32,0,0,0-4.16-.42,4.9,4.9,0,0,1-2.81-.75c-1.2-.86.11-1.63-.06-2.78a3.16,3.16,0,0,0-1.72-2.41,3.69,3.69,0,0,0-2.38.27c-.4.13-.78.13-1.18.24a5.17,5.17,0,0,0-1.19.72,13.75,13.75,0,0,1-2.71,1.1c-.5.16-1,.31-1.46.48-.29.1-1.07.24-1.24.51-.9,1.48-2.1,3.14-3.84,3.52-1.09.25-2.09.17-3,.93a10.29,10.29,0,0,0-2.18,2.82c-.51.86-1,1.75-1.42,2.65-.53,1.06-.16,2.14.2,3.31a3.16,3.16,0,0,1,0,2.08,7.14,7.14,0,0,1-1.75,3,6.79,6.79,0,0,0-2,3.18,18.88,18.88,0,0,0-.49,3.71,10.63,10.63,0,0,0,2.46,7.12c.47.51.24,2.58.3,3.26a6.21,6.21,0,0,0,1.22,3.46,5.85,5.85,0,0,0,1.91,1.61c1.47.79,2.61,2.18,4,3.26a24.59,24.59,0,0,0,4.12,2.71,8.86,8.86,0,0,0,5.79.93,5.31,5.31,0,0,0,2.55-1.19,3.9,3.9,0,0,1,1.31-.77,8.51,8.51,0,0,0,2.73-1.61c.41-.42.79-.88,1.16-1.28a3.39,3.39,0,0,1,3-1.38,4.71,4.71,0,0,1,1.47.45,14,14,0,0,0,2.89,1,3.84,3.84,0,0,0,1.42-.08,3.44,3.44,0,0,1,2.36.34c2,1.06,1.75,3.36,1.4,5.4s.85,3.38,2,4.52c.55.54,1,1.13,1.55,1.64A6.77,6.77,0,0,1,278.1,196c.36.72.76,1.35,1.13,2a16.86,16.86,0,0,1,1.5,4.35c.14.75.23,1.5.31,2.26l.09,1.13a13.06,13.06,0,0,1,0,2.08,6.81,6.81,0,0,0-.09.95,12,12,0,0,0,.29,2.29c.26,1.26.67,3.47.95,4.73a11,11,0,0,0,.69,2.19,58.08,58.08,0,0,0,5.27,8.48c.9,1.29,1.74,2.67,2.62,4,.44.65.82,1.38,1.32,2a11.3,11.3,0,0,1,1.14,2.28c.78,1.58,1.62,2.44,3.05,2.44a6.19,6.19,0,0,0,3.26-1.43,14.66,14.66,0,0,0,5.05-6.1,18.69,18.69,0,0,0,1.28-5.31,11,11,0,0,0,.15-2.58c-.07-.91-.23-1.83-.24-2.76,0-1.41-.12-2.93-.06-4.34.11-2.2-.09-4,.89-6a27.1,27.1,0,0,1,1.56-2.52c.85-1.35,2.48-3.6,1.94-5.69-2.54-9.87-7.55-16.66-.86-26.41,1.6-3.27,3.4-8.48,3.11-12.75-.13-2-1.75-2.87-2.81-2a19.37,19.37,0,0,1-2,1.42c-.63.38-1.31.67-2,1a3.5,3.5,0,0,1-2.13.1,2.11,2.11,0,0,1-1.69-1c-.47-.67-.59-1.45-1-2.13a3.58,3.58,0,0,0-1.67-1.26,14.23,14.23,0,0,1-3.69-2.93,17.31,17.31,0,0,1-2.47-4.2A7.73,7.73,0,0,0,291,147.7a20.18,20.18,0,0,1-2.26-2.42c-.7-.86-3.2-3.8-2.06-4.9.9-.86,2.6,2,3.2,2.68,1.21,1.39,2.42,2.63,3.65,3.84l1.91,1.86c1.06,1,2.33,2.3,2.84,2.83l.92,1a9.44,9.44,0,0,1,1.7,1.92c1.35,3,2.77,4.37,4.44,3.76s3.35-2.87,4.54-4.08a49.42,49.42,0,0,0,5.79-7,11.31,11.31,0,0,0,.84-2.5,8.54,8.54,0,0,0,.55-3,1.75,1.75,0,0,0-1.28-1.75c-.52-.15-1,.18-1.43,0s-.88-1.06-1.37-1.45c-.94-.76-1.47.13-2.08.77s-1.88,2.05-2.79,1.65c-.63-.28-.5-.87-.91-1.33s-.66-.11-1.07-.12c-1.06,0-1.86-1.33-2.59-2.12-.55-.6-1.78-2-1.77-2.88,0-1.57,2.07-.08,2.64.29a23.11,23.11,0,0,1,2.18,1.23,3.44,3.44,0,0,0,1.84.7,13.11,13.11,0,0,0,2,.28c.5,0,.93-.36,1.46-.32a1.7,1.7,0,0,1,.87.31,4.94,4.94,0,0,0,3.64.62c1.34-.39,2.63-1.11,3.86-1.58a6.21,6.21,0,0,1,3-.58,5.8,5.8,0,0,1,3.35,1.9c.68.85,1.4,2.09,2.5,2.29s1.07-2.22,1.78-1.84c.39.2.61,1.1.76,1.5a13.92,13.92,0,0,0,.68,1.47c.56,1.1,1.12,2.22,1.7,3.34a58.22,58.22,0,0,0,3.82,6.75c.69,1,1.73,2.54,2.85,2.62.49,0,1-.78,1.2-1.31a5.32,5.32,0,0,0,.17-1.69,18,18,0,0,0-.11-2.21,24.69,24.69,0,0,1-.11-4.08,13.59,13.59,0,0,1,.34-1.82,14.21,14.21,0,0,1,1.15-3.13,12,12,0,0,0,1.18-2.18c.11-.34.21-.68.31-1a16,16,0,0,1,.69-2,1.94,1.94,0,0,1,.54-.79,4.72,4.72,0,0,1,1-.41c.64-.32.7-.93,1.17-1.42s1.17-.16,1.64.15c1.33.87,1.86,2.72,2.46,4.24.29.75.64,1.73,1.4,1.6s1.08-.71,1.83-.26,1.19,1.72,1.78,2.5,1.38.92,1.75,1.86c.24.61,0,.78-.09,1.33s.12.85.4,1.32a3.13,3.13,0,0,1,.53,1.68,5,5,0,0,0,.05,1.69.77.77,0,0,0,.7.53,2.26,2.26,0,0,1,1.41,1.09c.19.36.36.74.49,1a5.44,5.44,0,0,0,.67,1.17,2.64,2.64,0,0,0,.29.29,2.92,2.92,0,0,1,.58,1.32,1,1,0,0,1-.19.91c-.19.17-.52.1-.86,0s-1.22-.47-1.66-.59a1.63,1.63,0,0,0-.78-.07c-1.33.26.95,3,1.4,3.36s.78.56,1.16.9a3.92,3.92,0,0,1,.83,1.3,16.51,16.51,0,0,0,2,2.71,12.53,12.53,0,0,0,2.19,2.18,5.87,5.87,0,0,0,1.23.7c.12.06,1.26.3,1.27.34.83,3.8,3.32.61,4.94,1.39,1.3.76,2.47,0,3.68-.43a5.47,5.47,0,0,0,.94-.45c0-.34,0-.69.05-1a1.56,1.56,0,0,1-1.26-.35A1.6,1.6,0,0,0,377.72,163.26Zm-91.66-42.55a14.13,14.13,0,0,1-3.57,0c-1.7-.09-4,1.17-5.42,1.92a5.15,5.15,0,0,1-2.26.69c-1.68,0-1.73-3.79-1.56-5.65a7.33,7.33,0,0,1,.65-2.83c.85-1.46,3.69-.64,3.41-.11s.41.83.63,1.25.78.72,1.1.19-.75-2.38.43-3.5a4.49,4.49,0,0,1,.46-.39c1.28-1,2.24-.39,2.54,1.52a3.86,3.86,0,0,0,.41,1.32c1,1.75,2.93,1.45,3,1.66s.85.26,1.61.79S287.67,120.35,286.06,120.71Zm15,2.92c-1.69-.32-2.62-2.9-3.07-4.57s-3.53-2.51-4.36-4.32c-1.45-3.2.63-6.54,2.75-6.95,1.62-.31,1.21,2.33.87,4.09-.12.62.28,1,1,1.6a19.35,19.35,0,0,0,4,1.94c.87.49.27,1.55-.5,2.06s2.46,2.34,2.59,4.22C304.4,123.19,302.85,124,301.05,123.63Zm-52.67,9.3c.39-.73.11-1.3-1.52-.78-.26,0-.54.61-.66,1.16C246,134.09,247.71,134.16,248.38,132.93ZM320,196.46a5.77,5.77,0,0,0-1-2.29,4.34,4.34,0,0,1-.52-.43c-.11-.12-.23-.28-.35-.44a2.42,2.42,0,0,0-.44-.46c-.27-.19-1,.37-1,1.28,0,.57.14,1.21.19,1.63.3,2.31-1.24,3.83-1.9,5.73-.92,2.65.13,4.94.67,7.36.35,1.57.13,3.89,1,5.12,2.95,4,3.81-3.76,4-6.18a43.17,43.17,0,0,0-.28-9.47C320.29,197.7,320.18,197.07,320,196.46Zm-58-62.61a1.37,1.37,0,0,0-1.31-1.49c-.49-.08-.42.43-.29,1C260.61,134.12,261.91,135.08,262,133.85Zm-6.63-3.14c.21-1.8-2.4-6.29-2.59-4.37a7.35,7.35,0,0,0,0,1.06C252.94,129.37,255.2,132.52,255.41,130.71Zm-27.95-18.57c-.22.26-.05.61-.22.87s-.94.29-1.29.48c-1,.53.14,1.45.47,2a2.38,2.38,0,0,1,.28,1.35c0,.44-.2,1,.09,1.39.76,1.12,1.89,0,2.57-.4a3.61,3.61,0,0,0,1.34-2.79,3.39,3.39,0,0,0-.9-2.18C229.27,112.35,228,111.49,227.46,112.14ZM167.2,187.55a7.81,7.81,0,0,1-3.67-.26c-1.16-.33-2.53-.72-3.46,0-.69.56.53,1.17,1.16,1.41a14.47,14.47,0,0,0,1.42.43c.79.19,1.91.68,2.51.83a1.76,1.76,0,0,0,1.06,0c1.33-.49,2.49-1.73,4.16-1.08.4.16,1.14.73,1.55.56l.07,0c.39-.29.09-1.07-.23-1.44C170.55,186.5,168.42,187.31,167.2,187.55ZM233.59,117c.17.6-.7,1-.27,1.57s1,.12,1.42,0c1.58-.57,3.65-1.61,4.37-3.39.28-.67.77-2.3-.15-2.66-.36-.14-.73,0-1.09-.26a4.51,4.51,0,0,1-1.09-1.09,18.18,18.18,0,0,0-1.59-1.9c-.89-.83-2.5-1-2.69-2.55-.06-.52.45-1.13.12-1.65-.18-.28-.51-.26-.77-.34s-1.46-.71-1.49-1.16-2.54.11-2.08.9c.67,1.18-1.28,2.13-.12,2.69l.15.08a15.51,15.51,0,0,0,.33,1.68c.31.87,1.66.9,1.94,1.64s1.35-.17,1.93.41,1,2,.34,2.51.05,1.86-.33,2.33c-.25.3-.5.6-.09,1C232.67,117.06,233.39,116.27,233.59,117Zm-89.87,1.88c-.27,1.82,0,3.39.8,3.54s2.48-1.49,3.73-2.23c1.81-1.05,0-1.53-1.64-2.5C145.53,117,144,117,143.72,118.87Zm83.8,109.29a17.56,17.56,0,0,1-2.07-4.76c-.59-3.14,1.63-5.81,1.1-9.13-.33-2.07-2.94-3.44-4.57-3.71s-4-2.42-5.64-1.94l-.53.16c-1.65.47-4.67-1-6.5-1.21a10.2,10.2,0,0,0-1.23,0c-1.78,0-4.25-1.43-5.62-3.08s-2.72-2.92-4.26-3.3c-2.08-.5-4.1,1.64-6.18.11a8.51,8.51,0,0,0-2.9-1.52,8.77,8.77,0,0,1-3-1.28c-1.35-1-1.94.19-3.23,0-.75-.12-1.08-.4-1.86-.19a29.32,29.32,0,0,1-3,.82c-.83.14-1.24-.2-2-.53-1.81-.75-4,.75-4.56,2.3-.29.76-.2,1.78-.5,2.48-.61,1.41-2.95,1-4.38.7a7.72,7.72,0,0,1-3.06-1.47c-1.07-.88-1.75-1-2.09-2.43-.24-1-.39-2.39-1.37-3.08a3.3,3.3,0,0,0-2.61-.21c-.66.14-1.43.64-2.16.46a2.44,2.44,0,0,1-1.59-1.92c0-.58.49-1,.64-1.56a2,2,0,0,0,.11-.88c0-.15-.34-.73-.33-.79.29-1.27-.14-1.85-.84-1.94a2.84,2.84,0,0,0-2.72,2.85c.11,1.49-1.91,3-3.54,2.79-3.2-.48-6-5.48-6.09-9.34,0-1.78,1.14-4.54,2.57-5.14,1.16-.48,2.57-.33,4-.59.59-.05.46-.45.35-.85-.2-.65,1.09-1,2-1.26a5,5,0,0,1,4.47.71,12.15,12.15,0,0,1,1.63,2c1.06,1.49,3.54,1.85,2.62.18-.57-1-1.51-2.31-2.19-3.49-.93-1.65-.21-4.35.68-5.59a20.66,20.66,0,0,0,1.58-2.25,4,4,0,0,0,.67-2.41c-.19-1-1.07-1.69-1.28-2.77a5.45,5.45,0,0,1,0-2.24,6.72,6.72,0,0,1,1.68-3.23c.77-.77,2.42-1,2.59-2.45s0-2.2.73-3.49a10.23,10.23,0,0,1,1.75-2.1c1.08-1,1,1.41,2.48.82a13.06,13.06,0,0,0,3.75-3.28c1.16-1.36,1.33-3.2.74-3.63s-1.12,2.81-2.67,2.87a2.05,2.05,0,0,1-.49,0c-1.52-.31-1.88-2.67-2.13-2.56s-.32-.28,0-.53.13-2.86-1.2-1.88c-.22.17-.45.37-.69.58-1.26,1.14-1.73,0-.49-1.14,2-1.83,4.64-2.8,7-4.13,1.44-.79,2.2-.12,1.73,1.82s-.64,3.19.54,3.12c1.59-.09,3.23-1.26,3.41-.67.11.38.24.73.65.22.62-.77,1.78.31,2.19-.84a1.69,1.69,0,0,0-.56-1.63c-.61-.7-1.5-2-2.42-1.83s-1.7-2.06-1.66-4.08c0-.21,0-.42,0-.62,0-2-2.73-2.94-4.12-3.66-4.09-2.11-2.87-2.6-5.46-6.36-1-1.39-2.25-.78-3.17.88-.49.88-1,1.57-1.57,1.63-1.37.17-1.45-4.08-2.43-4.27-.54-.1-1.2,0-1.65-.76a2.61,2.61,0,0,0-3.59-.85c-1.23.58-2.07,3.31-1.67,4.73s-.41,3.94.29,4.83,1.92,3.3,1.2,5.08c-.43,1.06-1.18,2-1.51,3-.58,1.87,1.17,4.11.77,5.18a1.08,1.08,0,0,1-1.3.8,4.09,4.09,0,0,1-2.35-2.12c-.78-2.19-.2-3.75-2.22-3.76a20.28,20.28,0,0,1-7.78-1.52c-1.15-.51-1.22-1.54-1.75-2.76s-1.72-1.32-.63-3.48c.68-1.35,1.9-2.5,2.13-4.32s-1.28-1.53-.59-3.08,3-1.6,4-2.32a2.37,2.37,0,0,0,1.06-1.48c.23-1.28-.68-1.11-1-1.63-.1-.17.21-.37.54-.52a3.61,3.61,0,0,0,1.27-.72,2.54,2.54,0,0,0,.47-.86,5.47,5.47,0,0,1,.2-1,1.65,1.65,0,0,1,.69-.68,4.59,4.59,0,0,0,1.63-1.13,6.51,6.51,0,0,0,1.77-2.89,5.36,5.36,0,0,0,.06-2.31c-.2-.37-.69-.2-.78-.84-.27-2.11,1.93-2.68,2.62-3,1.05-.5,2.29-1.14,2.36,1,0,1,.24,3.2,1.17,1.7.53-.85.71-1.24,1.25-.72a1.93,1.93,0,0,1,.88,1.71,2.55,2.55,0,0,1-.82,1.88c-.66.75-.94,3.92-2.16,4.46l-.6.27c-1.22.59-.57,3.6.57,2.7s2.76-.43,3.84.41c1.52,1.19,3.68,2.35,4.58,2.12,1.35-.35-.11-3.09.5-3.49a3.46,3.46,0,0,1,1.12-.59c.22,0,0-1.83-.06-2a2.65,2.65,0,0,0-.8-1.29c-.72-.58-1.58-.45-2.11-1.54s.45-2.69,1.24-2.4c.37.13.67.61,1,1.08.48.74,1.26,1,1.55.8a1.73,1.73,0,0,0,.46-.57c.31-.62.17-1.25.39-1.87.36-1,1.18-.93,1.53-1.89a1.12,1.12,0,0,0-.66-1.62c-1.18-.53-2.42-.71-3.54-1.18-.23-.1-.45-.15-.65-.25s-.62-1.19-.64-2a7.17,7.17,0,0,0-.12-1.36,2,2,0,0,0-1-1.19,6.26,6.26,0,0,0-1.43-.83c-.83-.33-2.55,0-3.33-.89s-1.44-2.07-2.32-1.78c-.11,0-.38.44-.52.54a.91.91,0,0,1-.6.18c-.39,0-.69-.3-1-.39a2.3,2.3,0,0,0-2.33.75,9.4,9.4,0,0,1-.91.83,10.63,10.63,0,0,1-1.84.81,9.17,9.17,0,0,0-2.3,2.4,7.69,7.69,0,0,0-1.07,2c-.36,1.16-.47,2.89.23,2.92s1.79-.61,2.61-.73,2.47-.6,2.15,1.33c-.24,1.46-1.78,1.4-1.64,3,0,.54.34.93.16,1.66a6.52,6.52,0,0,1-.83,1.67,10.33,10.33,0,0,1-.91,1.25c-.46.48-1.21.49-1.28-.3s.45-1.26.47-1.94-.34-.76-.68-.86a1.86,1.86,0,0,0-.58,0,1.68,1.68,0,0,1-1.13-.5,3.71,3.71,0,0,1-.44-.63c-.22-.39-.54-.74-.78-1.17a3.69,3.69,0,0,1,.08-2.78c.18-.27.39-.53.62-.9a14.74,14.74,0,0,0,1.12-2.41c.68-1.8.62-3.37-.51-3s-2.62,2.14-3,4.22a20.7,20.7,0,0,1-.67,3.59c-.42,1.08-1.11,2-1.47,3a18.33,18.33,0,0,0-.35,2.84c-.19,1-.41.81-.87,1.25-1,1-.49,3-1.43,4.17a3.09,3.09,0,0,1-1.11.72,4.3,4.3,0,0,1-2,.49c-.2,0-.47,0-.42-.48.08-.66.63-.94.92-1.27a6.08,6.08,0,0,0,1.22-4.38c-.2-.68-.83-.51-1.24-.74a2.8,2.8,0,0,1-1.13-2.61q-1.92,4.86-3.42,9.83a.62.62,0,0,1,.62.27,1.73,1.73,0,0,1,0,1.33,8.55,8.55,0,0,0-.22,1.1c-.08.6-.5,2.88-1.24,2.57a3,3,0,0,1-.54-.31,130.21,130.21,0,0,0-1.2,61.21,1.11,1.11,0,0,1,1.12.06c1.36.75,2.59,3.24,4,4,2.27,1.26,4.95,2.87,6.56,5,1,1.41,2.57,3.53,4.15,4.1,3.09,1.12,6.58,1.75,9.32.93s6.71,3.35,9,1.36c.28-.24,2.18,1.71,2.45,2a9.93,9.93,0,0,0,3.49,2,20.12,20.12,0,0,0,4,.87c2.51.37,5.59,1.14,5.82,4.77a50.14,50.14,0,0,1-.51,6.58c-.14,2.31-.07,4.57,1.5,6.44s3.64,2.94,5.18,4.72,1.71,4.49,3.35,6.46c2.05,2.46,4.28,2.5,7.24,3a9.54,9.54,0,0,1,5.84,3.17,82.5,82.5,0,0,1,9.68,12.79c3.55,5.63,6.75,11.75,11.46,16.47a27.32,27.32,0,0,0,7.76,5.77c1.92.9,3.58.63,3-1.84-.33-1.52-1.78-2.54-2.62-3.79s-.51-2.54-.82-4c-.26-1.17-1.66-2.76-1-3.88s2-.73,2.2-2.09c.26-1.71-1.62-2.11-2.14-3.3s1.59-1.64,2-2.9c.27-.79-.13-1.68,0-2.48.11-.65.42-.81.7-1.32a6.81,6.81,0,0,0,.53-3.2c0-1.77-2.07-3.4-1.74-5.15.24-1.25,1.66-2.8,2.78-3.67.88-.68,1.53-.89,1.88-2.3a8.68,8.68,0,0,0-.62-4.89C227.7,230,227.88,228.87,227.52,228.16Zm-86.85-73c1-1.46,2.78-4.62,4.14-4.21a4.81,4.81,0,0,1,1.8,1.5c1.06,1.2,3.19,1.26,4.49,1.59s-.12,1.81-.06,3-.68,1.8-.78,1.15c-.06-.4-.15-.7-.65-.36-.71.48-.64-.14-.55-.83.11-.94-2.09-1.26-2.26.65,0,.48,0,1,0,1.55.05,1.9-1.72,2.23-1.75.33,0-.24,0-.48,0-.73.07-1.91-.94-4-2.37-3.49C141,155.87,139.56,156.76,140.67,155.19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.64,37.58c-85.86-10.81-92.4,47.58-43.33,76s125.51,28.35,131.9,3.51S329.46,45.61,265.64,37.58Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,235.23c-72-42.34-69.81-152.32-19-194h0c-2.24,1.16-4.46,2.37-6.66,3.68A130.54,130.54,0,1,0,376.8,188.25C362.69,216.11,281,277.56,209,235.23Z",
    style: {
      opacity: 0.05
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-93"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-93",
    cx: 330.93,
    cy: 370.73,
    rx: 40.42,
    ry: 23.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-93",
    cx: 251.86,
    cy: 429.68,
    rx: 73.04,
    ry: 42.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-93",
    cx: 434.44,
    cy: 445.98,
    rx: 40.36,
    ry: 23.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-93",
    cx: 428.45,
    cy: 375.31,
    rx: 43.46,
    ry: 25.09,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-93",
    cx: 158.57,
    cy: 373.04,
    rx: 43.46,
    ry: 25.09,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-93",
    cx: 378.93,
    cy: 437.09,
    rx: 43.46,
    ry: 25.09,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-93",
    cx: 65.15,
    cy: 381.37,
    rx: 43.46,
    ry: 25.09,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-93",
    cx: 125.38,
    cy: 439.51,
    rx: 43.46,
    ry: 25.09,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-93",
    cx: 61.98,
    cy: 444.19,
    rx: 43.46,
    ry: 25.09,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-93"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Euro--inject-93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.9,360.17a22.64,22.64,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.75,0a22.64,22.64,0,0,1,8.4,7.77h1.9v7.18h0c-.25,5-3.67,9.95-10.27,13.77-13.74,7.93-36,7.93-49.75,0-6.6-3.82-10.05-8.77-10.3-13.77h0v-7.18Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.9,360.17a22.64,22.64,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.75,0a22.64,22.64,0,0,1,8.4,7.77h1.9v7.18h0c-.25,5-3.67,9.95-10.27,13.77-13.74,7.93-36,7.93-49.75,0-6.6-3.82-10.05-8.77-10.3-13.77h0v-7.18Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.17,346.45c9,0,18,2,24.88,5.95a22.64,22.64,0,0,1,8.4,7.77h1.9v7.18h0c-.25,5-3.67,9.95-10.27,13.77-6.87,4-15.88,5.95-24.88,5.95Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.38,349.75a37.32,37.32,0,0,1,5.67,2.65,22.64,22.64,0,0,1,8.4,7.77h1.9v7.18h0c-.25,5-3.67,9.95-10.27,13.77a39.34,39.34,0,0,1-5.67,2.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,349.75a37.66,37.66,0,0,0-5.66,2.65,22.64,22.64,0,0,0-8.4,7.77H296v7.18h0c.25,5,3.7,9.95,10.3,13.77a39.73,39.73,0,0,0,5.66,2.65Z",
    style: {
      fill: "#1E75FE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.05,345.81c13.73,7.93,13.73,20.79,0,28.72-12,6.94-30.57,7.81-44.23,2.6h0l-.54-.21a37.5,37.5,0,0,1-5-2.39c-11.45-6.61-13.36-16.65-5.7-24.4h0a26.91,26.91,0,0,1,5.7-4.31C320,337.88,342.31,337.88,356.05,345.81Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.05,345.81c13.73,7.93,13.73,20.79,0,28.72-12,6.94-30.57,7.81-44.23,2.6h0l-.54-.21a37.5,37.5,0,0,1-5-2.39c-11.45-6.61-13.36-16.65-5.7-24.4h0a26.91,26.91,0,0,1,5.7-4.31C320,337.88,342.31,337.88,356.05,345.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.6,350.13a15.32,15.32,0,0,0-3.68,12.53c1.21,7,11,12.85,14.36,14.26a37.5,37.5,0,0,1-5-2.39C294.85,367.92,292.94,357.88,300.6,350.13Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.75,370.22a15.39,15.39,0,0,0,3.68-12.53c-1.22-7-11-12.86-14.36-14.27a38,38,0,0,1,5,2.39C367.5,352.43,369.4,362.47,361.75,370.22Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 331.19,
    cy: 360.14,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 331.19,
    cy: 360.14,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,365.78c-2.63-4.86-1.77-10.21,2.56-14.75a23,23,0,0,1,2.77-2.43,28.25,28.25,0,0,1,2.65-1.74c.52-.31,1.06-.6,1.61-.88-1.36,2.24-.86,4.64,6.84,5.08,15.07.88-4,15.29-4,15.29S302.67,361.66,300,365.78Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.53,361.8c-2.26-.26-3.38-2.58-2.5-5.2s3.42-4.53,5.68-4.27,3.39,2.57,2.51,5.19S303.79,362.05,301.53,361.8Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.37,373.8c.74-5.6,25.2-21.09,25.2-21.09s5.43-2.18,3.63-6a29.39,29.39,0,0,1,2.61,1.69q.85.61,1.59,1.26c7.28,6.31,7.29,14.59,0,20.91-.49.42-1,.85-1.59,1.26a28.06,28.06,0,0,1-2.42,1.57c-.83.49-1.7.94-2.6,1.36-.71.34-1.45.66-2.2.95s-1.51.57-2.29.83a48.9,48.9,0,0,1-7.3,1.75l-1.64.24a57.24,57.24,0,0,1-7.3.46,55.18,55.18,0,0,1-8.93-.74S326.07,377.48,325.37,373.8Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.37,373.8c.74-5.6,25.2-21.09,25.2-21.09s5.43-2.18,3.63-6a29.39,29.39,0,0,1,2.61,1.69q.85.61,1.59,1.26c7.28,6.31,7.29,14.59,0,20.91-.49.42-1,.85-1.59,1.26a28.06,28.06,0,0,1-2.42,1.57c-.83.49-1.7.94-2.6,1.36-.71.34-1.45.66-2.2.95s-1.51.57-2.29.83a48.9,48.9,0,0,1-7.3,1.75l-1.64.24a57.24,57.24,0,0,1-7.3.46,55.18,55.18,0,0,1-8.93-.74S326.07,377.48,325.37,373.8Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.42,350.2c9.13,5.27,9.5,13.67,1.12,19.2-.36.23-.73.46-1.12.69-9.51,5.49-24.93,5.49-34.44,0s-9.52-14.4,0-19.89c.39-.23.79-.44,1.2-.65C324.74,344.71,339.3,344.93,348.42,350.2Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.42,350.2c9.13,5.27,9.5,13.67,1.12,19.2-.36.23-.73.46-1.12.69-9.51,5.49-24.93,5.49-34.44,0s-9.52-14.4,0-19.89c.39-.23.79-.44,1.2-.65C324.74,344.71,339.3,344.93,348.42,350.2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 331.19,
    cy: 360.14,
    rx: 23.28,
    ry: 13.44,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 331.19,
    cy: 360.14,
    rx: 23.28,
    ry: 13.44,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.65,354.39c-9.09-5.25-23.84-5.25-32.93,0-3.72,2.14-5.91,4.84-6.59,7.63.68,2.79,2.87,5.48,6.59,7.63,9.09,5.25,23.84,5.25,32.93,0,3.72-2.15,5.91-4.84,6.59-7.63C353.56,359.23,351.37,356.53,347.65,354.39Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.65,354.39c-9.09-5.25-23.84-5.25-32.93,0-3.72,2.14-5.91,4.84-6.59,7.63.68,2.79,2.87,5.48,6.59,7.63,9.09,5.25,23.84,5.25,32.93,0,3.72-2.15,5.91-4.84,6.59-7.63C353.56,359.23,351.37,356.53,347.65,354.39Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.85,361.4a5.24,5.24,0,0,0-1.45-3.34l-5.59,1.83v2.76l.2.28a6.58,6.58,0,0,1-1.82,1.44,10.58,10.58,0,0,1-3,1.2l1.54-.89v-2.77l-4.11-2.37-1.86,1.07v-2.14l-3.05-1.77a14.41,14.41,0,0,1,2.88.69l3.21-3.21v-2.76a18,18,0,0,0-15.85,1.4c-3,1.7-4.49,3.5-4.49,5.41V361a4.44,4.44,0,0,0,.73,2.34l-.16.09v2.77l4.09,2.35,1.21-.7.61.35v1.44L326,372l1.89-1.09a20.3,20.3,0,0,0,16.69-1.39c3.1-1.78,4.27-3.65,4.25-5.39C348.84,363.67,348.85,361.85,348.85,361.4Zm-26.4-1.71a4.32,4.32,0,0,1-.35-.42,6.55,6.55,0,0,1,1.76-1.37,9.17,9.17,0,0,1,3.84-1.24Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.19,364.37a9.24,9.24,0,0,1-7.49,1l6-3.47-4.11-2.37-6.68,3.85c-.47-.23-.94-.5-1.45-.8l-.44-.25,6.71-3.87-4.08-2.36-6.2,3.58c-1.52-1.65-1.15-3.07,1.41-4.55,3.21-1.85,6.11-1.39,8.7-.51l3.21-3.21a18,18,0,0,0-15.85,1.4c-5,2.9-5.94,6.07-2.2,9.6l-1.72,1,4.09,2.36,1.21-.7.88.5,1,.57-1.24.72,4.11,2.37,1.89-1.09a20.26,20.26,0,0,0,16.69-1.38c5.2-3,5-6.21,2.8-8.7l-5.59,1.83C343.36,361.83,342.18,363.22,340.19,364.37Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.19,364.37a9.24,9.24,0,0,1-7.49,1l6-3.47-4.11-2.37-6.68,3.85c-.47-.23-.94-.5-1.45-.8l-.44-.25,6.71-3.87-4.08-2.36-6.2,3.58c-1.52-1.65-1.15-3.07,1.41-4.55,3.21-1.85,6.11-1.39,8.7-.51l3.21-3.21a18,18,0,0,0-15.85,1.4c-5,2.9-5.94,6.07-2.2,9.6l-1.72,1,4.09,2.36,1.21-.7.88.5,1,.57-1.24.72,4.11,2.37,1.89-1.09a20.26,20.26,0,0,0,16.69-1.38c5.2-3,5-6.21,2.8-8.7l-5.59,1.83C343.36,361.83,342.18,363.22,340.19,364.37Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.7 365.38 337.79 361.92 334.59 359.54 338.7 361.91 332.7 365.38",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.02 362.34 331.86 358.49 328.65 356.11 332.73 358.47 326.02 362.34",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.57,353.68c8.71-5.28,16.06-2,16.06-2l-2.07,3,3.21-3.21a18,18,0,0,0-15.85,1.4A15,15,0,0,0,318.57,353.68Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.81,359.89c1.55,1.94.37,3.33-1.62,4.48a9.24,9.24,0,0,1-7.49,1,9.32,9.32,0,0,0,8.47-1.13c3.32-2.21,1.57-4.26,1.57-4.26l4.66-1.93Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.08 365.77 316.67 363.41 317.73 362.42 316 363.41 320.08 365.77",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.02 369.23 321.91 366.86 323.15 366.14 322.49 366.89 326.02 369.23",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.71,349.21a22.8,22.8,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.74,0a22.8,22.8,0,0,1,8.4,7.77h1.9v7.19h0c-.25,5-3.67,10-10.28,13.76-13.73,7.93-36,7.93-49.74,0-6.61-3.81-10.05-8.76-10.3-13.76h0v-7.19Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.71,349.21a22.8,22.8,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.74,0a22.8,22.8,0,0,1,8.4,7.77h1.9v7.19h0c-.25,5-3.67,10-10.28,13.76-13.73,7.93-36,7.93-49.74,0-6.61-3.81-10.05-8.76-10.3-13.76h0v-7.19Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,335.5c9,0,18,2,24.87,5.94a22.8,22.8,0,0,1,8.4,7.77h1.9v7.19h0c-.25,5-3.67,10-10.28,13.76-6.87,4-15.87,5.95-24.87,5.95Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.19,338.79a39.73,39.73,0,0,1,5.66,2.65,22.8,22.8,0,0,1,8.4,7.77h1.9v7.19h0c-.25,5-3.67,10-10.28,13.76a37.66,37.66,0,0,1-5.66,2.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.77,338.79a39.73,39.73,0,0,0-5.66,2.65,22.8,22.8,0,0,0-8.4,7.77h-1.9v7.19h0c.25,5,3.69,10,10.3,13.76a37.66,37.66,0,0,0,5.66,2.65Z",
    style: {
      fill: "#1E75FE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.85,334.86c13.74,7.93,13.74,20.79,0,28.72-12,6.94-30.57,7.8-44.22,2.6h0l-.55-.21a38.65,38.65,0,0,1-5-2.39c-11.46-6.62-13.36-16.66-5.71-24.41h0a26.58,26.58,0,0,1,5.7-4.31C316.84,326.93,339.12,326.93,352.85,334.86Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.85,334.86c13.74,7.93,13.74,20.79,0,28.72-12,6.94-30.57,7.8-44.22,2.6h0l-.55-.21a38.65,38.65,0,0,1-5-2.39c-11.46-6.62-13.36-16.66-5.71-24.41h0a26.58,26.58,0,0,1,5.7-4.31C316.84,326.93,339.12,326.93,352.85,334.86Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.4,339.17a15.43,15.43,0,0,0-3.68,12.53c1.22,7,11,12.86,14.36,14.27a38.65,38.65,0,0,1-5-2.39C291.65,357,289.75,346.92,297.4,339.17Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.56,359.26a15.36,15.36,0,0,0,3.68-12.53c-1.22-7-11-12.85-14.36-14.26a37.37,37.37,0,0,1,5,2.39C364.31,341.47,366.21,351.51,358.56,359.26Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 327.99,
    cy: 349.19,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 327.99,
    cy: 349.19,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.78,354.83c-2.63-4.86-1.77-10.22,2.57-14.76a21.44,21.44,0,0,1,2.77-2.42,27,27,0,0,1,2.65-1.75c.52-.3,1.05-.59,1.61-.87-1.36,2.24-.86,4.63,6.84,5.08,15.07.88-4,15.28-4,15.28S299.48,350.7,296.78,354.83Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.34,350.84c-2.26-.25-3.39-2.58-2.51-5.19s3.43-4.53,5.69-4.28,3.38,2.58,2.5,5.2S300.6,351.1,298.34,350.84Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.17,362.85c.75-5.6,25.21-21.09,25.21-21.09s5.42-2.18,3.62-6a27.49,27.49,0,0,1,2.62,1.69q.84.61,1.59,1.26c7.28,6.3,7.29,14.59,0,20.9-.49.43-1,.85-1.58,1.26a28.31,28.31,0,0,1-2.43,1.58c-.83.49-1.69.94-2.59,1.36-.71.33-1.45.65-2.2,1s-1.52.57-2.3.82a47.3,47.3,0,0,1-7.29,1.76l-1.65.23a56.3,56.3,0,0,1-16.22-.27S322.87,366.53,322.17,362.85Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.17,362.85c.75-5.6,25.21-21.09,25.21-21.09s5.42-2.18,3.62-6a27.49,27.49,0,0,1,2.62,1.69q.84.61,1.59,1.26c7.28,6.3,7.29,14.59,0,20.9-.49.43-1,.85-1.58,1.26a28.31,28.31,0,0,1-2.43,1.58c-.83.49-1.69.94-2.59,1.36-.71.33-1.45.65-2.2,1s-1.52.57-2.3.82a47.3,47.3,0,0,1-7.29,1.76l-1.65.23a56.3,56.3,0,0,1-16.22-.27S322.87,366.53,322.17,362.85Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.23,339.24c9.12,5.27,9.49,13.68,1.11,19.2-.35.24-.73.47-1.11.69-9.52,5.5-24.94,5.5-34.45,0s-9.52-14.39,0-19.89c.39-.22.79-.43,1.19-.64C321.54,333.76,336.1,334,345.23,339.24Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.23,339.24c9.12,5.27,9.49,13.68,1.11,19.2-.35.24-.73.47-1.11.69-9.52,5.5-24.94,5.5-34.45,0s-9.52-14.39,0-19.89c.39-.22.79-.43,1.19-.64C321.54,333.76,336.1,334,345.23,339.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 327.99,
    cy: 349.19,
    rx: 23.28,
    ry: 13.44,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 327.99,
    cy: 349.19,
    rx: 23.28,
    ry: 13.44,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.46,343.43c-9.1-5.25-23.84-5.25-32.93,0-3.72,2.15-5.92,4.84-6.59,7.63.67,2.79,2.87,5.49,6.59,7.63,9.09,5.25,23.83,5.25,32.93,0,3.71-2.14,5.91-4.84,6.59-7.63C350.37,348.27,348.17,345.58,344.46,343.43Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.46,343.43c-9.1-5.25-23.84-5.25-32.93,0-3.72,2.15-5.92,4.84-6.59,7.63.67,2.79,2.87,5.49,6.59,7.63,9.09,5.25,23.83,5.25,32.93,0,3.71-2.14,5.91-4.84,6.59-7.63C350.37,348.27,348.17,345.58,344.46,343.43Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.65,350.45a5.2,5.2,0,0,0-1.44-3.35l-5.6,1.83v2.77a2.34,2.34,0,0,1,.2.27,6.4,6.4,0,0,1-1.82,1.44,9.93,9.93,0,0,1-3,1.2l1.55-.89V351l-4.12-2.38-1.85,1.07v-2.14l-3.06-1.76a14.51,14.51,0,0,1,2.89.69l3.2-3.21v-2.77a18,18,0,0,0-15.85,1.4c-3,1.71-4.48,3.51-4.48,5.42V350a4.47,4.47,0,0,0,.73,2.34l-.16.09v2.76l4.08,2.36,1.22-.7.6.35v1.44l4.12,2.37,1.89-1.09a20.26,20.26,0,0,0,16.69-1.38c3.1-1.79,4.26-3.65,4.24-5.39C345.65,352.72,345.66,350.9,345.65,350.45Zm-26.4-1.71a4.18,4.18,0,0,1-.34-.42,6.4,6.4,0,0,1,1.76-1.37,9,9,0,0,1,3.83-1.24Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,353.41a9.18,9.18,0,0,1-7.48,1l6-3.46-4.12-2.38-6.67,3.86c-.48-.24-1-.51-1.45-.8l-.44-.25,6.71-3.88-4.08-2.35-6.21,3.58c-1.52-1.66-1.14-3.08,1.42-4.56,3.2-1.85,6.1-1.38,8.7-.5l3.2-3.22a18,18,0,0,0-15.85,1.4c-5,2.91-5.93,6.08-2.19,9.61l-1.72,1,4.08,2.35,1.22-.7.87.51,1,.56-1.25.72,4.12,2.38,1.89-1.09a20.3,20.3,0,0,0,16.69-1.38c5.2-3,5-6.21,2.8-8.71l-5.6,1.83C340.16,350.88,339,352.26,337,353.41Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,353.41a9.18,9.18,0,0,1-7.48,1l6-3.46-4.12-2.38-6.67,3.86c-.48-.24-1-.51-1.45-.8l-.44-.25,6.71-3.88-4.08-2.35-6.21,3.58c-1.52-1.66-1.14-3.08,1.42-4.56,3.2-1.85,6.1-1.38,8.7-.5l3.2-3.22a18,18,0,0,0-15.85,1.4c-5,2.91-5.93,6.08-2.19,9.61l-1.72,1,4.08,2.35,1.22-.7.87.51,1,.56-1.25.72,4.12,2.38,1.89-1.09a20.3,20.3,0,0,0,16.69-1.38c5.2-3,5-6.21,2.8-8.71l-5.6,1.83C340.16,350.88,339,352.26,337,353.41Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.5 354.43 334.6 350.96 331.39 348.58 335.51 350.96 329.5 354.43",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.83 351.39 328.67 347.54 325.46 345.16 329.54 347.51 322.83 351.39",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.38,342.73c8.7-5.28,16.05-2,16.05-2l-2.06,3,3.2-3.22a18,18,0,0,0-15.85,1.4C316.23,342.15,315.79,342.44,315.38,342.73Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.61,348.93c1.55,1.95.37,3.33-1.62,4.48a9.18,9.18,0,0,1-7.48,1,9.24,9.24,0,0,0,8.46-1.13c3.33-2.2,1.58-4.25,1.58-4.25l4.66-1.94Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.89 354.81 313.47 352.45 314.53 351.46 312.81 352.46 316.89 354.81",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.83 358.28 318.71 355.9 319.96 355.18 319.29 355.94 322.83 358.28",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.25,339.09a22.84,22.84,0,0,1,8.41-7.77c13.73-7.93,36-7.93,49.74,0a22.8,22.8,0,0,1,8.4,7.77h1.9v7.19h0c-.26,5-3.68,10-10.28,13.76-13.74,7.93-36,7.93-49.74,0-6.61-3.81-10.05-8.76-10.31-13.76h0v-7.19Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.25,339.09a22.84,22.84,0,0,1,8.41-7.77c13.73-7.93,36-7.93,49.74,0a22.8,22.8,0,0,1,8.4,7.77h1.9v7.19h0c-.26,5-3.68,10-10.28,13.76-13.74,7.93-36,7.93-49.74,0-6.61-3.81-10.05-8.76-10.31-13.76h0v-7.19Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.52,325.38c9,0,18,2,24.88,5.94a22.8,22.8,0,0,1,8.4,7.77h1.9v7.19h0c-.26,5-3.68,10-10.28,13.76-6.87,4-15.87,5.95-24.88,5.95Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.74,328.67a39.73,39.73,0,0,1,5.66,2.65,22.8,22.8,0,0,1,8.4,7.77h1.9v7.19h0c-.26,5-3.68,10-10.28,13.76a37.66,37.66,0,0,1-5.66,2.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.32,328.67a38.73,38.73,0,0,0-5.66,2.65,22.84,22.84,0,0,0-8.41,7.77h-1.9v7.19h0c.26,5,3.7,10,10.31,13.76a36.76,36.76,0,0,0,5.66,2.65Z",
    style: {
      fill: "#1E75FE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.4,324.74c13.73,7.93,13.73,20.79,0,28.72-12,6.93-30.57,7.8-44.23,2.6h0l-.54-.21a38,38,0,0,1-5-2.39c-11.46-6.62-13.36-16.66-5.71-24.41h0a26.65,26.65,0,0,1,5.71-4.31C322.39,316.81,344.66,316.81,358.4,324.74Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.4,324.74c13.73,7.93,13.73,20.79,0,28.72-12,6.93-30.57,7.8-44.23,2.6h0l-.54-.21a38,38,0,0,1-5-2.39c-11.46-6.62-13.36-16.66-5.71-24.41h0a26.65,26.65,0,0,1,5.71-4.31C322.39,316.81,344.66,316.81,358.4,324.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,329.05a15.39,15.39,0,0,0-3.68,12.53c1.22,7,11,12.86,14.36,14.27a38,38,0,0,1-5-2.39C297.2,346.84,295.3,336.8,303,329.05Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.1,349.14a15.32,15.32,0,0,0,3.68-12.53c-1.21-7-11-12.85-14.35-14.26a38,38,0,0,1,5,2.39C369.85,331.35,371.76,341.39,364.1,349.14Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 333.54,
    cy: 339.07,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 333.54,
    cy: 339.07,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.33,344.71c-2.63-4.86-1.77-10.22,2.57-14.76a20.79,20.79,0,0,1,2.77-2.42,26.86,26.86,0,0,1,2.64-1.75c.52-.3,1.06-.59,1.61-.87-1.36,2.23-.86,4.63,6.84,5.08,15.07.88-4,15.28-4,15.28S305,340.58,302.33,344.71Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.88,340.72c-2.26-.25-3.38-2.58-2.5-5.19s3.42-4.53,5.69-4.28,3.38,2.58,2.5,5.2S306.14,341,303.88,340.72Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.72,352.73c.74-5.6,25.2-21.09,25.2-21.09s5.43-2.18,3.63-6a27.31,27.31,0,0,1,2.61,1.69q.85.61,1.59,1.26c7.29,6.3,7.3,14.59,0,20.9q-.74.64-1.59,1.26a28.1,28.1,0,0,1-2.42,1.58c-.83.48-1.7.94-2.59,1.36-.72.33-1.46.65-2.21.95s-1.51.57-2.29.82a47.43,47.43,0,0,1-7.3,1.76l-1.64.23a56.36,56.36,0,0,1-16.23-.27S328.42,356.41,327.72,352.73Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.72,352.73c.74-5.6,25.2-21.09,25.2-21.09s5.43-2.18,3.63-6a27.31,27.31,0,0,1,2.61,1.69q.85.61,1.59,1.26c7.29,6.3,7.3,14.59,0,20.9q-.74.64-1.59,1.26a28.1,28.1,0,0,1-2.42,1.58c-.83.48-1.7.94-2.59,1.36-.72.33-1.46.65-2.21.95s-1.51.57-2.29.82a47.43,47.43,0,0,1-7.3,1.76l-1.64.23a56.36,56.36,0,0,1-16.23-.27S328.42,356.41,327.72,352.73Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.78,329.12c9.12,5.27,9.49,13.68,1.11,19.2-.36.24-.73.47-1.12.69-9.51,5.49-24.93,5.49-34.44,0s-9.52-14.39,0-19.89c.39-.22.79-.44,1.2-.64C327.09,323.64,341.65,323.86,350.78,329.12Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.78,329.12c9.12,5.27,9.49,13.68,1.11,19.2-.36.24-.73.47-1.12.69-9.51,5.49-24.93,5.49-34.44,0s-9.52-14.39,0-19.89c.39-.22.79-.44,1.2-.64C327.09,323.64,341.65,323.86,350.78,329.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,329.56c9.1,5.25,9.1,13.76,0,19s-23.83,5.25-32.93,0-9.09-13.76,0-19S340.91,324.31,350,329.56Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,329.56c9.1,5.25,9.1,13.76,0,19s-23.83,5.25-32.93,0-9.09-13.76,0-19S340.91,324.31,350,329.56Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,333.31c-9.09-5.25-23.83-5.25-32.93,0-3.71,2.15-5.91,4.84-6.59,7.63.68,2.79,2.88,5.49,6.59,7.63,9.1,5.25,23.84,5.25,32.93,0,3.72-2.14,5.92-4.84,6.59-7.63C355.92,338.15,353.72,335.46,350,333.31Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,333.31c-9.09-5.25-23.83-5.25-32.93,0-3.71,2.15-5.91,4.84-6.59,7.63.68,2.79,2.88,5.49,6.59,7.63,9.1,5.25,23.84,5.25,32.93,0,3.72-2.14,5.92-4.84,6.59-7.63C355.92,338.15,353.72,335.46,350,333.31Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.2,340.33a5.2,5.2,0,0,0-1.44-3.35l-5.6,1.83v2.77l.2.27a6.4,6.4,0,0,1-1.82,1.44,9.93,9.93,0,0,1-3,1.2l1.55-.89v-2.76l-4.12-2.38-1.85,1.07v-2.14L332,335.63a14.67,14.67,0,0,1,2.89.69l3.2-3.21v-2.77a18,18,0,0,0-15.85,1.4c-2.95,1.71-4.48,3.51-4.49,5.42,0,.46,0,2.29,0,2.75a4.47,4.47,0,0,0,.73,2.34l-.15.09v2.76l4.08,2.36,1.21-.7.61.35v1.44l4.11,2.37,1.89-1.09a20.28,20.28,0,0,0,16.7-1.38c3.09-1.79,4.26-3.65,4.24-5.39C351.19,342.6,351.2,340.78,351.2,340.33Zm-26.4-1.71c-.13-.14-.24-.29-.35-.42a6.43,6.43,0,0,1,1.77-1.37,9,9,0,0,1,3.83-1.24Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.54,343.29a9.2,9.2,0,0,1-7.49,1l6-3.46-4.12-2.38-6.68,3.86c-.47-.24-.94-.51-1.45-.8l-.44-.25,6.72-3.88L331,335l-6.2,3.58c-1.52-1.66-1.15-3.08,1.42-4.56,3.2-1.85,6.1-1.38,8.7-.5l3.2-3.22a18,18,0,0,0-15.85,1.4c-5,2.91-5.94,6.08-2.19,9.6l-1.72,1,4.08,2.35,1.21-.7.88.51,1,.56-1.25.72,4.11,2.38,1.89-1.09a20.32,20.32,0,0,0,16.7-1.38c5.19-3,5-6.22,2.8-8.71l-5.6,1.83C345.71,340.76,344.53,342.14,342.54,343.29Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.54,343.29a9.2,9.2,0,0,1-7.49,1l6-3.46-4.12-2.38-6.68,3.86c-.47-.24-.94-.51-1.45-.8l-.44-.25,6.72-3.88L331,335l-6.2,3.58c-1.52-1.66-1.15-3.08,1.42-4.56,3.2-1.85,6.1-1.38,8.7-.5l3.2-3.22a18,18,0,0,0-15.85,1.4c-5,2.91-5.94,6.08-2.19,9.6l-1.72,1,4.08,2.35,1.21-.7.88.51,1,.56-1.25.72,4.11,2.38,1.89-1.09a20.32,20.32,0,0,0,16.7-1.38c5.19-3,5-6.22,2.8-8.71l-5.6,1.83C345.71,340.76,344.53,342.14,342.54,343.29Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.05 344.3 340.15 340.84 336.94 338.46 341.06 340.84 335.05 344.3",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.37 341.27 334.21 337.42 331 335.04 335.09 337.39 328.37 341.27",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.92,332.61c8.71-5.28,16.06-2,16.06-2l-2.06,3,3.2-3.22a18,18,0,0,0-15.85,1.4C321.78,332,321.34,332.32,320.92,332.61Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.16,338.81c1.55,1.95.37,3.33-1.62,4.48a9.2,9.2,0,0,1-7.49,1,9.26,9.26,0,0,0,8.47-1.13c3.32-2.2,1.58-4.25,1.58-4.25l4.66-1.94Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.44 344.69 319.02 342.33 320.08 341.34 318.36 342.34 322.44 344.69",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.37 348.16 324.26 345.78 325.51 345.06 324.84 345.82 328.37 348.16",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.11,330.77a22.76,22.76,0,0,1,8.41-7.77c13.73-7.93,36-7.93,49.74,0a22.72,22.72,0,0,1,8.4,7.77h1.9V338h0c-.26,5-3.68,10-10.28,13.76-13.74,7.93-36,7.93-49.74,0-6.61-3.81-10-8.76-10.31-13.76h0v-7.19Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.11,330.77a22.76,22.76,0,0,1,8.41-7.77c13.73-7.93,36-7.93,49.74,0a22.72,22.72,0,0,1,8.4,7.77h1.9V338h0c-.26,5-3.68,10-10.28,13.76-13.74,7.93-36,7.93-49.74,0-6.61-3.81-10-8.76-10.31-13.76h0v-7.19Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.39,317.06c9,0,18,2,24.87,5.94a22.72,22.72,0,0,1,8.4,7.77h1.9V338h0c-.26,5-3.68,10-10.28,13.76-6.87,4-15.87,5.95-24.87,5.95Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.6,320.35a39.73,39.73,0,0,1,5.66,2.65,22.72,22.72,0,0,1,8.4,7.77h1.9V338h0c-.26,5-3.68,10-10.28,13.76a37.66,37.66,0,0,1-5.66,2.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.18,320.35a39.22,39.22,0,0,0-5.66,2.65,22.76,22.76,0,0,0-8.41,7.77h-1.9V338h0c.26,5,3.7,10,10.31,13.76a37.2,37.2,0,0,0,5.66,2.65Z",
    style: {
      fill: "#1E75FE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.26,316.42c13.74,7.93,13.73,20.79,0,28.72-12,6.93-30.57,7.8-44.22,2.6h0l-.54-.21a39.35,39.35,0,0,1-5-2.39c-11.46-6.62-13.36-16.66-5.71-24.41h0a26.65,26.65,0,0,1,5.71-4.31C316.25,308.49,338.52,308.49,352.26,316.42Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.26,316.42c13.74,7.93,13.73,20.79,0,28.72-12,6.93-30.57,7.8-44.22,2.6h0l-.54-.21a39.35,39.35,0,0,1-5-2.39c-11.46-6.62-13.36-16.66-5.71-24.41h0a26.65,26.65,0,0,1,5.71-4.31C316.25,308.49,338.52,308.49,352.26,316.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.81,320.73a15.39,15.39,0,0,0-3.68,12.53c1.22,7,11,12.85,14.36,14.27a39.35,39.35,0,0,1-5-2.39C291.06,338.52,289.16,328.48,296.81,320.73Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,340.82a15.32,15.32,0,0,0,3.68-12.53c-1.21-7-11-12.85-14.35-14.26a38,38,0,0,1,5,2.39C363.71,323,365.62,333.07,358,340.82Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 327.4,
    cy: 330.75,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 327.4,
    cy: 330.75,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.19,336.39c-2.63-4.86-1.77-10.22,2.57-14.76a20.79,20.79,0,0,1,2.77-2.42,26.86,26.86,0,0,1,2.64-1.75c.53-.3,1.06-.6,1.61-.87-1.36,2.23-.86,4.63,6.84,5.08,15.07.88-4,15.28-4,15.28S298.88,332.26,296.19,336.39Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.74,332.4c-2.26-.25-3.38-2.58-2.5-5.19s3.43-4.53,5.69-4.28,3.38,2.58,2.5,5.2S300,332.66,297.74,332.4Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.58,344.41c.74-5.6,25.21-21.09,25.21-21.09s5.42-2.18,3.62-6A27.31,27.31,0,0,1,353,319q.86.61,1.59,1.26c7.29,6.3,7.3,14.59,0,20.9q-.74.65-1.59,1.26A28.1,28.1,0,0,1,350.6,344c-.83.48-1.7.94-2.59,1.36-.72.33-1.46.65-2.21,1s-1.51.57-2.29.82a47.43,47.43,0,0,1-7.3,1.76l-1.64.23a56.29,56.29,0,0,1-16.22-.27S322.28,348.09,321.58,344.41Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.58,344.41c.74-5.6,25.21-21.09,25.21-21.09s5.42-2.18,3.62-6A27.31,27.31,0,0,1,353,319q.86.61,1.59,1.26c7.29,6.3,7.3,14.59,0,20.9q-.74.65-1.59,1.26A28.1,28.1,0,0,1,350.6,344c-.83.48-1.7.94-2.59,1.36-.72.33-1.46.65-2.21,1s-1.51.57-2.29.82a47.43,47.43,0,0,1-7.3,1.76l-1.64.23a56.29,56.29,0,0,1-16.22-.27S322.28,348.09,321.58,344.41Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.64,320.8c9.12,5.27,9.49,13.68,1.11,19.2-.36.24-.73.47-1.12.69-9.51,5.49-24.93,5.49-34.44,0s-9.52-14.39,0-19.89c.39-.22.79-.44,1.2-.64C321,315.32,335.51,315.54,344.64,320.8Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.64,320.8c9.12,5.27,9.49,13.68,1.11,19.2-.36.24-.73.47-1.12.69-9.51,5.49-24.93,5.49-34.44,0s-9.52-14.39,0-19.89c.39-.22.79-.44,1.2-.64C321,315.32,335.51,315.54,344.64,320.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.86,321.24c9.1,5.25,9.1,13.76,0,19s-23.83,5.25-32.93,0-9.09-13.76,0-19S334.77,316,343.86,321.24Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.86,321.24c9.1,5.25,9.1,13.76,0,19s-23.83,5.25-32.93,0-9.09-13.76,0-19S334.77,316,343.86,321.24Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.86,325c-9.09-5.25-23.83-5.25-32.93,0-3.71,2.15-5.91,4.84-6.59,7.63.68,2.79,2.88,5.49,6.59,7.63,9.1,5.25,23.84,5.25,32.93,0,3.72-2.14,5.92-4.84,6.59-7.63C349.78,329.83,347.58,327.14,343.86,325Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.86,325c-9.09-5.25-23.83-5.25-32.93,0-3.71,2.15-5.91,4.84-6.59,7.63.68,2.79,2.88,5.49,6.59,7.63,9.1,5.25,23.84,5.25,32.93,0,3.72-2.14,5.92-4.84,6.59-7.63C349.78,329.83,347.58,327.14,343.86,325Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.06,332a5.2,5.2,0,0,0-1.44-3.35l-5.6,1.83v2.77l.2.27A6.4,6.4,0,0,1,336.4,335a9.93,9.93,0,0,1-3,1.2l1.55-.89v-2.76l-4.12-2.38L329,331.21v-2.14l-3.06-1.76a14.67,14.67,0,0,1,2.89.69l3.2-3.21V322a18,18,0,0,0-15.85,1.4c-2.95,1.71-4.48,3.51-4.48,5.42v2.75a4.36,4.36,0,0,0,.72,2.34l-.15.09v2.76l4.08,2.36,1.21-.7.61.35v1.44l4.11,2.37,1.89-1.09a20.28,20.28,0,0,0,16.7-1.38c3.09-1.79,4.26-3.65,4.24-5.39Zm-26.4-1.71c-.13-.14-.24-.29-.35-.42a6.63,6.63,0,0,1,1.77-1.38,9.11,9.11,0,0,1,3.83-1.23Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.4,335a9.24,9.24,0,0,1-7.49,1l6-3.46-4.12-2.38L324.12,334c-.47-.24-.94-.51-1.45-.8l-.44-.25,6.72-3.88-4.08-2.35-6.21,3.58c-1.52-1.66-1.15-3.08,1.42-4.56,3.2-1.85,6.1-1.38,8.7-.5L332,322a18,18,0,0,0-15.85,1.4c-5,2.91-5.94,6.08-2.19,9.6l-1.72,1,4.08,2.35,1.21-.7.88.51,1,.56-1.25.72,4.11,2.38,1.89-1.09a20.32,20.32,0,0,0,16.7-1.38c5.19-3,5-6.22,2.8-8.71l-5.6,1.83C339.57,332.44,338.39,333.82,336.4,335Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.4,335a9.24,9.24,0,0,1-7.49,1l6-3.46-4.12-2.38L324.12,334c-.47-.24-.94-.51-1.45-.8l-.44-.25,6.72-3.88-4.08-2.35-6.21,3.58c-1.52-1.66-1.15-3.08,1.42-4.56,3.2-1.85,6.1-1.38,8.7-.5L332,322a18,18,0,0,0-15.85,1.4c-5,2.91-5.94,6.08-2.19,9.6l-1.72,1,4.08,2.35,1.21-.7.88.51,1,.56-1.25.72,4.11,2.38,1.89-1.09a20.32,20.32,0,0,0,16.7-1.38c5.19-3,5-6.22,2.8-8.71l-5.6,1.83C339.57,332.44,338.39,333.82,336.4,335Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.91 335.98 334.01 332.52 330.8 330.14 334.92 332.52 328.91 335.98",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.24 332.95 328.07 329.1 324.87 326.71 328.95 329.07 322.24 332.95",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.78,324.29c8.71-5.28,16.06-2,16.06-2l-2.06,3L332,322a18,18,0,0,0-15.85,1.4C315.64,323.71,315.2,324,314.78,324.29Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,330.49c1.55,1.95.37,3.33-1.62,4.48a9.24,9.24,0,0,1-7.49,1,9.26,9.26,0,0,0,8.47-1.13c3.32-2.2,1.58-4.25,1.58-4.25l4.66-1.94Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.3 336.37 312.88 334.01 313.94 333.02 312.22 334.02 316.3 336.37",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.23 339.84 318.12 337.46 319.37 336.74 318.7 337.5 322.23 339.84",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,319.75a22.64,22.64,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.74,0a22.64,22.64,0,0,1,8.4,7.77h1.9v7.18h0c-.25,5-3.67,9.95-10.28,13.77-13.73,7.93-36,7.93-49.74,0-6.61-3.82-10.05-8.77-10.3-13.77h0v-7.18Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,319.75a22.64,22.64,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.74,0a22.64,22.64,0,0,1,8.4,7.77h1.9v7.18h0c-.25,5-3.67,9.95-10.28,13.77-13.73,7.93-36,7.93-49.74,0-6.61-3.82-10.05-8.77-10.3-13.77h0v-7.18Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.23,306c9,0,18,2,24.87,6a22.64,22.64,0,0,1,8.4,7.77h1.9v7.18h0c-.25,5-3.67,9.95-10.28,13.77-6.87,4-15.87,5.94-24.87,5.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.44,309.33A37.66,37.66,0,0,1,359.1,312a22.64,22.64,0,0,1,8.4,7.77h1.9v7.18h0c-.25,5-3.67,9.95-10.28,13.77a39.73,39.73,0,0,1-5.66,2.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,309.33a37.66,37.66,0,0,0-5.66,2.65,22.64,22.64,0,0,0-8.4,7.77h-1.9v7.18h0c.25,5,3.7,9.95,10.3,13.77a39.73,39.73,0,0,0,5.66,2.65Z",
    style: {
      fill: "#1E75FE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.1,305.39c13.74,7.93,13.74,20.79,0,28.72-12,6.94-30.57,7.81-44.22,2.6h0l-.55-.21a38.65,38.65,0,0,1-5-2.39c-11.45-6.61-13.36-16.65-5.71-24.4h0a26.91,26.91,0,0,1,5.7-4.31C323.09,297.46,345.37,297.46,359.1,305.39Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.1,305.39c13.74,7.93,13.74,20.79,0,28.72-12,6.94-30.57,7.81-44.22,2.6h0l-.55-.21a38.65,38.65,0,0,1-5-2.39c-11.45-6.61-13.36-16.65-5.71-24.4h0a26.91,26.91,0,0,1,5.7-4.31C323.09,297.46,345.37,297.46,359.1,305.39Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.65,309.71A15.38,15.38,0,0,0,300,322.23c1.22,7,11,12.86,14.36,14.27a38.65,38.65,0,0,1-5-2.39C297.91,327.5,296,317.46,303.65,309.71Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.81,329.8a15.39,15.39,0,0,0,3.68-12.53c-1.22-7-11-12.86-14.36-14.27a38.65,38.65,0,0,1,5,2.39C370.56,312,372.46,322,364.81,329.8Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 334.24,
    cy: 319.72,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 334.24,
    cy: 319.72,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,325.36c-2.63-4.86-1.77-10.21,2.57-14.75a22.27,22.27,0,0,1,2.77-2.43,27,27,0,0,1,2.65-1.75c.52-.3,1.05-.59,1.61-.87-1.36,2.24-.86,4.63,6.84,5.08,15.07.88-4,15.28-4,15.28S305.73,321.24,303,325.36Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.59,321.38c-2.26-.26-3.38-2.58-2.51-5.2s3.43-4.53,5.69-4.28,3.38,2.58,2.5,5.2S306.85,321.63,304.59,321.38Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.42,333.38c.75-5.6,25.21-21.09,25.21-21.09s5.42-2.18,3.62-6a29.59,29.59,0,0,1,2.62,1.69q.84.62,1.59,1.26c7.28,6.31,7.29,14.59,0,20.9-.49.43-1,.85-1.58,1.26a26.1,26.1,0,0,1-2.43,1.58c-.83.49-1.69.94-2.59,1.36-.71.34-1.45.65-2.2.95s-1.52.57-2.3.83a48.48,48.48,0,0,1-7.29,1.75q-.82.14-1.65.24a57,57,0,0,1-7.29.46,55.09,55.09,0,0,1-8.93-.74S329.12,337.06,328.42,333.38Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.42,333.38c.75-5.6,25.21-21.09,25.21-21.09s5.42-2.18,3.62-6a29.59,29.59,0,0,1,2.62,1.69q.84.62,1.59,1.26c7.28,6.31,7.29,14.59,0,20.9-.49.43-1,.85-1.58,1.26a26.1,26.1,0,0,1-2.43,1.58c-.83.49-1.69.94-2.59,1.36-.71.34-1.45.65-2.2.95s-1.52.57-2.3.83a48.48,48.48,0,0,1-7.29,1.75q-.82.14-1.65.24a57,57,0,0,1-7.29.46,55.09,55.09,0,0,1-8.93-.74S329.12,337.06,328.42,333.38Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.48,309.78c9.13,5.27,9.5,13.67,1.11,19.2-.35.23-.73.46-1.11.69-9.52,5.49-24.93,5.49-34.45,0s-9.51-14.4,0-19.89c.39-.23.79-.44,1.19-.65C327.79,304.29,342.36,304.51,351.48,309.78Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.48,309.78c9.13,5.27,9.5,13.67,1.11,19.2-.35.23-.73.46-1.11.69-9.52,5.49-24.93,5.49-34.45,0s-9.51-14.4,0-19.89c.39-.23.79-.44,1.19-.65C327.79,304.29,342.36,304.51,351.48,309.78Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 334.24,
    cy: 319.72,
    rx: 23.28,
    ry: 13.44,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 334.24,
    cy: 319.72,
    rx: 23.28,
    ry: 13.44,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.71,314c-9.1-5.25-23.84-5.25-32.93,0-3.72,2.14-5.92,4.83-6.59,7.63.67,2.79,2.87,5.48,6.59,7.63,9.09,5.25,23.83,5.25,32.93,0,3.72-2.15,5.91-4.84,6.59-7.63C356.62,318.8,354.43,316.11,350.71,314Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.71,314c-9.1-5.25-23.84-5.25-32.93,0-3.72,2.14-5.92,4.83-6.59,7.63.67,2.79,2.87,5.48,6.59,7.63,9.09,5.25,23.83,5.25,32.93,0,3.72-2.15,5.91-4.84,6.59-7.63C356.62,318.8,354.43,316.11,350.71,314Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.17 316.17 304.05 309.44 304.94 316.17 316.59 316.68 304.94 317.19 304.05 323.92 303.17 317.19 291.51 316.68 303.17 316.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.91,321a5.24,5.24,0,0,0-1.45-3.34l-5.6,1.83v2.76a1.79,1.79,0,0,1,.2.28,6.24,6.24,0,0,1-1.82,1.43,10.22,10.22,0,0,1-3,1.21l1.55-.9v-2.76l-4.11-2.37-1.86,1.07V318l-3.05-1.76a14.41,14.41,0,0,1,2.88.69l3.21-3.21V311A18,18,0,0,0,323,312.4c-3,1.7-4.48,3.5-4.48,5.41v2.75a4.47,4.47,0,0,0,.73,2.34l-.16.09v2.76l4.08,2.36,1.22-.7.6.35v1.44l4.12,2.38,1.89-1.09a20.3,20.3,0,0,0,16.69-1.39c3.1-1.78,4.26-3.65,4.24-5.39C351.9,323.25,351.91,321.43,351.91,321Zm-26.41-1.71a4.18,4.18,0,0,1-.34-.42,6.4,6.4,0,0,1,1.76-1.37,9.18,9.18,0,0,1,3.83-1.24Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.24,323.94a9.18,9.18,0,0,1-7.48,1l6-3.47-4.11-2.37L331,323c-.48-.23-1-.5-1.45-.8l-.44-.25,6.71-3.88-4.08-2.35-6.21,3.58c-1.51-1.65-1.14-3.08,1.42-4.55,3.2-1.85,6.1-1.39,8.7-.51l3.21-3.21A18,18,0,0,0,323,312.4c-5,2.9-5.93,6.07-2.19,9.6l-1.72,1,4.08,2.36,1.22-.7.87.5,1,.57-1.25.72,4.12,2.37,1.89-1.09a20.26,20.26,0,0,0,16.69-1.38c5.2-3,5-6.21,2.8-8.7l-5.6,1.83C346.41,321.41,345.23,322.8,343.24,323.94Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.24,323.94a9.18,9.18,0,0,1-7.48,1l6-3.47-4.11-2.37L331,323c-.48-.23-1-.5-1.45-.8l-.44-.25,6.71-3.88-4.08-2.35-6.21,3.58c-1.51-1.65-1.14-3.08,1.42-4.55,3.2-1.85,6.1-1.39,8.7-.51l3.21-3.21A18,18,0,0,0,323,312.4c-5,2.9-5.93,6.07-2.19,9.6l-1.72,1,4.08,2.36,1.22-.7.87.5,1,.57-1.25.72,4.12,2.37,1.89-1.09a20.26,20.26,0,0,0,16.69-1.38c5.2-3,5-6.21,2.8-8.7l-5.6,1.83C346.41,321.41,345.23,322.8,343.24,323.94Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.76 324.96 340.85 321.49 337.64 319.12 341.76 321.49 335.76 324.96",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.08 321.92 334.92 318.07 331.71 315.69 335.79 318.05 329.08 321.92",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.63,313.26c8.7-5.28,16.05-2,16.05-2l-2.06,3,3.21-3.21A18,18,0,0,0,323,312.4C322.48,312.68,322,313,321.63,313.26Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.86,319.47c1.55,1.94.37,3.33-1.62,4.47a9.18,9.18,0,0,1-7.48,1,9.3,9.3,0,0,0,8.46-1.13c3.33-2.21,1.58-4.26,1.58-4.26l4.66-1.93Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.14 325.35 319.72 322.99 320.78 322 319.06 322.99 323.14 325.35",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.08 328.81 324.96 326.44 326.21 325.72 325.54 326.47 329.08 328.81",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Dollar--inject-93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129,364.94a22.74,22.74,0,0,1,8.4-7.78c13.74-7.93,36-7.93,49.74,0a22.77,22.77,0,0,1,8.41,7.78h1.9v7.18h0c-.25,5-3.67,9.95-10.28,13.76-13.73,7.93-36,7.93-49.74,0-6.6-3.81-10-8.76-10.3-13.76h0v-7.18Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,364.94a22.74,22.74,0,0,1,8.4-7.78c13.74-7.93,36-7.93,49.74,0a22.77,22.77,0,0,1,8.41,7.78h1.9v7.18h0c-.25,5-3.67,9.95-10.28,13.76-13.73,7.93-36,7.93-49.74,0-6.6-3.81-10-8.76-10.3-13.76h0v-7.18Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.22,351.22c9,0,18,2,24.87,5.94a22.77,22.77,0,0,1,8.41,7.78h1.9v7.18h0c-.25,5-3.67,9.95-10.28,13.76-6.86,4-15.87,5.95-24.87,5.95Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.43,354.51a38.73,38.73,0,0,1,5.66,2.65,22.77,22.77,0,0,1,8.41,7.78h1.9v7.18h0c-.25,5-3.67,9.95-10.28,13.76a37.75,37.75,0,0,1-5.66,2.66Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,354.51a39.73,39.73,0,0,0-5.66,2.65,22.74,22.74,0,0,0-8.4,7.78h-1.9v7.18h0c.25,5,3.7,9.95,10.3,13.76a38.7,38.7,0,0,0,5.66,2.66Z",
    style: {
      fill: "#1E75FE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.1,350.58c13.73,7.93,13.73,20.79,0,28.72-12,6.94-30.58,7.8-44.23,2.6h0l-.55-.21a39.3,39.3,0,0,1-5-2.39c-11.45-6.62-13.36-16.65-5.7-24.41h0a26.91,26.91,0,0,1,5.7-4.31C151.09,342.65,173.36,342.65,187.1,350.58Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.1,350.58c13.73,7.93,13.73,20.79,0,28.72-12,6.94-30.58,7.8-44.23,2.6h0l-.55-.21a39.3,39.3,0,0,1-5-2.39c-11.45-6.62-13.36-16.65-5.7-24.41h0a26.91,26.91,0,0,1,5.7-4.31C151.09,342.65,173.36,342.65,187.1,350.58Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.65,354.89A15.36,15.36,0,0,0,128,367.42c1.21,7,11,12.86,14.35,14.27a39.3,39.3,0,0,1-5-2.39C125.9,372.68,124,362.65,131.65,354.89Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.8,375a15.36,15.36,0,0,0,3.68-12.53c-1.22-7-11-12.85-14.36-14.26a36.79,36.79,0,0,1,5,2.39C198.55,357.19,200.45,367.23,192.8,375Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.24,
    cy: 364.91,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.24,
    cy: 364.91,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,370.55c-2.63-4.86-1.78-10.21,2.56-14.76a21.44,21.44,0,0,1,2.77-2.42,28.29,28.29,0,0,1,2.65-1.75c.52-.3,1.06-.59,1.61-.87-1.36,2.24-.86,4.63,6.84,5.08,15.07.88-4,15.28-4,15.28S133.72,366.42,131,370.55Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.58,366.56c-2.26-.25-3.38-2.57-2.5-5.19s3.42-4.53,5.68-4.28,3.39,2.58,2.51,5.2S134.84,366.82,132.58,366.56Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.42,378.57c.74-5.6,25.2-21.09,25.2-21.09s5.43-2.18,3.63-6a27.31,27.31,0,0,1,2.61,1.69q.85.62,1.59,1.26c7.28,6.31,7.29,14.59,0,20.9-.49.43-1,.85-1.59,1.26a28.1,28.1,0,0,1-2.42,1.58c-.83.49-1.7.94-2.6,1.36-.71.33-1.45.65-2.2.95s-1.51.57-2.29.82a47.71,47.71,0,0,1-7.3,1.76l-1.64.24a57.23,57.23,0,0,1-7.3.45,55.18,55.18,0,0,1-8.93-.73S157.12,382.25,156.42,378.57Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.42,378.57c.74-5.6,25.2-21.09,25.2-21.09s5.43-2.18,3.63-6a27.31,27.31,0,0,1,2.61,1.69q.85.62,1.59,1.26c7.28,6.31,7.29,14.59,0,20.9-.49.43-1,.85-1.59,1.26a28.1,28.1,0,0,1-2.42,1.58c-.83.49-1.7.94-2.6,1.36-.71.33-1.45.65-2.2.95s-1.51.57-2.29.82a47.71,47.71,0,0,1-7.3,1.76l-1.64.24a57.23,57.23,0,0,1-7.3.45,55.18,55.18,0,0,1-8.93-.73S157.12,382.25,156.42,378.57Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.47,355c9.13,5.26,9.5,13.67,1.12,19.19-.36.24-.73.47-1.12.69-9.51,5.5-24.93,5.5-34.45,0s-9.51-14.39,0-19.88c.39-.23.79-.44,1.2-.65C155.79,349.48,170.35,349.7,179.47,355Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.47,355c9.13,5.26,9.5,13.67,1.12,19.19-.36.24-.73.47-1.12.69-9.51,5.5-24.93,5.5-34.45,0s-9.51-14.39,0-19.88c.39-.23.79-.44,1.2-.65C155.79,349.48,170.35,349.7,179.47,355Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.24,
    cy: 364.91,
    rx: 23.28,
    ry: 13.44,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.24,
    cy: 364.91,
    rx: 23.28,
    ry: 13.44,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.7,359.15c-9.09-5.25-23.84-5.25-32.93,0-3.72,2.15-5.91,4.84-6.59,7.63.68,2.8,2.87,5.49,6.59,7.63,9.09,5.25,23.84,5.25,32.93,0,3.72-2.14,5.91-4.83,6.59-7.63C184.61,364,182.42,361.3,178.7,359.15Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.7,359.15c-9.09-5.25-23.84-5.25-32.93,0-3.72,2.15-5.91,4.84-6.59,7.63.68,2.8,2.87,5.49,6.59,7.63,9.09,5.25,23.84,5.25,32.93,0,3.72-2.14,5.91-4.83,6.59-7.63C184.61,364,182.42,361.3,178.7,359.15Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.9,369v-2.78c0-1.14-.79-2.25-2.48-3.24l-.06,0c-3.13-1.8-6.36-1.56-9.24-.84h0c-1.23.31-2.39.71-3.45,1.07a33.9,33.9,0,0,1-3.7,1.15h0a6.58,6.58,0,0,1-1.76.17,3.73,3.73,0,0,1-1.46-.39l.12-.08.36-.22a9,9,0,0,1,1-.49,6.8,6.8,0,0,1,5.18-.12l3-3v-2.76a14.25,14.25,0,0,0-8.16-.3,16.36,16.36,0,0,0-2.6.9l-3-1.72-3.56,2.05v2.77l1.22.7a3,3,0,0,0-.53,1.61c0,.46,0,2.3,0,2.76,0,1.14.81,2.24,2.53,3.24a10.4,10.4,0,0,0,4.92,1.41h0c.33,0,.66,0,1,0a19.61,19.61,0,0,0,5.28-1.14l1-.36-3,3v2.76a14.65,14.65,0,0,0,11.51-.5l3,1.7,3.56-2.06v-2.76l-1.22-.7A3.36,3.36,0,0,0,176.9,369Zm-7.51-.24a6.38,6.38,0,0,1-.83.41,7.65,7.65,0,0,1-5.83.09c2.79-1,5.12-1.84,7.11-.79A5,5,0,0,1,169.39,368.72Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.12,362.06h0c-1.23.31-2.39.71-3.45,1.07a33.9,33.9,0,0,1-3.7,1.15h0a6.58,6.58,0,0,1-1.76.17,3.86,3.86,0,0,1-1.7-.51c-1.14-.66-1.31-1.63.36-2.72l.36-.23a8.85,8.85,0,0,1,1-.48,6.73,6.73,0,0,1,5.17-.12l3-3a14.25,14.25,0,0,0-8.16-.3,16.36,16.36,0,0,0-2.6.9l-3-1.72-3.56,2.05L150,360l0,0c-3,2.28-3.06,4.64.31,6.58A10.41,10.41,0,0,0,155.2,368h0c.33,0,.66,0,1,0a18.88,18.88,0,0,0,5.28-1.14c3.42-1.14,6.19-2.49,8.49-1.16,1.55.89,1.12,2-.57,3a6.38,6.38,0,0,1-.83.41,7.65,7.65,0,0,1-5.93.05l-3.13,3.14a14.65,14.65,0,0,0,11.51-.5l3,1.7,3.56-2.06-3-1.7c3-2.29,3.31-4.79-.16-6.82l0,0C171.23,361.1,168,361.34,165.12,362.06Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.12,362.06h0c-1.23.31-2.39.71-3.45,1.07a33.9,33.9,0,0,1-3.7,1.15h0a6.58,6.58,0,0,1-1.76.17,3.86,3.86,0,0,1-1.7-.51c-1.14-.66-1.31-1.63.36-2.72l.36-.23a8.85,8.85,0,0,1,1-.48,6.73,6.73,0,0,1,5.17-.12l3-3a14.25,14.25,0,0,0-8.16-.3,16.36,16.36,0,0,0-2.6.9l-3-1.72-3.56,2.05L150,360l0,0c-3,2.28-3.06,4.64.31,6.58A10.41,10.41,0,0,0,155.2,368h0c.33,0,.66,0,1,0a18.88,18.88,0,0,0,5.28-1.14c3.42-1.14,6.19-2.49,8.49-1.16,1.55.89,1.12,2-.57,3a6.38,6.38,0,0,1-.83.41,7.65,7.65,0,0,1-5.93.05l-3.13,3.14a14.65,14.65,0,0,0,11.51-.5l3,1.7,3.56-2.06-3-1.7c3-2.29,3.31-4.79-.16-6.82l0,0C171.23,361.1,168,361.34,165.12,362.06Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "147.05 358.31 150.64 356.69 153.59 357.98 150.61 356.26 147.05 358.31",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.78,357.2a16.48,16.48,0,0,1,7.65.26l-2.06,2.93,3-3A14.23,14.23,0,0,0,155.78,357.2Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.36,362.9l0,0c3.47,2,3.13,4.53.16,6.82,2.63-2.86,2.15-4.86-.7-6.5a13.43,13.43,0,0,0-8.75-1.2C168,361.34,171.23,361.1,174.36,362.9Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.57 369.76 176.83 371.5 173.96 373.52 177.52 371.46 174.57 369.76",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.56,369.13a7.65,7.65,0,0,1-5.68.5l-3.38,2.69,3.13-3.14A7.65,7.65,0,0,0,168.56,369.13Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,364.28a4.64,4.64,0,0,1-4.27-.4c-1-.89-.37-1.84,1.17-2.66-1.67,1.09-1.5,2.06-.36,2.72a3.86,3.86,0,0,0,1.7.51A6.58,6.58,0,0,0,158,364.28Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,360c-.25.23-2.4,2.22-1.45,4.22s4.15,3.5,6.68,3.78h0a10.41,10.41,0,0,1-4.92-1.42C146.91,364.68,147,362.32,150,360Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.52,355a22.64,22.64,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.74,0a22.67,22.67,0,0,1,8.41,7.77H202v7.18h0c-.25,5-3.67,9.95-10.28,13.77-13.73,7.93-36,7.93-49.74,0-6.6-3.82-10-8.77-10.3-13.77h0V355Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.52,355a22.64,22.64,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.74,0a22.67,22.67,0,0,1,8.41,7.77H202v7.18h0c-.25,5-3.67,9.95-10.28,13.77-13.73,7.93-36,7.93-49.74,0-6.6-3.82-10-8.77-10.3-13.77h0V355Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.79,341.3c9,0,18,2,24.87,5.95a22.67,22.67,0,0,1,8.41,7.77H202v7.18h0c-.25,5-3.67,9.95-10.28,13.77-6.86,4-15.87,5.95-24.87,5.95Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,344.6a36.76,36.76,0,0,1,5.66,2.65,22.67,22.67,0,0,1,8.41,7.77H202v7.18h0c-.25,5-3.67,9.95-10.28,13.77a38.73,38.73,0,0,1-5.66,2.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.58,344.6a37.66,37.66,0,0,0-5.66,2.65,22.64,22.64,0,0,0-8.4,7.77h-1.9v7.18h0c.25,5,3.7,9.95,10.3,13.77a39.73,39.73,0,0,0,5.66,2.65Z",
    style: {
      fill: "#1E75FE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.66,340.66c13.74,7.93,13.74,20.79,0,28.72-12,6.94-30.57,7.81-44.22,2.6h0l-.55-.21a38,38,0,0,1-5-2.39c-11.45-6.61-13.36-16.65-5.7-24.4h0a26.91,26.91,0,0,1,5.7-4.31C155.66,332.73,177.93,332.73,191.66,340.66Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.66,340.66c13.74,7.93,13.74,20.79,0,28.72-12,6.94-30.57,7.81-44.22,2.6h0l-.55-.21a38,38,0,0,1-5-2.39c-11.45-6.61-13.36-16.65-5.7-24.4h0a26.91,26.91,0,0,1,5.7-4.31C155.66,332.73,177.93,332.73,191.66,340.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.22,345a15.32,15.32,0,0,0-3.68,12.53c1.21,7,11,12.85,14.35,14.26a38,38,0,0,1-5-2.39C130.47,362.77,128.56,352.73,136.22,345Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.37,365.07a15.39,15.39,0,0,0,3.68-12.53c-1.22-7-11-12.86-14.36-14.27a38,38,0,0,1,5,2.39C203.12,347.28,205,357.32,197.37,365.07Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 166.81,
    cy: 354.99,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 166.81,
    cy: 354.99,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.59,360.63c-2.62-4.86-1.77-10.21,2.57-14.75a22.27,22.27,0,0,1,2.77-2.43,28.25,28.25,0,0,1,2.65-1.74c.52-.31,1.06-.6,1.61-.88-1.36,2.24-.86,4.64,6.84,5.08,15.07.88-4,15.29-4,15.29S138.29,356.51,135.59,360.63Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.15,356.65c-2.26-.26-3.38-2.58-2.5-5.2s3.42-4.53,5.68-4.27,3.39,2.57,2.51,5.19S139.41,356.9,137.15,356.65Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,368.65c.74-5.6,25.2-21.09,25.2-21.09s5.43-2.18,3.62-6a28.2,28.2,0,0,1,2.62,1.69q.85.62,1.59,1.26c7.28,6.31,7.29,14.59,0,20.91-.49.42-1,.85-1.59,1.26a28.06,28.06,0,0,1-2.42,1.57c-.83.49-1.7.94-2.6,1.36-.71.34-1.45.66-2.2.95s-1.51.57-2.29.83a48.9,48.9,0,0,1-7.3,1.75l-1.64.24a57.24,57.24,0,0,1-7.3.46,55.18,55.18,0,0,1-8.93-.74S161.69,372.33,161,368.65Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,368.65c.74-5.6,25.2-21.09,25.2-21.09s5.43-2.18,3.62-6a28.2,28.2,0,0,1,2.62,1.69q.85.62,1.59,1.26c7.28,6.31,7.29,14.59,0,20.91-.49.42-1,.85-1.59,1.26a28.06,28.06,0,0,1-2.42,1.57c-.83.49-1.7.94-2.6,1.36-.71.34-1.45.66-2.2.95s-1.51.57-2.29.83a48.9,48.9,0,0,1-7.3,1.75l-1.64.24a57.24,57.24,0,0,1-7.3.46,55.18,55.18,0,0,1-8.93-.74S161.69,372.33,161,368.65Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,345.05c9.13,5.27,9.5,13.67,1.12,19.2-.36.23-.73.46-1.12.69-9.51,5.49-24.93,5.49-34.45,0s-9.51-14.4,0-19.89c.39-.23.79-.44,1.2-.65C160.36,339.56,174.92,339.78,184,345.05Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,345.05c9.13,5.27,9.5,13.67,1.12,19.2-.36.23-.73.46-1.12.69-9.51,5.49-24.93,5.49-34.45,0s-9.51-14.4,0-19.89c.39-.23.79-.44,1.2-.65C160.36,339.56,174.92,339.78,184,345.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 166.8,
    cy: 354.99,
    rx: 23.28,
    ry: 13.44,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 166.8,
    cy: 354.99,
    rx: 23.28,
    ry: 13.44,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.27,349.24c-9.09-5.25-23.84-5.25-32.93,0-3.72,2.14-5.91,4.84-6.59,7.63.68,2.79,2.87,5.48,6.59,7.63,9.09,5.25,23.84,5.25,32.93,0,3.72-2.15,5.91-4.84,6.59-7.63C189.18,354.08,187,351.38,183.27,349.24Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.27,349.24c-9.09-5.25-23.84-5.25-32.93,0-3.72,2.14-5.91,4.84-6.59,7.63.68,2.79,2.87,5.48,6.59,7.63,9.09,5.25,23.84,5.25,32.93,0,3.72-2.15,5.91-4.84,6.59-7.63C189.18,354.08,187,351.38,183.27,349.24Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.47,359v-2.78c0-1.14-.79-2.24-2.49-3.23,0,0,0,0,0,0-3.13-1.81-6.36-1.57-9.24-.85h0c-1.23.31-2.39.7-3.45,1.07a33.56,33.56,0,0,1-3.7,1.14h0a6.55,6.55,0,0,1-1.76.16,3.9,3.9,0,0,1-1.46-.38l.12-.08a3.17,3.17,0,0,1,.36-.23,7.37,7.37,0,0,1,1-.48,6.69,6.69,0,0,1,5.17-.12l3-3v-2.77a14.17,14.17,0,0,0-8.16-.29,17.37,17.37,0,0,0-2.6.89l-3-1.72-3.57,2.06v2.76l1.23.71a3,3,0,0,0-.53,1.61c0,.46,0,2.29,0,2.76,0,1.14.81,2.24,2.53,3.23a10.41,10.41,0,0,0,4.92,1.42h0a8.18,8.18,0,0,0,1,0,19.61,19.61,0,0,0,5.28-1.14l1-.35-3,3v2.76a14.65,14.65,0,0,0,11.51-.5l2.95,1.71,3.56-2.06v-2.77l-1.22-.7A3.31,3.31,0,0,0,181.47,359ZM174,358.8a9.25,9.25,0,0,1-.83.42,7.69,7.69,0,0,1-5.83.08c2.79-1,5.12-1.84,7.11-.78Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.69,352.14h0c-1.23.31-2.39.7-3.45,1.07a33.56,33.56,0,0,1-3.7,1.14h0a6.55,6.55,0,0,1-1.76.16,3.72,3.72,0,0,1-1.7-.5c-1.14-.67-1.31-1.63.36-2.73l.36-.22a9,9,0,0,1,1-.49,6.78,6.78,0,0,1,5.17-.12l3-3a14.17,14.17,0,0,0-8.16-.29,17.37,17.37,0,0,0-2.6.89l-3-1.72-3.57,2.06,3,1.7,0,0c-3,2.27-3.06,4.63.31,6.58a10.51,10.51,0,0,0,4.92,1.41h0c.33,0,.66,0,1,0A19.61,19.61,0,0,0,166,357c3.42-1.15,6.19-2.49,8.49-1.16,1.55.89,1.12,2-.57,3a9.25,9.25,0,0,1-.83.42,7.67,7.67,0,0,1-5.94,0l-3.12,3.14a14.65,14.65,0,0,0,11.51-.5l2.95,1.7,3.56-2.06-3-1.7c3-2.29,3.31-4.79-.16-6.81,0,0,0,0,0,0C175.8,351.18,172.57,351.42,169.69,352.14Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.69,352.14h0c-1.23.31-2.39.7-3.45,1.07a33.56,33.56,0,0,1-3.7,1.14h0a6.55,6.55,0,0,1-1.76.16,3.72,3.72,0,0,1-1.7-.5c-1.14-.67-1.31-1.63.36-2.73l.36-.22a9,9,0,0,1,1-.49,6.78,6.78,0,0,1,5.17-.12l3-3a14.17,14.17,0,0,0-8.16-.29,17.37,17.37,0,0,0-2.6.89l-3-1.72-3.57,2.06,3,1.7,0,0c-3,2.27-3.06,4.63.31,6.58a10.51,10.51,0,0,0,4.92,1.41h0c.33,0,.66,0,1,0A19.61,19.61,0,0,0,166,357c3.42-1.15,6.19-2.49,8.49-1.16,1.55.89,1.12,2-.57,3a9.25,9.25,0,0,1-.83.42,7.67,7.67,0,0,1-5.94,0l-3.12,3.14a14.65,14.65,0,0,0,11.51-.5l2.95,1.7,3.56-2.06-3-1.7c3-2.29,3.31-4.79-.16-6.81,0,0,0,0,0,0C175.8,351.18,172.57,351.42,169.69,352.14Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "151.62 348.4 155.21 346.77 158.16 348.06 155.18 346.34 151.62 348.4",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.34,347.28a16.65,16.65,0,0,1,7.66.26l-2.06,2.93,3-3A14.26,14.26,0,0,0,160.34,347.28Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.93,353s0,0,0,0c3.47,2,3.12,4.52.16,6.81,2.63-2.86,2.15-4.85-.7-6.5a13.5,13.5,0,0,0-8.75-1.2C172.57,351.42,175.8,351.18,178.93,353Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.14 359.84 181.4 361.58 178.53 363.6 182.09 361.55 179.14 359.84",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.13,359.22a7.67,7.67,0,0,1-5.68.49l-3.38,2.69,3.12-3.14A7.67,7.67,0,0,0,173.13,359.22Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.52,354.37a4.67,4.67,0,0,1-4.27-.41c-1-.89-.37-1.83,1.17-2.66-1.67,1.1-1.5,2.06-.36,2.73a3.72,3.72,0,0,0,1.7.5A6.55,6.55,0,0,0,162.52,354.37Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.54,350.13c-.25.22-2.4,2.22-1.45,4.22s4.15,3.5,6.68,3.77h0a10.51,10.51,0,0,1-4.92-1.41C151.48,354.76,151.54,352.4,154.54,350.13Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.25,345.29a22.72,22.72,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.75,0a22.72,22.72,0,0,1,8.4,7.77h1.9v7.19h0c-.25,5-3.67,9.95-10.27,13.76-13.74,7.93-36,7.93-49.75,0-6.6-3.81-10.05-8.76-10.3-13.76h0v-7.19Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.25,345.29a22.72,22.72,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.75,0a22.72,22.72,0,0,1,8.4,7.77h1.9v7.19h0c-.25,5-3.67,9.95-10.27,13.76-13.74,7.93-36,7.93-49.75,0-6.6-3.81-10.05-8.76-10.3-13.76h0v-7.19Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.52,331.58c9,0,18,2,24.88,5.94a22.72,22.72,0,0,1,8.4,7.77h1.9v7.19h0c-.25,5-3.67,9.95-10.27,13.76-6.87,4-15.88,5.95-24.88,5.95Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.73,334.87a39.34,39.34,0,0,1,5.67,2.65,22.72,22.72,0,0,1,8.4,7.77h1.9v7.19h0c-.25,5-3.67,9.95-10.27,13.76a37.32,37.32,0,0,1-5.67,2.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.31,334.87a39.73,39.73,0,0,0-5.66,2.65,22.72,22.72,0,0,0-8.4,7.77h-1.9v7.19h0c.25,5,3.7,9.95,10.3,13.76a37.66,37.66,0,0,0,5.66,2.65Z",
    style: {
      fill: "#1E75FE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.4,330.94c13.73,7.93,13.73,20.79,0,28.72-12,6.93-30.57,7.8-44.23,2.6h0l-.54-.21a38.79,38.79,0,0,1-5-2.39C125.2,353,123.3,343,131,335.25h0a26.58,26.58,0,0,1,5.7-4.31C150.39,323,172.66,323,186.4,330.94Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.4,330.94c13.73,7.93,13.73,20.79,0,28.72-12,6.93-30.57,7.8-44.23,2.6h0l-.54-.21a38.79,38.79,0,0,1-5-2.39C125.2,353,123.3,343,131,335.25h0a26.58,26.58,0,0,1,5.7-4.31C150.39,323,172.66,323,186.4,330.94Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,335.25a15.36,15.36,0,0,0-3.68,12.53c1.22,7,11,12.85,14.36,14.27a38.79,38.79,0,0,1-5-2.39C125.2,353,123.3,343,131,335.25Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.1,355.34a15.36,15.36,0,0,0,3.68-12.53c-1.22-7-11-12.85-14.36-14.26a37.5,37.5,0,0,1,5,2.39C197.85,337.55,199.75,347.59,192.1,355.34Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.54,
    cy: 345.27,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.54,
    cy: 345.27,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.33,350.91c-2.63-4.86-1.77-10.22,2.56-14.76a22.13,22.13,0,0,1,2.77-2.42,28.29,28.29,0,0,1,2.65-1.75c.52-.3,1.06-.6,1.61-.87-1.36,2.23-.86,4.63,6.84,5.08,15.07.88-4,15.28-4,15.28S133,346.78,130.33,350.91Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.88,346.92c-2.26-.25-3.38-2.58-2.5-5.19s3.42-4.53,5.68-4.28,3.39,2.58,2.51,5.2S134.14,347.18,131.88,346.92Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.72,358.93c.74-5.6,25.2-21.09,25.2-21.09s5.43-2.18,3.63-6a27.31,27.31,0,0,1,2.61,1.69q.85.62,1.59,1.26c7.28,6.3,7.29,14.59,0,20.9q-.74.64-1.59,1.26a28.1,28.1,0,0,1-2.42,1.58c-.83.48-1.7.94-2.59,1.36-.72.33-1.46.65-2.21.95s-1.51.57-2.29.82a47.71,47.71,0,0,1-7.3,1.76l-1.64.23a56.36,56.36,0,0,1-16.23-.27S156.42,362.61,155.72,358.93Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.72,358.93c.74-5.6,25.2-21.09,25.2-21.09s5.43-2.18,3.63-6a27.31,27.31,0,0,1,2.61,1.69q.85.62,1.59,1.26c7.28,6.3,7.29,14.59,0,20.9q-.74.64-1.59,1.26a28.1,28.1,0,0,1-2.42,1.58c-.83.48-1.7.94-2.59,1.36-.72.33-1.46.65-2.21.95s-1.51.57-2.29.82a47.71,47.71,0,0,1-7.3,1.76l-1.64.23a56.36,56.36,0,0,1-16.23-.27S156.42,362.61,155.72,358.93Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.77,335.32c9.13,5.27,9.5,13.68,1.12,19.2-.36.24-.73.47-1.12.69-9.51,5.49-24.93,5.49-34.44,0s-9.52-14.39,0-19.89c.39-.22.79-.44,1.2-.64C155.09,329.84,169.65,330.06,178.77,335.32Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.77,335.32c9.13,5.27,9.5,13.68,1.12,19.2-.36.24-.73.47-1.12.69-9.51,5.49-24.93,5.49-34.44,0s-9.52-14.39,0-19.89c.39-.22.79-.44,1.2-.64C155.09,329.84,169.65,330.06,178.77,335.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,335.76c9.09,5.25,9.09,13.76,0,19s-23.83,5.25-32.93,0-9.09-13.76,0-19S168.91,330.51,178,335.76Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,335.76c9.09,5.25,9.09,13.76,0,19s-23.83,5.25-32.93,0-9.09-13.76,0-19S168.91,330.51,178,335.76Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,339.51c-9.09-5.25-23.83-5.25-32.93,0-3.72,2.15-5.91,4.84-6.59,7.63.68,2.79,2.87,5.49,6.59,7.63,9.1,5.25,23.84,5.25,32.93,0,3.72-2.14,5.91-4.84,6.59-7.63C183.91,344.35,181.72,341.66,178,339.51Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,339.51c-9.09-5.25-23.83-5.25-32.93,0-3.72,2.15-5.91,4.84-6.59,7.63.68,2.79,2.87,5.49,6.59,7.63,9.1,5.25,23.84,5.25,32.93,0,3.72-2.14,5.91-4.84,6.59-7.63C183.91,344.35,181.72,341.66,178,339.51Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.2,349.32c0-.46,0-2.31,0-2.78,0-1.14-.79-2.25-2.48-3.24l-.06,0c-3.13-1.8-6.36-1.57-9.24-.84h0c-1.23.31-2.39.71-3.45,1.07a33.23,33.23,0,0,1-3.7,1.15h0a6.54,6.54,0,0,1-1.76.17,3.73,3.73,0,0,1-1.46-.39l.12-.08c.11-.08.24-.15.36-.22a9,9,0,0,1,1-.49,6.76,6.76,0,0,1,5.18-.12l3-3v-2.76a14.17,14.17,0,0,0-8.16-.3,16.71,16.71,0,0,0-2.6.9l-3-1.72-3.56,2.05v2.77l1.22.7a3,3,0,0,0-.53,1.61c0,.46,0,2.3,0,2.76,0,1.14.82,2.24,2.53,3.24a10.51,10.51,0,0,0,4.92,1.41h1a19.24,19.24,0,0,0,5.28-1.15l1-.35-3,3v2.77a14.65,14.65,0,0,0,11.51-.5l2.95,1.7,3.56-2.06v-2.76l-1.22-.71A3.22,3.22,0,0,0,176.2,349.32Zm-7.51-.24a6.38,6.38,0,0,1-.83.41,7.65,7.65,0,0,1-5.83.09c2.79-1,5.12-1.85,7.11-.79Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.42,342.42h0c-1.23.31-2.39.71-3.45,1.07a33.23,33.23,0,0,1-3.7,1.15h0a6.54,6.54,0,0,1-1.76.17,3.78,3.78,0,0,1-1.69-.51c-1.15-.66-1.32-1.63.35-2.72l.36-.23a7.37,7.37,0,0,1,1-.48,6.76,6.76,0,0,1,5.18-.12l3-3a14.17,14.17,0,0,0-8.16-.3,16.71,16.71,0,0,0-2.6.9l-3-1.72-3.56,2.05,3,1.71,0,0c-3,2.28-3.06,4.64.31,6.58a10.41,10.41,0,0,0,4.92,1.42h0c.32,0,.65,0,1,0a19.24,19.24,0,0,0,5.28-1.14c3.42-1.14,6.19-2.49,8.49-1.16,1.55.89,1.12,2-.57,3a6.38,6.38,0,0,1-.83.41,7.65,7.65,0,0,1-5.93.05l-3.13,3.13a14.6,14.6,0,0,0,11.51-.5l2.95,1.71,3.56-2.06-2.95-1.7c3-2.3,3.31-4.79-.15-6.82l-.06,0C170.53,341.46,167.3,341.69,164.42,342.42Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.42,342.42h0c-1.23.31-2.39.71-3.45,1.07a33.23,33.23,0,0,1-3.7,1.15h0a6.54,6.54,0,0,1-1.76.17,3.78,3.78,0,0,1-1.69-.51c-1.15-.66-1.32-1.63.35-2.72l.36-.23a7.37,7.37,0,0,1,1-.48,6.76,6.76,0,0,1,5.18-.12l3-3a14.17,14.17,0,0,0-8.16-.3,16.71,16.71,0,0,0-2.6.9l-3-1.72-3.56,2.05,3,1.71,0,0c-3,2.28-3.06,4.64.31,6.58a10.41,10.41,0,0,0,4.92,1.42h0c.32,0,.65,0,1,0a19.24,19.24,0,0,0,5.28-1.14c3.42-1.14,6.19-2.49,8.49-1.16,1.55.89,1.12,2-.57,3a6.38,6.38,0,0,1-.83.41,7.65,7.65,0,0,1-5.93.05l-3.13,3.13a14.6,14.6,0,0,0,11.51-.5l2.95,1.71,3.56-2.06-2.95-1.7c3-2.3,3.31-4.79-.15-6.82l-.06,0C170.53,341.46,167.3,341.69,164.42,342.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "146.35 338.67 149.94 337.04 152.9 338.34 149.91 336.62 146.35 338.67",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.08,337.56a16.6,16.6,0,0,1,7.65.25l-2.06,2.94,3-3A14.08,14.08,0,0,0,155.08,337.56Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.66,343.26l.06,0c3.46,2,3.12,4.52.15,6.82,2.63-2.86,2.15-4.86-.7-6.51a13.48,13.48,0,0,0-8.75-1.19C167.3,341.69,170.53,341.46,173.66,343.26Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.87 350.12 176.13 351.86 173.26 353.88 176.82 351.82 173.87 350.12",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.86,349.49a7.65,7.65,0,0,1-5.68.5l-3.38,2.68,3.13-3.13A7.65,7.65,0,0,0,167.86,349.49Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.25,344.64a4.64,4.64,0,0,1-4.27-.4c-1-.89-.37-1.84,1.17-2.66-1.67,1.09-1.5,2.06-.35,2.72a3.78,3.78,0,0,0,1.69.51A6.54,6.54,0,0,0,157.25,344.64Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.27,340.4c-.25.22-2.4,2.22-1.45,4.22s4.15,3.5,6.69,3.78h0a10.41,10.41,0,0,1-4.92-1.42C146.21,345,146.28,342.68,149.27,340.4Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.91,332.45a22.72,22.72,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.75,0a22.64,22.64,0,0,1,8.4,7.77h1.9v7.19h0c-.25,5-3.67,9.94-10.27,13.76-13.74,7.93-36,7.93-49.75,0-6.6-3.82-10-8.77-10.3-13.76h0v-7.19Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.91,332.45a22.72,22.72,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.75,0a22.64,22.64,0,0,1,8.4,7.77h1.9v7.19h0c-.25,5-3.67,9.94-10.27,13.76-13.74,7.93-36,7.93-49.75,0-6.6-3.82-10-8.77-10.3-13.76h0v-7.19Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.18,318.73c9,0,18,2,24.88,5.95a22.64,22.64,0,0,1,8.4,7.77h1.9v7.19h0c-.25,5-3.67,9.94-10.27,13.76-6.87,4-15.87,6-24.88,6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.4,322a37.66,37.66,0,0,1,5.66,2.65,22.64,22.64,0,0,1,8.4,7.77h1.9v7.19h0c-.25,5-3.67,9.94-10.27,13.76a39.73,39.73,0,0,1-5.66,2.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,322a37.32,37.32,0,0,0-5.67,2.65,22.72,22.72,0,0,0-8.4,7.77H129v7.19h0c.26,5,3.7,9.94,10.3,13.76a39.34,39.34,0,0,0,5.67,2.65Z",
    style: {
      fill: "#1E75FE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.06,318.09c13.73,7.93,13.73,20.79,0,28.72-12,6.94-30.57,7.81-44.23,2.6h0l-.54-.21a37.5,37.5,0,0,1-5-2.39c-11.45-6.61-13.35-16.65-5.7-24.4h0a27,27,0,0,1,5.71-4.31C153.05,310.16,175.32,310.16,189.06,318.09Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.06,318.09c13.73,7.93,13.73,20.79,0,28.72-12,6.94-30.57,7.81-44.23,2.6h0l-.54-.21a37.5,37.5,0,0,1-5-2.39c-11.45-6.61-13.35-16.65-5.7-24.4h0a27,27,0,0,1,5.71-4.31C153.05,310.16,175.32,310.16,189.06,318.09Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.61,322.41a15.36,15.36,0,0,0-3.68,12.53c1.22,7,11,12.85,14.36,14.26a37.5,37.5,0,0,1-5-2.39C127.86,340.2,126,330.16,133.61,322.41Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.76,342.5A15.36,15.36,0,0,0,198.44,330c-1.21-7-11-12.86-14.36-14.27a38.79,38.79,0,0,1,5,2.39C200.51,324.71,202.41,334.75,194.76,342.5Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 164.2,
    cy: 332.42,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 164.2,
    cy: 332.42,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,338.06c-2.63-4.86-1.77-10.21,2.56-14.75a23,23,0,0,1,2.77-2.43,28.25,28.25,0,0,1,2.65-1.74c.52-.31,1.06-.6,1.61-.88-1.36,2.24-.86,4.64,6.84,5.09,15.07.88-4,15.28-4,15.28S135.68,333.94,133,338.06Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.54,334.08c-2.26-.25-3.38-2.58-2.5-5.2s3.42-4.53,5.69-4.27,3.38,2.58,2.5,5.19S136.8,334.33,134.54,334.08Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.38,346.08c.74-5.6,25.2-21.09,25.2-21.09s5.43-2.17,3.63-6a29.39,29.39,0,0,1,2.61,1.69q.85.62,1.59,1.26c7.29,6.31,7.29,14.59,0,20.91q-.74.64-1.59,1.26a28.06,28.06,0,0,1-2.42,1.57c-.83.49-1.7.94-2.59,1.36-.72.34-1.46.66-2.21.95s-1.51.57-2.29.83a48.9,48.9,0,0,1-7.3,1.75c-.54.09-1.09.17-1.64.24a57.12,57.12,0,0,1-7.3.46,56.33,56.33,0,0,1-8.93-.73S159.08,349.76,158.38,346.08Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.38,346.08c.74-5.6,25.2-21.09,25.2-21.09s5.43-2.17,3.63-6a29.39,29.39,0,0,1,2.61,1.69q.85.62,1.59,1.26c7.29,6.31,7.29,14.59,0,20.91q-.74.64-1.59,1.26a28.06,28.06,0,0,1-2.42,1.57c-.83.49-1.7.94-2.59,1.36-.72.34-1.46.66-2.21.95s-1.51.57-2.29.83a48.9,48.9,0,0,1-7.3,1.75c-.54.09-1.09.17-1.64.24a57.12,57.12,0,0,1-7.3.46,56.33,56.33,0,0,1-8.93-.73S159.08,349.76,158.38,346.08Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.44,322.48c9.12,5.27,9.49,13.67,1.11,19.2-.36.23-.73.46-1.12.69-9.51,5.49-24.93,5.49-34.44,0s-9.52-14.4,0-19.89c.39-.22.79-.44,1.2-.65C157.75,317,172.31,317.21,181.44,322.48Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.44,322.48c9.12,5.27,9.49,13.67,1.11,19.2-.36.23-.73.46-1.12.69-9.51,5.49-24.93,5.49-34.44,0s-9.52-14.4,0-19.89c.39-.22.79-.44,1.2-.65C157.75,317,172.31,317.21,181.44,322.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 164.2,
    cy: 332.42,
    rx: 23.28,
    ry: 13.44,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 164.2,
    cy: 332.42,
    rx: 23.28,
    ry: 13.44,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.66,326.67c-9.09-5.25-23.83-5.25-32.93,0-3.71,2.14-5.91,4.84-6.59,7.63.68,2.79,2.88,5.48,6.59,7.63,9.1,5.25,23.84,5.25,32.93,0,3.72-2.15,5.92-4.84,6.59-7.63C186.58,331.51,184.38,328.81,180.66,326.67Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.66,326.67c-9.09-5.25-23.83-5.25-32.93,0-3.71,2.14-5.91,4.84-6.59,7.63.68,2.79,2.88,5.48,6.59,7.63,9.1,5.25,23.84,5.25,32.93,0,3.72-2.15,5.92-4.84,6.59-7.63C186.58,331.51,184.38,328.81,180.66,326.67Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.86,336.47c0-.45,0-2.3,0-2.78,0-1.14-.79-2.24-2.48-3.23l-.06,0c-3.13-1.81-6.36-1.57-9.24-.85h0c-1.22.31-2.39.7-3.45,1.07a33.48,33.48,0,0,1-3.69,1.14h0a6.51,6.51,0,0,1-1.76.16,3.76,3.76,0,0,1-1.46-.38l.12-.08c.11-.08.24-.15.37-.23a7.31,7.31,0,0,1,6.15-.6l3-3v-2.77a14.17,14.17,0,0,0-8.16-.29,16.26,16.26,0,0,0-2.59.9l-3-1.73L149,325.83v2.76l1.22.71a3,3,0,0,0-.53,1.61c0,.46,0,2.29,0,2.76,0,1.14.82,2.24,2.53,3.23a10.48,10.48,0,0,0,4.92,1.42h0c.32,0,.65,0,1,0a19.61,19.61,0,0,0,5.28-1.14l1-.35-3,3v2.76a14.6,14.6,0,0,0,11.51-.5l2.95,1.71,3.56-2.06V339l-1.22-.71A3.23,3.23,0,0,0,178.86,336.47Zm-7.51-.23c-.28.15-.55.29-.83.41a7.62,7.62,0,0,1-5.82.08c2.79-1,5.11-1.84,7.1-.78Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.08,329.57h0c-1.22.31-2.39.7-3.45,1.07a33.48,33.48,0,0,1-3.69,1.14h0a6.51,6.51,0,0,1-1.76.16,3.64,3.64,0,0,1-1.69-.5c-1.15-.66-1.32-1.63.35-2.73l.37-.22a8,8,0,0,1,1-.49,6.76,6.76,0,0,1,5.18-.11l3-3a14.17,14.17,0,0,0-8.16-.29,16.26,16.26,0,0,0-2.59.9l-3-1.73L149,325.83l3,1.7,0,0c-3,2.27-3.05,4.63.31,6.58a10.43,10.43,0,0,0,4.92,1.41h0c.32,0,.65,0,1,0a19.61,19.61,0,0,0,5.28-1.14c3.42-1.15,6.19-2.49,8.5-1.16,1.54.89,1.11,2-.58,3-.28.15-.55.29-.83.41a7.64,7.64,0,0,1-5.93,0l-3.13,3.14a14.65,14.65,0,0,0,11.51-.5l2.95,1.7,3.56-2-2.95-1.71c3-2.29,3.31-4.79-.15-6.81l-.06,0C173.19,328.61,170,328.85,167.08,329.57Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.08,329.57h0c-1.22.31-2.39.7-3.45,1.07a33.48,33.48,0,0,1-3.69,1.14h0a6.51,6.51,0,0,1-1.76.16,3.64,3.64,0,0,1-1.69-.5c-1.15-.66-1.32-1.63.35-2.73l.37-.22a8,8,0,0,1,1-.49,6.76,6.76,0,0,1,5.18-.11l3-3a14.17,14.17,0,0,0-8.16-.29,16.26,16.26,0,0,0-2.59.9l-3-1.73L149,325.83l3,1.7,0,0c-3,2.27-3.05,4.63.31,6.58a10.43,10.43,0,0,0,4.92,1.41h0c.32,0,.65,0,1,0a19.61,19.61,0,0,0,5.28-1.14c3.42-1.15,6.19-2.49,8.5-1.16,1.54.89,1.11,2-.58,3-.28.15-.55.29-.83.41a7.64,7.64,0,0,1-5.93,0l-3.13,3.14a14.65,14.65,0,0,0,11.51-.5l2.95,1.7,3.56-2-2.95-1.71c3-2.29,3.31-4.79-.15-6.81l-.06,0C173.19,328.61,170,328.85,167.08,329.57Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "149.01 325.83 152.61 324.2 155.56 325.5 152.57 323.77 149.01 325.83",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.74,324.71a16.66,16.66,0,0,1,7.66.26l-2.07,2.94,3-3A14.23,14.23,0,0,0,157.74,324.71Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.32,330.42l.06,0c3.46,2,3.12,4.52.15,6.81,2.63-2.86,2.16-4.85-.7-6.5a13.49,13.49,0,0,0-8.75-1.2C170,328.85,173.19,328.61,176.32,330.42Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.53 337.27 178.79 339.01 175.92 341.03 179.48 338.98 176.53 337.27",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.52,336.65a7.67,7.67,0,0,1-5.68.49l-3.38,2.69,3.13-3.14A7.64,7.64,0,0,0,170.52,336.65Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.91,331.8a4.64,4.64,0,0,1-4.27-.41c-1-.88-.37-1.83,1.17-2.66-1.67,1.1-1.5,2.07-.35,2.73a3.64,3.64,0,0,0,1.69.5A6.51,6.51,0,0,0,159.91,331.8Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.93,327.56c-.25.22-2.4,2.22-1.45,4.22s4.15,3.5,6.69,3.77h0a10.43,10.43,0,0,1-4.92-1.41C148.88,332.19,148.94,329.83,151.93,327.56Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.76,324.23a22.7,22.7,0,0,1,8.4-7.76c13.73-7.94,36-7.94,49.74,0a22.7,22.7,0,0,1,8.4,7.76h1.9v7.19h0c-.25,5-3.67,9.95-10.28,13.76-13.74,7.93-36,7.93-49.74,0-6.61-3.81-10-8.76-10.3-13.76h0v-7.19Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.76,324.23a22.7,22.7,0,0,1,8.4-7.76c13.73-7.94,36-7.94,49.74,0a22.7,22.7,0,0,1,8.4,7.76h1.9v7.19h0c-.25,5-3.67,9.95-10.28,13.76-13.74,7.93-36,7.93-49.74,0-6.61-3.81-10-8.76-10.3-13.76h0v-7.19Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,310.52c9,0,18,2,24.87,6a22.7,22.7,0,0,1,8.4,7.76h1.9v7.19h0c-.25,5-3.67,9.95-10.28,13.76-6.87,4-15.87,5.95-24.87,5.95Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.24,313.81a38.7,38.7,0,0,1,5.66,2.66,22.7,22.7,0,0,1,8.4,7.76h1.9v7.19h0c-.25,5-3.67,9.95-10.28,13.76a38.7,38.7,0,0,1-5.66,2.66Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.82,313.81a38.7,38.7,0,0,0-5.66,2.66,22.7,22.7,0,0,0-8.4,7.76h-1.9v7.19h0c.25,5,3.69,9.95,10.3,13.76a38.7,38.7,0,0,0,5.66,2.66Z",
    style: {
      fill: "#1E75FE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.9,309.88c13.74,7.93,13.74,20.79,0,28.72-12,6.94-30.57,7.8-44.22,2.6h0l-.55-.21a38.65,38.65,0,0,1-5-2.39C119.7,332,117.8,322,125.45,314.19h0a26.58,26.58,0,0,1,5.7-4.31C144.89,302,167.16,302,180.9,309.88Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.9,309.88c13.74,7.93,13.74,20.79,0,28.72-12,6.94-30.57,7.8-44.22,2.6h0l-.55-.21a38.65,38.65,0,0,1-5-2.39C119.7,332,117.8,322,125.45,314.19h0a26.58,26.58,0,0,1,5.7-4.31C144.89,302,167.16,302,180.9,309.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.45,314.19a15.39,15.39,0,0,0-3.68,12.53c1.22,7,11,12.86,14.36,14.27a38.65,38.65,0,0,1-5-2.39C119.7,332,117.8,322,125.45,314.19Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.61,334.28a15.4,15.4,0,0,0,3.68-12.53c-1.22-7-11-12.85-14.36-14.26a37.37,37.37,0,0,1,5,2.39C192.36,316.49,194.26,326.53,186.61,334.28Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 156.04,
    cy: 324.21,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 156.04,
    cy: 324.21,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.83,329.85c-2.63-4.86-1.77-10.21,2.57-14.76a21.44,21.44,0,0,1,2.77-2.42,27,27,0,0,1,2.65-1.75c.52-.3,1.05-.59,1.61-.87-1.36,2.24-.86,4.63,6.84,5.08,15.07.88-4,15.28-4,15.28S127.52,325.72,124.83,329.85Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.39,325.86c-2.27-.25-3.39-2.57-2.51-5.19s3.43-4.53,5.69-4.28,3.38,2.58,2.5,5.2S128.65,326.12,126.39,325.86Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.22,337.87c.74-5.6,25.21-21.09,25.21-21.09s5.42-2.18,3.62-6a28.82,28.82,0,0,1,2.62,1.69q.84.62,1.59,1.26c7.28,6.31,7.29,14.59,0,20.9-.49.43-1,.85-1.58,1.26a28.31,28.31,0,0,1-2.43,1.58c-.83.49-1.7.94-2.59,1.36-.71.33-1.45.65-2.2.95s-1.52.57-2.3.82a47.15,47.15,0,0,1-7.3,1.76l-1.64.24a57.12,57.12,0,0,1-7.3.45,55.06,55.06,0,0,1-8.92-.73S150.92,341.55,150.22,337.87Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.22,337.87c.74-5.6,25.21-21.09,25.21-21.09s5.42-2.18,3.62-6a28.82,28.82,0,0,1,2.62,1.69q.84.62,1.59,1.26c7.28,6.31,7.29,14.59,0,20.9-.49.43-1,.85-1.58,1.26a28.31,28.31,0,0,1-2.43,1.58c-.83.49-1.7.94-2.59,1.36-.71.33-1.45.65-2.2.95s-1.52.57-2.3.82a47.15,47.15,0,0,1-7.3,1.76l-1.64.24a57.12,57.12,0,0,1-7.3.45,55.06,55.06,0,0,1-8.92-.73S150.92,341.55,150.22,337.87Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.28,314.27c9.12,5.26,9.49,13.67,1.11,19.19-.35.24-.73.47-1.11.69-9.52,5.5-24.94,5.5-34.45,0s-9.52-14.39,0-19.88c.39-.23.79-.44,1.19-.65C149.59,308.78,164.15,309,173.28,314.27Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.28,314.27c9.12,5.26,9.49,13.67,1.11,19.19-.35.24-.73.47-1.11.69-9.52,5.5-24.94,5.5-34.45,0s-9.52-14.39,0-19.88c.39-.23.79-.44,1.19-.65C149.59,308.78,164.15,309,173.28,314.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 156.04,
    cy: 324.21,
    rx: 23.28,
    ry: 13.44,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 156.04,
    cy: 324.21,
    rx: 23.28,
    ry: 13.44,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.51,318.45c-9.1-5.25-23.84-5.25-32.93,0-3.72,2.15-5.92,4.84-6.59,7.63.67,2.8,2.87,5.49,6.59,7.63,9.09,5.25,23.83,5.25,32.93,0,3.71-2.14,5.91-4.83,6.59-7.63C178.42,323.29,176.22,320.6,172.51,318.45Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.51,318.45c-9.1-5.25-23.84-5.25-32.93,0-3.72,2.15-5.92,4.84-6.59,7.63.67,2.8,2.87,5.49,6.59,7.63,9.09,5.25,23.83,5.25,32.93,0,3.71-2.14,5.91-4.83,6.59-7.63C178.42,323.29,176.22,320.6,172.51,318.45Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.7,328.26c0-.45,0-2.3,0-2.78,0-1.14-.79-2.25-2.49-3.24l-.06,0c-3.12-1.8-6.35-1.56-9.23-.84h0c-1.22.31-2.38.71-3.44,1.07a33.9,33.9,0,0,1-3.7,1.15h0a6.54,6.54,0,0,1-1.76.17,3.68,3.68,0,0,1-1.45-.39l.11-.08.37-.22a9.82,9.82,0,0,1,1-.49,6.81,6.81,0,0,1,5.18-.12l3-3v-2.76a14.29,14.29,0,0,0-8.17-.3,16.61,16.61,0,0,0-2.59.9l-3-1.72-3.56,2.05v2.77l1.22.7a3,3,0,0,0-.52,1.61v2.76c0,1.14.82,2.24,2.54,3.24A10.4,10.4,0,0,0,149,330.1h0c.33,0,.66,0,1,0a19.68,19.68,0,0,0,5.29-1.14l1-.36-3,3v2.76a14.64,14.64,0,0,0,11.51-.5l2.95,1.7,3.57-2.06v-2.76l-1.23-.71A3.14,3.14,0,0,0,170.7,328.26Zm-7.51-.24a5.81,5.81,0,0,1-.83.41,7.62,7.62,0,0,1-5.82.09c2.79-1,5.12-1.84,7.1-.79A3.88,3.88,0,0,1,163.19,328Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.93,321.36h0c-1.22.31-2.38.71-3.44,1.07a33.9,33.9,0,0,1-3.7,1.15h0a6.54,6.54,0,0,1-1.76.17,3.82,3.82,0,0,1-1.69-.51c-1.15-.66-1.31-1.63.35-2.72l.37-.23a7.92,7.92,0,0,1,1-.48,6.76,6.76,0,0,1,5.18-.12l3-3a14.29,14.29,0,0,0-8.17-.3,16.61,16.61,0,0,0-2.59.9l-3-1.72-3.56,2.05,3,1.71,0,0c-3,2.28-3.06,4.64.31,6.58a10.41,10.41,0,0,0,4.92,1.42h0c.33,0,.66,0,1,0a19,19,0,0,0,5.29-1.14c3.42-1.14,6.19-2.49,8.49-1.16,1.54.89,1.12,2-.58,3a5.81,5.81,0,0,1-.83.41,7.65,7.65,0,0,1-5.93.05l-3.13,3.14a14.64,14.64,0,0,0,11.51-.5l2.95,1.7,3.57-2.06-3-1.7c3-2.29,3.3-4.79-.16-6.82l-.06,0C165,320.4,161.81,320.64,158.93,321.36Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.93,321.36h0c-1.22.31-2.38.71-3.44,1.07a33.9,33.9,0,0,1-3.7,1.15h0a6.54,6.54,0,0,1-1.76.17,3.82,3.82,0,0,1-1.69-.51c-1.15-.66-1.31-1.63.35-2.72l.37-.23a7.92,7.92,0,0,1,1-.48,6.76,6.76,0,0,1,5.18-.12l3-3a14.29,14.29,0,0,0-8.17-.3,16.61,16.61,0,0,0-2.59.9l-3-1.72-3.56,2.05,3,1.71,0,0c-3,2.28-3.06,4.64.31,6.58a10.41,10.41,0,0,0,4.92,1.42h0c.33,0,.66,0,1,0a19,19,0,0,0,5.29-1.14c3.42-1.14,6.19-2.49,8.49-1.16,1.54.89,1.12,2-.58,3a5.81,5.81,0,0,1-.83.41,7.65,7.65,0,0,1-5.93.05l-3.13,3.14a14.64,14.64,0,0,0,11.51-.5l2.95,1.7,3.57-2.06-3-1.7c3-2.29,3.3-4.79-.16-6.82l-.06,0C165,320.4,161.81,320.64,158.93,321.36Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "140.85 317.62 144.45 315.99 147.4 317.28 144.41 315.56 140.85 317.62",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.58,316.5a16.52,16.52,0,0,1,7.66.26l-2.07,2.93,3-3A14.26,14.26,0,0,0,149.58,316.5Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.16,322.2l.06,0c3.46,2,3.12,4.53.16,6.82,2.62-2.86,2.15-4.86-.7-6.5a13.44,13.44,0,0,0-8.75-1.2C161.81,320.64,165,320.4,168.16,322.2Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.38 329.06 170.64 330.8 167.76 332.82 171.33 330.76 168.38 329.06",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.36,328.43a7.62,7.62,0,0,1-5.67.5l-3.39,2.69,3.13-3.14A7.65,7.65,0,0,0,162.36,328.43Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.75,323.58a4.62,4.62,0,0,1-4.26-.4c-1-.89-.37-1.84,1.16-2.66-1.66,1.09-1.5,2.06-.35,2.72a3.82,3.82,0,0,0,1.69.51A6.54,6.54,0,0,0,151.75,323.58Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.78,319.34c-.26.23-2.4,2.22-1.45,4.22s4.14,3.5,6.68,3.78h0a10.41,10.41,0,0,1-4.92-1.42C140.72,324,140.78,321.62,143.78,319.34Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.21,312.81a22.67,22.67,0,0,1,8.41-7.77c13.73-7.93,36-7.93,49.74,0a22.64,22.64,0,0,1,8.4,7.77h1.9V320h0c-.26,5-3.68,9.95-10.28,13.77-13.74,7.93-36,7.93-49.74,0C132,329.94,128.57,325,128.31,320h0v-7.18Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.21,312.81a22.67,22.67,0,0,1,8.41-7.77c13.73-7.93,36-7.93,49.74,0a22.64,22.64,0,0,1,8.4,7.77h1.9V320h0c-.26,5-3.68,9.95-10.28,13.77-13.74,7.93-36,7.93-49.74,0C132,329.94,128.57,325,128.31,320h0v-7.18Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.49,299.09c9,0,18,2,24.87,6a22.64,22.64,0,0,1,8.4,7.77h1.9V320h0c-.26,5-3.68,9.95-10.28,13.77-6.87,4-15.87,5.94-24.87,5.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.7,302.39a37.66,37.66,0,0,1,5.66,2.65,22.64,22.64,0,0,1,8.4,7.77h1.9V320h0c-.26,5-3.68,9.95-10.28,13.77a39.73,39.73,0,0,1-5.66,2.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.28,302.39a37.2,37.2,0,0,0-5.66,2.65,22.67,22.67,0,0,0-8.41,7.77h-1.9V320h0c.26,5,3.7,9.95,10.31,13.77a39.22,39.22,0,0,0,5.66,2.65Z",
    style: {
      fill: "#1E75FE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.36,298.45c13.74,7.93,13.73,20.79,0,28.72-12,6.94-30.57,7.81-44.22,2.6h0l-.54-.21a36.79,36.79,0,0,1-5-2.39c-11.46-6.61-13.36-16.65-5.71-24.4h0a27,27,0,0,1,5.71-4.31C152.35,290.52,174.62,290.52,188.36,298.45Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.36,298.45c13.74,7.93,13.73,20.79,0,28.72-12,6.94-30.57,7.81-44.22,2.6h0l-.54-.21a36.79,36.79,0,0,1-5-2.39c-11.46-6.61-13.36-16.65-5.71-24.4h0a27,27,0,0,1,5.71-4.31C152.35,290.52,174.62,290.52,188.36,298.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.91,302.77a15.36,15.36,0,0,0-3.68,12.53c1.22,7,11,12.85,14.36,14.26a36.79,36.79,0,0,1-5-2.39C127.16,320.56,125.26,310.52,132.91,302.77Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.06,322.86a15.36,15.36,0,0,0,3.68-12.53c-1.21-7-11-12.86-14.35-14.27a39.3,39.3,0,0,1,5,2.39C199.81,305.07,201.72,315.1,194.06,322.86Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.5,
    cy: 312.78,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.5,
    cy: 312.78,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.29,318.42c-2.63-4.86-1.77-10.21,2.57-14.75a21.57,21.57,0,0,1,2.77-2.43,25.14,25.14,0,0,1,2.64-1.74c.53-.31,1.06-.6,1.61-.88-1.36,2.24-.86,4.63,6.84,5.08,15.07.88-4,15.29-4,15.29S135,314.3,132.29,318.42Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.84,314.44c-2.26-.26-3.38-2.58-2.5-5.2s3.43-4.53,5.69-4.28,3.38,2.58,2.5,5.2S136.11,314.69,133.84,314.44Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.68,326.44c.74-5.6,25.21-21.09,25.21-21.09s5.42-2.18,3.62-6a29.39,29.39,0,0,1,2.61,1.69q.85.62,1.59,1.26c7.29,6.31,7.3,14.59,0,20.9q-.74.64-1.59,1.26a25.92,25.92,0,0,1-2.42,1.58c-.83.49-1.7.94-2.59,1.36-.72.34-1.46.66-2.21.95s-1.51.57-2.29.83a48.61,48.61,0,0,1-7.3,1.75c-.54.09-1.09.17-1.64.24a57.12,57.12,0,0,1-7.3.46,55,55,0,0,1-8.92-.74S158.38,330.12,157.68,326.44Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.68,326.44c.74-5.6,25.21-21.09,25.21-21.09s5.42-2.18,3.62-6a29.39,29.39,0,0,1,2.61,1.69q.85.62,1.59,1.26c7.29,6.31,7.3,14.59,0,20.9q-.74.64-1.59,1.26a25.92,25.92,0,0,1-2.42,1.58c-.83.49-1.7.94-2.59,1.36-.72.34-1.46.66-2.21.95s-1.51.57-2.29.83a48.61,48.61,0,0,1-7.3,1.75c-.54.09-1.09.17-1.64.24a57.12,57.12,0,0,1-7.3.46,55,55,0,0,1-8.92-.74S158.38,330.12,157.68,326.44Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.74,302.84c9.12,5.27,9.49,13.67,1.11,19.2-.36.23-.73.46-1.12.69-9.51,5.49-24.93,5.49-34.44,0s-9.52-14.4,0-19.89c.39-.23.79-.44,1.2-.65C157.05,297.35,171.61,297.57,180.74,302.84Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.74,302.84c9.12,5.27,9.49,13.67,1.11,19.2-.36.23-.73.46-1.12.69-9.51,5.49-24.93,5.49-34.44,0s-9.52-14.4,0-19.89c.39-.23.79-.44,1.2-.65C157.05,297.35,171.61,297.57,180.74,302.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.5,
    cy: 312.78,
    rx: 23.28,
    ry: 13.44,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.5,
    cy: 312.78,
    rx: 23.28,
    ry: 13.44,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,307c-9.09-5.25-23.83-5.25-32.93,0-3.71,2.14-5.91,4.84-6.59,7.63.68,2.79,2.88,5.48,6.59,7.63,9.1,5.25,23.84,5.25,32.93,0,3.72-2.15,5.92-4.84,6.59-7.63C185.88,311.87,183.68,309.17,180,307Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,307c-9.09-5.25-23.83-5.25-32.93,0-3.71,2.14-5.91,4.84-6.59,7.63.68,2.79,2.88,5.48,6.59,7.63,9.1,5.25,23.84,5.25,32.93,0,3.72-2.15,5.92-4.84,6.59-7.63C185.88,311.87,183.68,309.17,180,307Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.16,316.83c0-.45,0-2.3,0-2.78,0-1.14-.79-2.24-2.48-3.24l-.06,0c-3.13-1.81-6.36-1.57-9.23-.85h0c-1.22.3-2.38.7-3.45,1.07a32.83,32.83,0,0,1-3.69,1.14h0a6.16,6.16,0,0,1-1.76.17,3.85,3.85,0,0,1-1.45-.38l.11-.09.37-.22a8.83,8.83,0,0,1,1-.49,6.76,6.76,0,0,1,5.18-.11l3-3v-2.77a14.17,14.17,0,0,0-8.16-.29,17.25,17.25,0,0,0-2.59.89l-3-1.72-3.56,2.06V309l1.22.71a2.87,2.87,0,0,0-.52,1.61V314c0,1.14.82,2.24,2.54,3.23a10.41,10.41,0,0,0,4.92,1.42h0c.32,0,.66,0,1,0a19.77,19.77,0,0,0,5.29-1.14l1-.36-3,3V323a14.65,14.65,0,0,0,11.51-.5l2.95,1.7,3.56-2v-2.77l-1.22-.7A3.25,3.25,0,0,0,178.16,316.83Zm-7.51-.24a7.18,7.18,0,0,1-.83.42,7.66,7.66,0,0,1-5.82.08c2.79-1,5.12-1.84,7.1-.78Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.39,309.93h0c-1.22.3-2.38.7-3.45,1.07a32.83,32.83,0,0,1-3.69,1.14h0a6.16,6.16,0,0,1-1.76.17,3.68,3.68,0,0,1-1.69-.5c-1.15-.67-1.31-1.64.35-2.73l.37-.22a8.83,8.83,0,0,1,1-.49,6.76,6.76,0,0,1,5.18-.12l3-3a14.17,14.17,0,0,0-8.16-.29,17.25,17.25,0,0,0-2.59.89l-3-1.72-3.56,2.06,2.95,1.7,0,0c-3,2.28-3,4.64.32,6.59a10.51,10.51,0,0,0,4.92,1.41h1a19.77,19.77,0,0,0,5.29-1.14c3.41-1.15,6.18-2.49,8.49-1.17,1.54.9,1.11,2-.58,3a7.18,7.18,0,0,1-.83.42,7.64,7.64,0,0,1-5.93,0l-3.13,3.14a14.65,14.65,0,0,0,11.51-.5l2.95,1.7,3.56-2.06-2.94-1.7c3-2.29,3.3-4.79-.16-6.82l-.06,0C172.49,309,169.26,309.21,166.39,309.93Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.39,309.93h0c-1.22.3-2.38.7-3.45,1.07a32.83,32.83,0,0,1-3.69,1.14h0a6.16,6.16,0,0,1-1.76.17,3.68,3.68,0,0,1-1.69-.5c-1.15-.67-1.31-1.64.35-2.73l.37-.22a8.83,8.83,0,0,1,1-.49,6.76,6.76,0,0,1,5.18-.12l3-3a14.17,14.17,0,0,0-8.16-.29,17.25,17.25,0,0,0-2.59.89l-3-1.72-3.56,2.06,2.95,1.7,0,0c-3,2.28-3,4.64.32,6.59a10.51,10.51,0,0,0,4.92,1.41h1a19.77,19.77,0,0,0,5.29-1.14c3.41-1.15,6.18-2.49,8.49-1.17,1.54.9,1.11,2-.58,3a7.18,7.18,0,0,1-.83.42,7.64,7.64,0,0,1-5.93,0l-3.13,3.14a14.65,14.65,0,0,0,11.51-.5l2.95,1.7,3.56-2.06-2.94-1.7c3-2.29,3.3-4.79-.16-6.82l-.06,0C172.49,309,169.26,309.21,166.39,309.93Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "148.31 306.19 151.91 304.56 154.86 305.85 151.87 304.13 148.31 306.19",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,305.07a16.52,16.52,0,0,1,7.66.26l-2.07,2.93,3-3A14.23,14.23,0,0,0,157,305.07Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.62,310.78l.06,0c3.46,2,3.12,4.53.16,6.82,2.62-2.86,2.15-4.85-.71-6.5a13.47,13.47,0,0,0-8.74-1.2C169.26,309.21,172.49,309,175.62,310.78Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.84 317.63 178.1 319.37 175.22 321.39 178.78 319.33 175.84 317.63",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.82,317a7.67,7.67,0,0,1-5.68.49l-3.38,2.69,3.13-3.14A7.64,7.64,0,0,0,169.82,317Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.21,312.15a4.64,4.64,0,0,1-4.27-.4c-1-.89-.37-1.84,1.17-2.66-1.66,1.09-1.5,2.06-.35,2.73a3.68,3.68,0,0,0,1.69.5A6.16,6.16,0,0,0,159.21,312.15Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.23,307.91c-.25.23-2.39,2.23-1.45,4.23s4.15,3.5,6.69,3.77h0a10.51,10.51,0,0,1-4.92-1.41C148.18,312.55,148.24,310.19,151.23,307.91Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.42 309.23 133.31 302.5 134.19 309.23 145.85 309.74 134.19 310.26 133.31 316.99 132.42 310.26 120.77 309.74 132.42 309.23",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pound--inject-93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.38,371.33a22.64,22.64,0,0,1,8.4-7.77c13.74-7.94,36-7.94,49.75,0a22.64,22.64,0,0,1,8.4,7.77h1.9v7.18h0c-.25,5-3.67,9.95-10.27,13.76-13.74,7.93-36,7.93-49.75,0-6.6-3.81-10-8.76-10.3-13.76h0v-7.18Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.38,371.33a22.64,22.64,0,0,1,8.4-7.77c13.74-7.94,36-7.94,49.75,0a22.64,22.64,0,0,1,8.4,7.77h1.9v7.18h0c-.25,5-3.67,9.95-10.27,13.76-13.74,7.93-36,7.93-49.75,0-6.6-3.81-10-8.76-10.3-13.76h0v-7.18Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.65,357.61c9,0,18,2,24.88,5.95a22.64,22.64,0,0,1,8.4,7.77h1.9v7.18h0c-.25,5-3.67,9.95-10.27,13.76-6.87,4-15.87,6-24.88,6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.87,360.9a38.7,38.7,0,0,1,5.66,2.66,22.64,22.64,0,0,1,8.4,7.77h1.9v7.18h0c-.25,5-3.67,9.95-10.27,13.76a38.7,38.7,0,0,1-5.66,2.66Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.44,360.9a38.7,38.7,0,0,0-5.66,2.66,22.64,22.64,0,0,0-8.4,7.77h-1.9v7.18h0c.26,5,3.7,9.95,10.3,13.76a38.7,38.7,0,0,0,5.66,2.66Z",
    style: {
      fill: "#1E75FE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.53,357c13.73,7.93,13.73,20.79,0,28.72-12,6.94-30.57,7.81-44.23,2.6h0l-.54-.21a38.79,38.79,0,0,1-5-2.39c-11.45-6.62-13.35-16.65-5.7-24.41h0a26.91,26.91,0,0,1,5.7-4.31C55.52,349,77.79,349,91.53,357Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.53,357c13.73,7.93,13.73,20.79,0,28.72-12,6.94-30.57,7.81-44.23,2.6h0l-.54-.21a38.79,38.79,0,0,1-5-2.39c-11.45-6.62-13.35-16.65-5.7-24.41h0a26.91,26.91,0,0,1,5.7-4.31C55.52,349,77.79,349,91.53,357Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.08,361.28a15.39,15.39,0,0,0-3.68,12.53c1.22,7,11,12.86,14.36,14.27a38.79,38.79,0,0,1-5-2.39C30.33,379.07,28.43,369,36.08,361.28Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.23,381.37a15.35,15.35,0,0,0,3.68-12.52c-1.22-7-11-12.86-14.36-14.27a37.5,37.5,0,0,1,5,2.39C103,363.58,104.88,373.62,97.23,381.37Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.67,
    cy: 371.3,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.67,
    cy: 371.3,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.46,376.94c-2.63-4.86-1.77-10.21,2.56-14.76a22.13,22.13,0,0,1,2.77-2.42A28.29,28.29,0,0,1,43.44,358c.52-.3,1.06-.59,1.61-.87-1.36,2.24-.86,4.63,6.84,5.08,15.07.88-4,15.28-4,15.28S38.15,372.81,35.46,376.94Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,373c-2.26-.25-3.38-2.57-2.5-5.19s3.42-4.53,5.68-4.28,3.39,2.58,2.51,5.2S39.27,373.21,37,373Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.85,385c.74-5.6,25.2-21.09,25.2-21.09s5.43-2.18,3.63-6a27.31,27.31,0,0,1,2.61,1.69q.85.62,1.59,1.26c7.28,6.31,7.29,14.59,0,20.9q-.73.64-1.59,1.26a28.1,28.1,0,0,1-2.42,1.58c-.83.49-1.7.94-2.59,1.36-.72.34-1.46.65-2.21.95s-1.51.57-2.29.82a47.71,47.71,0,0,1-7.3,1.76c-.54.09-1.09.17-1.64.24a56.9,56.9,0,0,1-16.23-.28S61.55,388.64,60.85,385Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.85,385c.74-5.6,25.2-21.09,25.2-21.09s5.43-2.18,3.63-6a27.31,27.31,0,0,1,2.61,1.69q.85.62,1.59,1.26c7.28,6.31,7.29,14.59,0,20.9q-.73.64-1.59,1.26a28.1,28.1,0,0,1-2.42,1.58c-.83.49-1.7.94-2.59,1.36-.72.34-1.46.65-2.21.95s-1.51.57-2.29.82a47.71,47.71,0,0,1-7.3,1.76c-.54.09-1.09.17-1.64.24a56.9,56.9,0,0,1-16.23-.28S61.55,388.64,60.85,385Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9,361.36C93,366.62,93.4,375,85,380.55c-.36.24-.73.47-1.12.69-9.51,5.5-24.93,5.5-34.44,0s-9.52-14.39,0-19.88c.39-.23.79-.44,1.2-.65C60.22,355.87,74.78,356.09,83.9,361.36Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9,361.36C93,366.62,93.4,375,85,380.55c-.36.24-.73.47-1.12.69-9.51,5.5-24.93,5.5-34.44,0s-9.52-14.39,0-19.88c.39-.23.79-.44,1.2-.65C60.22,355.87,74.78,356.09,83.9,361.36Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.67,
    cy: 371.3,
    rx: 23.28,
    ry: 13.44,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.67,
    cy: 371.3,
    rx: 23.28,
    ry: 13.44,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.13,365.54c-9.09-5.25-23.83-5.25-32.93,0-3.72,2.15-5.91,4.84-6.59,7.63.68,2.8,2.87,5.49,6.59,7.64,9.1,5.25,23.84,5.25,32.93,0,3.72-2.15,5.91-4.84,6.59-7.64C89,370.38,86.85,367.69,83.13,365.54Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.13,365.54c-9.09-5.25-23.83-5.25-32.93,0-3.72,2.15-5.91,4.84-6.59,7.63.68,2.8,2.87,5.49,6.59,7.64,9.1,5.25,23.84,5.25,32.93,0,3.72-2.15,5.91-4.84,6.59-7.64C89,370.38,86.85,367.69,83.13,365.54Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.86,372v2.76l-17.15,9.91-.88,0-3.72-2.18V380A9.73,9.73,0,0,0,63,379.3c-.64-.37-1.42-.74-2.19-1.15l-2.2,1.26-3.67-2.12V375.4c-.91-.44-1.77-.88-2.53-1.32-2-1.14-3-2.44-3-3.8,0-.45,0-2.27,0-2.73a3.31,3.31,0,0,1,.72-2,9.32,9.32,0,0,1,3-2.45,16.23,16.23,0,0,1,13.62-1.52c.52.17,1,.38,1.6.6V365l-3.14,3.13c-3.24-1.4-5.56-1.26-7.69,0a6.11,6.11,0,0,0-.84.57,6.6,6.6,0,0,0,1.14.81c.81.46,2,1,3.21,1.58l7.25-4.19L71.94,369v2.77l-4.19,2.41c1.28.79,2.2,1.67,1.86,2.47l5.87-3.38,6.24-3.61Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.61,376.61c.37-.87-.74-1.83-2.19-2.66-.54-.31-1.32-.68-2.23-1.09l6.75-3.9-3.68-2.12L61,371c-1.25-.57-2.4-1.11-3.21-1.58-2.56-1.48-2.53-2.86-.3-4.15s4.45-1.36,7.69,0l3.14-3.14a16.3,16.3,0,0,0-15.21.92c-4.79,2.77-4.79,5.84-.71,8.2,1.25.72,2.76,1.44,4.31,2.18l-1.78,1,3.67,2.12,2.2-1.26c.77.41,1.55.78,2.19,1.15,1.89,1.09,2.63,1.94,1.11,3.25l4.15,2.39L85.87,372l-4.15-2.4-6.24,3.61Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.61,376.61c.37-.87-.74-1.83-2.19-2.66-.54-.31-1.32-.68-2.23-1.09l6.75-3.9-3.68-2.12L61,371c-1.25-.57-2.4-1.11-3.21-1.58-2.56-1.48-2.53-2.86-.3-4.15s4.45-1.36,7.69,0l3.14-3.14a16.3,16.3,0,0,0-15.21.92c-4.79,2.77-4.79,5.84-.71,8.2,1.25.72,2.76,1.44,4.31,2.18l-1.78,1,3.67,2.12,2.2-1.26c.77.41,1.55.78,2.19,1.15,1.89,1.09,2.63,1.94,1.11,3.25l4.15,2.39L85.87,372l-4.15-2.4-6.24,3.61Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.11,363.76a16.65,16.65,0,0,1,15.18-1.36l-2.1,2.94,3.14-3.14a16.3,16.3,0,0,0-15.21.92C52.75,363.33,52.42,363.55,52.11,363.76Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.01 371.03 68.31 367.28 71.94 368.96 68.26 366.84 61.01 371.03",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.61 376.62 81.83 370.38 85.86 372.02 81.72 369.62 69.61 376.62",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.61 376.65 56.08 374.55 56.73 373.5 54.94 374.53 58.61 376.65",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.12,377.56a12.83,12.83,0,0,0-4.31-2.17c.77.41,1.55.78,2.19,1.15,1.89,1.09,2.63,1.94,1.11,3.25l4.15,2.39L65,379.68A1.33,1.33,0,0,0,65.12,377.56Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.93,360.22a22.64,22.64,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.74,0a22.67,22.67,0,0,1,8.41,7.77h1.9v7.19h0c-.25,5-3.67,9.94-10.28,13.76-13.73,7.93-36,7.93-49.74,0-6.6-3.82-10-8.77-10.3-13.77h0v-7.19Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.93,360.22a22.64,22.64,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.74,0a22.67,22.67,0,0,1,8.41,7.77h1.9v7.19h0c-.25,5-3.67,9.94-10.28,13.76-13.73,7.93-36,7.93-49.74,0-6.6-3.82-10-8.77-10.3-13.77h0v-7.19Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2,346.5c9,0,18,2,24.87,5.95a22.56,22.56,0,0,1,8.4,7.77h1.91v7.19h0c-.25,5-3.67,9.94-10.28,13.76-6.87,4-15.87,5.95-24.87,5.95Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.41,349.8a37.66,37.66,0,0,1,5.66,2.65,22.56,22.56,0,0,1,8.4,7.77h1.91v7.19h0c-.25,5-3.67,9.94-10.28,13.76a39.73,39.73,0,0,1-5.66,2.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,349.8a37.66,37.66,0,0,0-5.66,2.65,22.64,22.64,0,0,0-8.4,7.77H36v7.19h0c.25,5,3.7,10,10.3,13.77A39.73,39.73,0,0,0,52,383.82Z",
    style: {
      fill: "#1E75FE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.07,345.86c13.74,7.93,13.74,20.79,0,28.72-12,6.94-30.57,7.81-44.22,2.6h0L51.3,377a37.37,37.37,0,0,1-5-2.39C34.88,368,33,357.93,40.62,350.18h0a26.91,26.91,0,0,1,5.7-4.31C60.07,337.93,82.34,337.93,96.07,345.86Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.07,345.86c13.74,7.93,13.74,20.79,0,28.72-12,6.94-30.57,7.81-44.22,2.6h0L51.3,377a37.37,37.37,0,0,1-5-2.39C34.88,368,33,357.93,40.62,350.18h0a26.91,26.91,0,0,1,5.7-4.31C60.07,337.93,82.34,337.93,96.07,345.86Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.62,350.18A15.37,15.37,0,0,0,37,362.71c1.21,7,11,12.85,14.35,14.26a37.37,37.37,0,0,1-5-2.39C34.88,368,33,357.93,40.62,350.18Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.78,370.27a15.39,15.39,0,0,0,3.68-12.53c-1.22-7-11-12.86-14.36-14.27a38,38,0,0,1,5,2.39C107.53,352.48,109.43,362.52,101.78,370.27Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.22,
    cy: 360.19,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.22,
    cy: 360.19,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,365.83c-2.62-4.86-1.77-10.21,2.57-14.75a22.27,22.27,0,0,1,2.77-2.43A27,27,0,0,1,48,346.91c.52-.31,1-.6,1.61-.88-1.36,2.24-.86,4.64,6.84,5.08,15.07.89-4,15.29-4,15.29S42.7,361.71,40,365.83Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.56,361.85c-2.26-.25-3.38-2.58-2.5-5.2s3.42-4.53,5.68-4.27,3.38,2.57,2.5,5.19S43.82,362.1,41.56,361.85Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.39,373.85c.75-5.6,25.21-21.09,25.21-21.09s5.42-2.18,3.62-6a29.59,29.59,0,0,1,2.62,1.69c.57.41,1.09.83,1.59,1.26,7.28,6.31,7.29,14.59,0,20.91q-.75.64-1.59,1.26a28.27,28.27,0,0,1-2.43,1.57c-.83.49-1.69.94-2.59,1.36-.71.34-1.45.66-2.2,1s-1.51.57-2.3.83A48.48,48.48,0,0,1,80,378.37l-1.65.24a57,57,0,0,1-7.29.46,55.09,55.09,0,0,1-8.93-.74S66.09,377.53,65.39,373.85Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.39,373.85c.75-5.6,25.21-21.09,25.21-21.09s5.42-2.18,3.62-6a29.59,29.59,0,0,1,2.62,1.69c.57.41,1.09.83,1.59,1.26,7.28,6.31,7.29,14.59,0,20.91q-.75.64-1.59,1.26a28.27,28.27,0,0,1-2.43,1.57c-.83.49-1.69.94-2.59,1.36-.71.34-1.45.66-2.2,1s-1.51.57-2.3.83A48.48,48.48,0,0,1,80,378.37l-1.65.24a57,57,0,0,1-7.29.46,55.09,55.09,0,0,1-8.93-.74S66.09,377.53,65.39,373.85Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.45,350.25c9.13,5.27,9.5,13.67,1.11,19.2q-.53.35-1.11.69c-9.52,5.49-24.93,5.49-34.45,0s-9.51-14.4,0-19.89l1.19-.65C64.76,344.77,79.33,345,88.45,350.25Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.45,350.25c9.13,5.27,9.5,13.67,1.11,19.2q-.53.35-1.11.69c-9.52,5.49-24.93,5.49-34.45,0s-9.51-14.4,0-19.89l1.19-.65C64.76,344.77,79.33,345,88.45,350.25Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.21,
    cy: 360.19,
    rx: 23.28,
    ry: 13.44,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.21,
    cy: 360.19,
    rx: 23.28,
    ry: 13.44,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.68,354.44c-9.1-5.25-23.84-5.25-32.93,0-3.72,2.14-5.91,4.84-6.59,7.63.68,2.79,2.87,5.48,6.59,7.63,9.09,5.25,23.83,5.25,32.93,0,3.72-2.15,5.91-4.84,6.59-7.63C93.59,359.28,91.4,356.58,87.68,354.44Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.68,354.44c-9.1-5.25-23.84-5.25-32.93,0-3.72,2.14-5.91,4.84-6.59,7.63.68,2.79,2.87,5.48,6.59,7.63,9.09,5.25,23.83,5.25,32.93,0,3.72-2.15,5.91-4.84,6.59-7.63C93.59,359.28,91.4,356.58,87.68,354.44Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.41,360.91v2.77l-17.16,9.9-.87,0-3.72-2.18v-2.52a12.63,12.63,0,0,0-1.11-.73c-.64-.37-1.42-.74-2.2-1.15l-2.19,1.27-3.68-2.12V364.3c-.9-.44-1.76-.89-2.53-1.33-2-1.13-3-2.44-3-3.8v-2.73a3.33,3.33,0,0,1,.71-2,9.5,9.5,0,0,1,3-2.46,16.19,16.19,0,0,1,13.62-1.51q.78.25,1.59.6v2.76L69.74,357c-3.24-1.41-5.57-1.27-7.69,0a6.25,6.25,0,0,0-.85.58,7.33,7.33,0,0,0,1.15.8c.81.47,2,1,3.21,1.58l7.25-4.19,3.67,2.12v2.77L72.29,363c1.29.78,2.21,1.66,1.87,2.47L80,362.12l6.25-3.6Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.16,365.51c.37-.88-.75-1.83-2.2-2.67-.54-.31-1.31-.68-2.22-1.09l6.74-3.89-3.67-2.13-7.26,4.19c-1.24-.57-2.39-1.11-3.2-1.58-2.56-1.48-2.53-2.86-.3-4.15s4.45-1.36,7.69,0l3.13-3.13a16.28,16.28,0,0,0-15.21.91c-4.79,2.77-4.79,5.85-.71,8.2,1.25.72,2.77,1.44,4.32,2.18l-1.79,1,3.68,2.13,2.19-1.27c.78.41,1.55.78,2.19,1.15,1.89,1.09,2.64,1.95,1.12,3.25l4.15,2.4,17.6-10.17-4.15-2.39L80,362.12Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.16,365.51c.37-.88-.75-1.83-2.2-2.67-.54-.31-1.31-.68-2.22-1.09l6.74-3.89-3.67-2.13-7.26,4.19c-1.24-.57-2.39-1.11-3.2-1.58-2.56-1.48-2.53-2.86-.3-4.15s4.45-1.36,7.69,0l3.13-3.13a16.28,16.28,0,0,0-15.21.91c-4.79,2.77-4.79,5.85-.71,8.2,1.25.72,2.77,1.44,4.32,2.18l-1.79,1,3.68,2.13,2.19-1.27c.78.41,1.55.78,2.19,1.15,1.89,1.09,2.64,1.95,1.12,3.25l4.15,2.4,17.6-10.17-4.15-2.39L80,362.12Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.66,352.65a16.62,16.62,0,0,1,15.17-1.36l-2.09,2.94,3.13-3.13a16.28,16.28,0,0,0-15.21.91C57.3,352.23,57,352.44,56.66,352.65Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.56 359.92 72.86 356.17 76.48 357.86 72.81 355.73 65.56 359.92",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.16 365.51 86.38 359.27 90.41 360.91 86.26 358.52 74.16 365.51",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.16 365.55 60.63 363.44 61.27 362.39 59.48 363.43 63.16 365.55",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.67,366.45a12.84,12.84,0,0,0-4.32-2.17c.78.41,1.55.78,2.19,1.15,1.89,1.09,2.64,1.95,1.12,3.25l4.15,2.4-3.29-2.51A1.33,1.33,0,0,0,69.67,366.45Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.92,352.49a22.64,22.64,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.75,0a22.64,22.64,0,0,1,8.4,7.77h1.9v7.19h0c-.25,5-3.67,9.94-10.27,13.76-13.74,7.93-36,7.93-49.75,0-6.6-3.82-10-8.77-10.3-13.76h0v-7.19Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.92,352.49a22.64,22.64,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.75,0a22.64,22.64,0,0,1,8.4,7.77h1.9v7.19h0c-.25,5-3.67,9.94-10.27,13.76-13.74,7.93-36,7.93-49.75,0-6.6-3.82-10-8.77-10.3-13.76h0v-7.19Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.19,338.77c9,0,18,2,24.88,6a22.64,22.64,0,0,1,8.4,7.77h1.9v7.19h0c-.25,5-3.67,9.94-10.27,13.76-6.87,4-15.87,5.95-24.88,5.95Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.41,342.07a37.66,37.66,0,0,1,5.66,2.65,22.64,22.64,0,0,1,8.4,7.77h1.9v7.19h0c-.25,5-3.67,9.94-10.27,13.76a39.73,39.73,0,0,1-5.66,2.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,342.07a37.32,37.32,0,0,0-5.67,2.65,22.64,22.64,0,0,0-8.4,7.77H27v7.19h0c.26,5,3.7,9.94,10.3,13.76A39.34,39.34,0,0,0,43,376.09Z",
    style: {
      fill: "#1E75FE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.07,338.13c13.73,7.93,13.73,20.79,0,28.72-12,6.94-30.57,7.81-44.23,2.61h0l-.54-.21a37.5,37.5,0,0,1-5-2.39c-11.45-6.61-13.35-16.65-5.7-24.4h0a26.91,26.91,0,0,1,5.7-4.31C51.06,330.2,73.33,330.2,87.07,338.13Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.07,338.13c13.73,7.93,13.73,20.79,0,28.72-12,6.94-30.57,7.81-44.23,2.61h0l-.54-.21a37.5,37.5,0,0,1-5-2.39c-11.45-6.61-13.35-16.65-5.7-24.4h0a26.91,26.91,0,0,1,5.7-4.31C51.06,330.2,73.33,330.2,87.07,338.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.62,342.45A15.36,15.36,0,0,0,27.94,355c1.22,7,11,12.85,14.36,14.26a37.5,37.5,0,0,1-5-2.39C25.87,360.24,24,350.2,31.62,342.45Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.77,362.54A15.36,15.36,0,0,0,96.45,350c-1.21-7-11-12.85-14.36-14.27a38.79,38.79,0,0,1,5,2.39C98.52,344.75,100.42,354.79,92.77,362.54Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.09,365.81c-12.77-7.37-12.77-19.32,0-26.69s33.47-7.38,46.24,0,12.77,19.32,0,26.69S51.86,373.19,39.09,365.81Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.09,365.81c-12.77-7.37-12.77-19.32,0-26.69s33.47-7.38,46.24,0,12.77,19.32,0,26.69S51.86,373.19,39.09,365.81Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,358.1c-2.63-4.86-1.77-10.21,2.56-14.75a23,23,0,0,1,2.77-2.43A28.25,28.25,0,0,1,39,339.18c.52-.31,1.06-.6,1.61-.88-1.36,2.24-.86,4.64,6.84,5.09,15.07.88-4,15.28-4,15.28S33.69,354,31,358.1Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.55,354.12c-2.26-.25-3.38-2.58-2.5-5.2s3.42-4.53,5.69-4.27,3.38,2.58,2.5,5.19S34.81,354.37,32.55,354.12Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.39,366.12c.74-5.59,25.2-21.09,25.2-21.09s5.43-2.17,3.63-6a29.39,29.39,0,0,1,2.61,1.69q.86.62,1.59,1.26c7.29,6.31,7.29,14.59,0,20.91q-.73.65-1.59,1.26a28.06,28.06,0,0,1-2.42,1.57c-.83.49-1.7.94-2.59,1.36-.72.34-1.46.66-2.21.95s-1.51.57-2.29.83a48.9,48.9,0,0,1-7.3,1.75c-.54.09-1.09.17-1.64.24a57.24,57.24,0,0,1-7.3.46,56.33,56.33,0,0,1-8.93-.73S57.09,369.8,56.39,366.12Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.39,366.12c.74-5.59,25.2-21.09,25.2-21.09s5.43-2.17,3.63-6a29.39,29.39,0,0,1,2.61,1.69q.86.62,1.59,1.26c7.29,6.31,7.29,14.59,0,20.91q-.73.65-1.59,1.26a28.06,28.06,0,0,1-2.42,1.57c-.83.49-1.7.94-2.59,1.36-.72.34-1.46.66-2.21.95s-1.51.57-2.29.83a48.9,48.9,0,0,1-7.3,1.75c-.54.09-1.09.17-1.64.24a57.24,57.24,0,0,1-7.3.46,56.33,56.33,0,0,1-8.93-.73S57.09,369.8,56.39,366.12Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.44,342.52c9.13,5.27,9.5,13.67,1.12,19.2-.36.23-.73.46-1.12.69-9.51,5.49-24.93,5.49-34.44,0s-9.52-14.4,0-19.89c.39-.22.79-.44,1.2-.65C55.76,337,70.32,337.25,79.44,342.52Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.44,342.52c9.13,5.27,9.5,13.67,1.12,19.2-.36.23-.73.46-1.12.69-9.51,5.49-24.93,5.49-34.44,0s-9.52-14.4,0-19.89c.39-.22.79-.44,1.2-.65C55.76,337,70.32,337.25,79.44,342.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.21,
    cy: 352.46,
    rx: 23.28,
    ry: 13.44,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.21,
    cy: 352.46,
    rx: 23.28,
    ry: 13.44,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.67,346.71c-9.09-5.25-23.83-5.25-32.93,0-3.72,2.14-5.91,4.84-6.59,7.63.68,2.79,2.87,5.48,6.59,7.63,9.1,5.25,23.84,5.25,32.93,0,3.72-2.15,5.92-4.84,6.59-7.63C84.59,351.55,82.39,348.85,78.67,346.71Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.67,346.71c-9.09-5.25-23.83-5.25-32.93,0-3.72,2.14-5.91,4.84-6.59,7.63.68,2.79,2.87,5.48,6.59,7.63,9.1,5.25,23.84,5.25,32.93,0,3.72-2.15,5.92-4.84,6.59-7.63C84.59,351.55,82.39,348.85,78.67,346.71Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.41,353.18V356l-17.16,9.9-.88,0-3.72-2.18V361.2a9.68,9.68,0,0,0-1.11-.74c-.64-.36-1.42-.74-2.19-1.15l-2.2,1.27-3.67-2.12v-1.89c-.91-.44-1.77-.88-2.53-1.33-2-1.13-3-2.44-3-3.79,0-.46,0-2.27,0-2.74a3.35,3.35,0,0,1,.72-2,9.33,9.33,0,0,1,3-2.46,16.19,16.19,0,0,1,13.62-1.51c.52.17,1,.37,1.6.6v2.76l-3.14,3.14c-3.23-1.41-5.56-1.27-7.69,0a6.1,6.1,0,0,0-.84.58,7.33,7.33,0,0,0,1.15.8,35.53,35.53,0,0,0,3.2,1.58L63.8,348l3.68,2.12v2.77l-4.19,2.42c1.28.78,2.2,1.66,1.86,2.47L71,354.39l6.24-3.6Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.15,357.78c.37-.88-.74-1.83-2.19-2.67-.54-.31-1.32-.68-2.23-1.09l6.75-3.89L63.8,348l-7.25,4.19c-1.25-.57-2.4-1.11-3.21-1.58-2.56-1.48-2.53-2.86-.3-4.15s4.45-1.36,7.69,0l3.14-3.13a16.27,16.27,0,0,0-15.21.91c-4.79,2.77-4.79,5.85-.71,8.2,1.25.72,2.76,1.44,4.32,2.18l-1.79,1,3.67,2.13,2.2-1.27c.77.41,1.55.78,2.19,1.15,1.89,1.09,2.63,1.95,1.11,3.25l4.15,2.4,17.61-10.17-4.15-2.39L71,354.39Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.15,357.78c.37-.88-.74-1.83-2.19-2.67-.54-.31-1.32-.68-2.23-1.09l6.75-3.89L63.8,348l-7.25,4.19c-1.25-.57-2.4-1.11-3.21-1.58-2.56-1.48-2.53-2.86-.3-4.15s4.45-1.36,7.69,0l3.14-3.13a16.27,16.27,0,0,0-15.21.91c-4.79,2.77-4.79,5.85-.71,8.2,1.25.72,2.76,1.44,4.32,2.18l-1.79,1,3.67,2.13,2.2-1.27c.77.41,1.55.78,2.19,1.15,1.89,1.09,2.63,1.95,1.11,3.25l4.15,2.4,17.61-10.17-4.15-2.39L71,354.39Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.65,344.92a16.65,16.65,0,0,1,15.18-1.36l-2.1,2.94,3.14-3.13a16.27,16.27,0,0,0-15.21.91C48.29,344.5,48,344.71,47.65,344.92Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.55 352.19 63.85 348.44 67.48 350.13 63.8 348 56.55 352.19",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.15 357.78 77.37 351.54 81.41 353.18 77.26 350.79 65.15 357.78",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.15 357.82 51.63 355.71 52.27 354.66 50.48 355.69 54.15 357.82",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.66,358.72a12.83,12.83,0,0,0-4.31-2.17c.77.41,1.55.78,2.19,1.15,1.89,1.09,2.63,1.95,1.11,3.25l4.15,2.4-3.29-2.51A1.32,1.32,0,0,0,60.66,358.72Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.13 348.91 32.02 342.19 32.9 348.91 44.56 349.43 32.9 349.94 32.02 356.67 31.13 349.94 19.48 349.43 31.13 348.91",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lira--inject-93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.65,365.26a22.72,22.72,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.75,0a22.72,22.72,0,0,1,8.4,7.77h1.9v7.19h0c-.25,5-3.67,9.95-10.27,13.76-13.74,7.93-36,7.93-49.75,0-6.6-3.81-10.05-8.77-10.3-13.76h0v-7.19Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.65,365.26a22.72,22.72,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.75,0a22.72,22.72,0,0,1,8.4,7.77h1.9v7.19h0c-.25,5-3.67,9.95-10.27,13.76-13.74,7.93-36,7.93-49.75,0-6.6-3.81-10.05-8.77-10.3-13.76h0v-7.19Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.92,351.54c9,0,18,2,24.88,5.95a22.8,22.8,0,0,1,8.4,7.77h1.9v7.19h0c-.25,5-3.67,9.95-10.27,13.76-6.87,4-15.88,6-24.88,6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.13,354.84a38.3,38.3,0,0,1,5.67,2.65,22.8,22.8,0,0,1,8.4,7.77h1.9v7.19h0c-.25,5-3.67,9.95-10.27,13.76a38.3,38.3,0,0,1-5.67,2.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.71,354.84a38.66,38.66,0,0,0-5.66,2.65,22.72,22.72,0,0,0-8.4,7.77h-1.9v7.19h0c.25,5,3.7,9.95,10.3,13.76a38.66,38.66,0,0,0,5.66,2.65Z",
    style: {
      fill: "#1E75FE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.8,350.9c13.73,7.94,13.73,20.79,0,28.72-12,6.94-30.57,7.81-44.23,2.61h0L409,382a37.5,37.5,0,0,1-5-2.39c-11.45-6.61-13.36-16.65-5.7-24.4h0a26.91,26.91,0,0,1,5.7-4.31C417.79,343,440.06,343,453.8,350.9Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.8,350.9c13.73,7.94,13.73,20.79,0,28.72-12,6.94-30.57,7.81-44.23,2.61h0L409,382a37.5,37.5,0,0,1-5-2.39c-11.45-6.61-13.36-16.65-5.7-24.4h0a26.91,26.91,0,0,1,5.7-4.31C417.79,343,440.06,343,453.8,350.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.35,355.22a15.34,15.34,0,0,0-3.68,12.53c1.21,7,11,12.85,14.36,14.26a37.5,37.5,0,0,1-5-2.39C392.6,373,390.69,363,398.35,355.22Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.5,375.31a15.39,15.39,0,0,0,3.68-12.53c-1.22-7-11-12.85-14.36-14.26a36.79,36.79,0,0,1,5,2.39C465.25,357.52,467.15,367.56,459.5,375.31Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 428.94,
    cy: 365.24,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 428.94,
    cy: 365.24,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.73,370.87c-2.63-4.85-1.78-10.21,2.56-14.75a23,23,0,0,1,2.77-2.43,30.38,30.38,0,0,1,2.65-1.74c.52-.31,1.06-.6,1.61-.87-1.36,2.23-.86,4.63,6.84,5.08,15.07.88-4,15.28-4,15.28S400.42,366.75,397.73,370.87Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.28,366.89c-2.26-.25-3.38-2.58-2.5-5.19s3.42-4.54,5.68-4.28,3.39,2.58,2.51,5.19S401.54,367.14,399.28,366.89Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.12,378.89c.74-5.59,25.2-21.09,25.2-21.09s5.43-2.17,3.63-6a27.35,27.35,0,0,1,2.61,1.7,18.68,18.68,0,0,1,1.59,1.25c7.28,6.31,7.29,14.59,0,20.91-.49.43-1,.85-1.59,1.26-.75.54-1.55,1.07-2.42,1.58s-1.7.93-2.6,1.35c-.71.34-1.45.66-2.2.95s-1.51.57-2.29.83a47.7,47.7,0,0,1-7.3,1.75l-1.64.24a57.24,57.24,0,0,1-7.3.46,56.33,56.33,0,0,1-8.93-.73S423.82,382.57,423.12,378.89Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.12,378.89c.74-5.59,25.2-21.09,25.2-21.09s5.43-2.17,3.63-6a27.35,27.35,0,0,1,2.61,1.7,18.68,18.68,0,0,1,1.59,1.25c7.28,6.31,7.29,14.59,0,20.91-.49.43-1,.85-1.59,1.26-.75.54-1.55,1.07-2.42,1.58s-1.7.93-2.6,1.35c-.71.34-1.45.66-2.2.95s-1.51.57-2.29.83a47.7,47.7,0,0,1-7.3,1.75l-1.64.24a57.24,57.24,0,0,1-7.3.46,56.33,56.33,0,0,1-8.93-.73S423.82,382.57,423.12,378.89Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.17,355.29c9.13,5.27,9.5,13.67,1.12,19.2-.36.23-.73.47-1.12.69-9.51,5.49-24.93,5.49-34.44,0s-9.52-14.4,0-19.89c.39-.22.79-.44,1.2-.64C422.49,349.81,437.05,350,446.17,355.29Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.17,355.29c9.13,5.27,9.5,13.67,1.12,19.2-.36.23-.73.47-1.12.69-9.51,5.49-24.93,5.49-34.44,0s-9.52-14.4,0-19.89c.39-.22.79-.44,1.2-.64C422.49,349.81,437.05,350,446.17,355.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.4,355.73c9.09,5.25,9.09,13.76,0,19s-23.84,5.25-32.93,0-9.09-13.76,0-19S436.31,350.48,445.4,355.73Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.4,355.73c9.09,5.25,9.09,13.76,0,19s-23.84,5.25-32.93,0-9.09-13.76,0-19S436.31,350.48,445.4,355.73Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.4,359.48c-9.09-5.25-23.84-5.25-32.93,0-3.72,2.15-5.91,4.84-6.59,7.63.68,2.79,2.87,5.48,6.59,7.63,9.09,5.25,23.84,5.25,32.93,0,3.72-2.15,5.91-4.84,6.59-7.63C451.31,364.32,449.12,361.63,445.4,359.48Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.4,359.48c-9.09-5.25-23.84-5.25-32.93,0-3.72,2.15-5.91,4.84-6.59,7.63.68,2.79,2.87,5.48,6.59,7.63,9.09,5.25,23.84,5.25,32.93,0,3.72-2.15,5.91-4.84,6.59-7.63C451.31,364.32,449.12,361.63,445.4,359.48Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.23,360l-5.73,1.85v2.76A6.73,6.73,0,0,1,440,366.3a7.31,7.31,0,0,1-2.67,2.31l-1.3.75-3.28-1.9L434,366.3v-2.77l-4.15-2.39L426.73,364l-.1-.06,1.29-1.16V360l-4.18-2.41-3.17,2.84-4.81-2.78-4.89,2.82v2.76l4,2.33v2.76l4.15,2.4,1.86-1.69.11.07v2.76l4.18,2.41,1.87-1.68,8.4,4.85,6.39-3.7c3.65-2.1,5.15-4.24,5.14-6.26,0-.47,0-2.32,0-2.78C447,363,446,361.41,444.23,360Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.23,360c3.83,3.19,4.32,7.16-2.36,11l-6.39,3.69-8.4-4.85-1.87,1.69L421,369.09l1.86-1.68-2-1.14L419.06,368l-4.15-2.4,1.87-1.68-5.91-3.41,4.89-2.82,4.81,2.78,3.17-2.84,4.18,2.41-3.16,2.84,2,1.14,3.16-2.84,4.15,2.39-3.13,2.86,5.13,3,1.3-.75c4.57-2.64,3.27-5,1.16-6.8Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.23,360c3.83,3.19,4.32,7.16-2.36,11l-6.39,3.69-8.4-4.85-1.87,1.69L421,369.09l1.86-1.68-2-1.14L419.06,368l-4.15-2.4,1.87-1.68-5.91-3.41,4.89-2.82,4.81,2.78,3.17-2.84,4.18,2.41-3.16,2.84,2,1.14,3.16-2.84,4.15,2.39-3.13,2.86,5.13,3,1.3-.75c4.57-2.64,3.27-5,1.16-6.8Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.87 360.47 416.01 358.37 420.57 360.43 415.76 357.65 410.87 360.47",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.74 357.59 426.89 360.11 424.75 362.84 427.92 360 423.74 357.59",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.89 361.14 433.1 363.54 430.91 366.39 434.04 363.53 429.89 361.14",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.87,371c6.68-3.86,6.19-7.83,2.36-11l-5.73,1.85,5.72-1.34a7.81,7.81,0,0,1,2.26,3.48C447,366,444.79,369.3,441.87,371Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.89 367.41 421.73 369.08 425.21 371.51 421.03 369.09 422.89 367.41",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.78 363.88 415.72 365.47 419.06 367.96 414.91 365.56 416.78 363.88",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.94,356.66a22.8,22.8,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.74,0a22.84,22.84,0,0,1,8.41,7.77h1.9v7.19h0c-.25,5-3.67,9.95-10.28,13.76-13.73,7.93-36,7.93-49.74,0-6.6-3.81-10-8.76-10.3-13.76h0v-7.19Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.94,356.66a22.8,22.8,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.74,0a22.84,22.84,0,0,1,8.41,7.77h1.9v7.19h0c-.25,5-3.67,9.95-10.28,13.76-13.73,7.93-36,7.93-49.74,0-6.6-3.81-10-8.76-10.3-13.76h0v-7.19Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.21,343c9,0,18,2,24.87,5.94a22.84,22.84,0,0,1,8.41,7.77h1.9v7.19h0c-.25,5-3.67,9.95-10.28,13.76-6.86,4-15.87,5.95-24.87,5.95Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.42,346.24a39.22,39.22,0,0,1,5.66,2.65,22.84,22.84,0,0,1,8.41,7.77h1.9v7.19h0c-.25,5-3.67,9.95-10.28,13.76a37.2,37.2,0,0,1-5.66,2.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,346.24a39.73,39.73,0,0,0-5.66,2.65,22.8,22.8,0,0,0-8.4,7.77H390v7.19h0c.25,5,3.7,9.95,10.3,13.76a37.66,37.66,0,0,0,5.66,2.65Z",
    style: {
      fill: "#1E75FE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.08,342.31c13.74,7.93,13.74,20.79,0,28.72-12,6.94-30.57,7.8-44.22,2.6h0l-.55-.21a39.3,39.3,0,0,1-5-2.39c-11.45-6.62-13.36-16.66-5.71-24.41h0a26.58,26.58,0,0,1,5.7-4.31C414.08,334.38,436.35,334.38,450.08,342.31Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.08,342.31c13.74,7.93,13.74,20.79,0,28.72-12,6.94-30.57,7.8-44.22,2.6h0l-.55-.21a39.3,39.3,0,0,1-5-2.39c-11.45-6.62-13.36-16.66-5.71-24.41h0a26.58,26.58,0,0,1,5.7-4.31C414.08,334.38,436.35,334.38,450.08,342.31Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.63,346.62A15.4,15.4,0,0,0,391,359.15c1.21,7,11,12.86,14.35,14.27a39.3,39.3,0,0,1-5-2.39C388.89,364.41,387,354.37,394.63,346.62Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.79,366.71a15.36,15.36,0,0,0,3.68-12.53c-1.22-7-11-12.85-14.36-14.26a36.79,36.79,0,0,1,5,2.39C461.54,348.92,463.44,359,455.79,366.71Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 425.23,
    cy: 356.64,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 425.23,
    cy: 356.64,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,362.28c-2.62-4.86-1.77-10.22,2.57-14.76a21.44,21.44,0,0,1,2.77-2.42,27,27,0,0,1,2.65-1.75c.52-.3,1.06-.59,1.61-.87-1.36,2.23-.86,4.63,6.84,5.08,15.07.88-4,15.28-4,15.28S396.71,358.15,394,362.28Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 397.16,
    cy: 353.56,
    rx: 5.18,
    ry: 3.88,
    transform: "translate(-123.81 460) rotate(-53.22)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.41,370.3c.74-5.6,25.2-21.09,25.2-21.09s5.42-2.18,3.62-6a27.49,27.49,0,0,1,2.62,1.69c.57.41,1.09.83,1.59,1.26,7.28,6.3,7.29,14.59,0,20.9q-.75.65-1.59,1.26a28.31,28.31,0,0,1-2.43,1.58c-.83.49-1.69.94-2.59,1.36-.71.33-1.45.65-2.2.95s-1.51.57-2.29.82a47.71,47.71,0,0,1-7.3,1.76l-1.64.23a56.36,56.36,0,0,1-16.23-.27S420.11,374,419.41,370.3Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.41,370.3c.74-5.6,25.2-21.09,25.2-21.09s5.42-2.18,3.62-6a27.49,27.49,0,0,1,2.62,1.69c.57.41,1.09.83,1.59,1.26,7.28,6.3,7.29,14.59,0,20.9q-.75.65-1.59,1.26a28.31,28.31,0,0,1-2.43,1.58c-.83.49-1.69.94-2.59,1.36-.71.33-1.45.65-2.2.95s-1.51.57-2.29.82a47.71,47.71,0,0,1-7.3,1.76l-1.64.23a56.36,56.36,0,0,1-16.23-.27S420.11,374,419.41,370.3Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.46,346.69c9.13,5.27,9.5,13.68,1.11,19.2q-.52.36-1.11.69c-9.52,5.5-24.93,5.5-34.45,0s-9.51-14.39,0-19.89c.39-.22.79-.44,1.2-.64C418.78,341.21,433.34,341.43,442.46,346.69Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.46,346.69c9.13,5.27,9.5,13.68,1.11,19.2q-.52.36-1.11.69c-9.52,5.5-24.93,5.5-34.45,0s-9.51-14.39,0-19.89c.39-.22.79-.44,1.2-.64C418.78,341.21,433.34,341.43,442.46,346.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 425.22,
    cy: 356.64,
    rx: 23.28,
    ry: 13.44,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 425.22,
    cy: 356.64,
    rx: 23.28,
    ry: 13.44,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.69,350.88c-9.09-5.25-23.84-5.25-32.93,0-3.72,2.15-5.91,4.84-6.59,7.63.68,2.79,2.87,5.49,6.59,7.63,9.09,5.25,23.83,5.25,32.93,0,3.72-2.14,5.91-4.84,6.59-7.63C447.6,355.72,445.41,353,441.69,350.88Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.69,350.88c-9.09-5.25-23.84-5.25-32.93,0-3.72,2.15-5.91,4.84-6.59,7.63.68,2.79,2.87,5.49,6.59,7.63,9.09,5.25,23.83,5.25,32.93,0,3.72-2.14,5.91-4.84,6.59-7.63C447.6,355.72,445.41,353,441.69,350.88Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.52,351.36l-5.73,1.85V356a7.08,7.08,0,0,1,1.51,1.73,7.31,7.31,0,0,1-2.67,2.31l-1.3.75-3.28-1.89,1.27-1.17v-2.76l-4.14-2.4L423,355.38l-.09-.05,1.29-1.16V351.4L420,349l-3.16,2.84-4.81-2.78-4.89,2.82v2.76l4,2.34v2.76l4.15,2.39,1.86-1.68.11.06v2.76l4.18,2.41,1.86-1.68,8.41,4.85,6.39-3.69c3.64-2.11,5.15-4.24,5.14-6.27,0-.47,0-2.32,0-2.77C443.31,354.42,442.26,352.81,440.52,351.36Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.52,351.36c3.83,3.19,4.32,7.17-2.36,11l-6.39,3.7-8.41-4.85-1.86,1.68-4.18-2.41,1.86-1.69-2-1.13-1.86,1.68L411.2,357l1.86-1.69-5.9-3.41,4.89-2.82,4.81,2.78L420,349l4.19,2.41L421,354.25l2,1.13,3.17-2.84,4.14,2.4-3.12,2.86,5.13,3,1.3-.75c4.57-2.64,3.27-5,1.16-6.8Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.52,351.36c3.83,3.19,4.32,7.17-2.36,11l-6.39,3.7-8.41-4.85-1.86,1.68-4.18-2.41,1.86-1.69-2-1.13-1.86,1.68L411.2,357l1.86-1.69-5.9-3.41,4.89-2.82,4.81,2.78L420,349l4.19,2.41L421,354.25l2,1.13,3.17-2.84,4.14,2.4-3.12,2.86,5.13,3,1.3-.75c4.57-2.64,3.27-5,1.16-6.8Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.16 351.87 412.3 349.77 416.86 351.83 412.05 349.05 407.16 351.87",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.02 348.99 423.18 351.51 421.04 354.25 424.21 351.4 420.02 348.99",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.18 352.54 429.39 354.94 427.2 357.8 430.32 354.94 426.18 352.54",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.16,362.38c6.68-3.85,6.19-7.83,2.36-11l-5.73,1.85,5.71-1.34a7.78,7.78,0,0,1,2.27,3.49C443.31,357.39,441.07,360.7,438.16,362.38Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.18 358.81 418.02 360.49 421.5 362.91 417.32 360.5 419.18 358.81",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.06 355.28 412.01 356.87 415.35 359.36 411.2 356.96 413.06 355.28",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.37,349.24a22.64,22.64,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.74,0a22.56,22.56,0,0,1,8.4,7.77h1.91v7.18h0c-.25,5-3.67,9.95-10.28,13.77-13.73,7.93-36,7.93-49.74,0-6.6-3.82-10-8.77-10.3-13.77h0v-7.18Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.37,349.24a22.64,22.64,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.74,0a22.56,22.56,0,0,1,8.4,7.77h1.91v7.18h0c-.25,5-3.67,9.95-10.28,13.77-13.73,7.93-36,7.93-49.74,0-6.6-3.82-10-8.77-10.3-13.77h0v-7.18Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.64,335.52c9,0,18,2,24.87,6a22.56,22.56,0,0,1,8.4,7.77h1.91v7.18h0c-.25,5-3.67,9.95-10.28,13.77-6.87,4-15.87,5.94-24.87,5.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.85,338.82a37.66,37.66,0,0,1,5.66,2.65,22.56,22.56,0,0,1,8.4,7.77h1.91v7.18h0c-.25,5-3.67,9.95-10.28,13.77a39.73,39.73,0,0,1-5.66,2.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.43,338.82a37.66,37.66,0,0,0-5.66,2.65,22.64,22.64,0,0,0-8.4,7.77h-1.9v7.18h0c.25,5,3.7,9.95,10.3,13.77a39.73,39.73,0,0,0,5.66,2.65Z",
    style: {
      fill: "#1E75FE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.51,334.88c13.74,7.93,13.74,20.79,0,28.72-12,6.94-30.57,7.81-44.22,2.6h0l-.55-.21a38.65,38.65,0,0,1-5-2.39c-11.45-6.61-13.36-16.65-5.71-24.4h0a26.91,26.91,0,0,1,5.7-4.31C422.51,327,444.78,327,458.51,334.88Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.51,334.88c13.74,7.93,13.74,20.79,0,28.72-12,6.94-30.57,7.81-44.22,2.6h0l-.55-.21a38.65,38.65,0,0,1-5-2.39c-11.45-6.61-13.36-16.65-5.71-24.4h0a26.91,26.91,0,0,1,5.7-4.31C422.51,327,444.78,327,458.51,334.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.06,339.2a15.36,15.36,0,0,0-3.67,12.52c1.21,7,11,12.86,14.35,14.27a38.65,38.65,0,0,1-5-2.39C397.32,357,395.41,347,403.06,339.2Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.22,359.29a15.39,15.39,0,0,0,3.68-12.53c-1.22-7-11-12.86-14.36-14.27a38,38,0,0,1,5,2.39C470,341.49,471.87,351.53,464.22,359.29Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 433.66,
    cy: 349.21,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 433.66,
    cy: 349.21,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.44,354.85c-2.63-4.86-1.77-10.21,2.57-14.75a21.48,21.48,0,0,1,2.77-2.43,27,27,0,0,1,2.65-1.75c.52-.3,1.05-.59,1.61-.87-1.36,2.24-.86,4.63,6.84,5.08,15.07.88-4,15.28-4,15.28S405.14,350.73,402.44,354.85Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 405.59,
    cy: 346.13,
    rx: 5.18,
    ry: 3.88,
    transform: "translate(-114.48 463.76) rotate(-53.22)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.83,362.87c.75-5.6,25.21-21.09,25.21-21.09s5.42-2.18,3.62-6a27.49,27.49,0,0,1,2.62,1.69q.84.62,1.59,1.26c7.28,6.31,7.29,14.59,0,20.9q-.75.64-1.59,1.26a26.1,26.1,0,0,1-2.43,1.58c-.83.49-1.69.94-2.59,1.36-.71.34-1.45.65-2.2.95s-1.51.57-2.3.83a48.48,48.48,0,0,1-7.29,1.75q-.83.14-1.65.24a57,57,0,0,1-7.29.46,55.09,55.09,0,0,1-8.93-.74S428.53,366.55,427.83,362.87Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.83,362.87c.75-5.6,25.21-21.09,25.21-21.09s5.42-2.18,3.62-6a27.49,27.49,0,0,1,2.62,1.69q.84.62,1.59,1.26c7.28,6.31,7.29,14.59,0,20.9q-.75.64-1.59,1.26a26.1,26.1,0,0,1-2.43,1.58c-.83.49-1.69.94-2.59,1.36-.71.34-1.45.65-2.2.95s-1.51.57-2.3.83a48.48,48.48,0,0,1-7.29,1.75q-.83.14-1.65.24a57,57,0,0,1-7.29.46,55.09,55.09,0,0,1-8.93-.74S428.53,366.55,427.83,362.87Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.89,339.27c9.13,5.27,9.5,13.67,1.11,19.2-.35.23-.73.46-1.11.69-9.52,5.49-24.93,5.49-34.45,0s-9.51-14.4,0-19.89c.39-.23.79-.44,1.19-.65C427.2,333.78,441.77,334,450.89,339.27Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.89,339.27c9.13,5.27,9.5,13.67,1.11,19.2-.35.23-.73.46-1.11.69-9.52,5.49-24.93,5.49-34.45,0s-9.51-14.4,0-19.89c.39-.23.79-.44,1.19-.65C427.2,333.78,441.77,334,450.89,339.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 433.65,
    cy: 349.21,
    rx: 23.28,
    ry: 13.44,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 433.65,
    cy: 349.21,
    rx: 23.28,
    ry: 13.44,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.12,343.46c-9.1-5.25-23.84-5.25-32.93,0-3.72,2.14-5.91,4.83-6.59,7.63.68,2.79,2.87,5.48,6.59,7.63,9.09,5.25,23.83,5.25,32.93,0,3.72-2.15,5.91-4.84,6.59-7.63C456,348.29,453.84,345.6,450.12,343.46Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.12,343.46c-9.1-5.25-23.84-5.25-32.93,0-3.72,2.14-5.91,4.83-6.59,7.63.68,2.79,2.87,5.48,6.59,7.63,9.09,5.25,23.83,5.25,32.93,0,3.72-2.15,5.91-4.84,6.59-7.63C456,348.29,453.84,345.6,450.12,343.46Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,343.94l-5.73,1.84v2.77a7.07,7.07,0,0,1,1.51,1.72,7.31,7.31,0,0,1-2.67,2.31l-1.3.75-3.28-1.89,1.27-1.17v-2.76l-4.14-2.4L431.44,348l-.09-.06,1.29-1.16V344l-4.19-2.42-3.16,2.84-4.82-2.78-4.88,2.82v2.77l4,2.33v2.76l4.15,2.39,1.86-1.68.11.06v2.76l4.18,2.42,1.86-1.69,8.4,4.85,6.4-3.69c3.64-2.1,5.15-4.24,5.14-6.27,0-.47,0-2.31,0-2.77C451.74,347,450.69,345.38,449,343.94Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,343.94c3.83,3.18,4.32,7.16-2.36,11l-6.4,3.69-8.4-4.85-1.86,1.68-4.18-2.41,1.86-1.69-2-1.13-1.86,1.68-4.15-2.39,1.86-1.69-5.9-3.41,4.88-2.82,4.82,2.78,3.16-2.84,4.19,2.42-3.17,2.84,2,1.14,3.17-2.85,4.14,2.4-3.12,2.86,5.13,3,1.3-.75c4.57-2.64,3.27-5,1.16-6.8Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,343.94c3.83,3.18,4.32,7.16-2.36,11l-6.4,3.69-8.4-4.85-1.86,1.68-4.18-2.41,1.86-1.69-2-1.13-1.86,1.68-4.15-2.39,1.86-1.69-5.9-3.41,4.88-2.82,4.82,2.78,3.16-2.84,4.19,2.42-3.17,2.84,2,1.14,3.17-2.85,4.14,2.4-3.12,2.86,5.13,3,1.3-.75c4.57-2.64,3.27-5,1.16-6.8Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.59 344.44 420.72 342.34 425.29 344.4 420.48 341.62 415.59 344.44",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.45 341.56 431.61 344.09 429.47 346.82 432.64 343.98 428.45 341.56",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.61 345.11 437.81 347.51 435.63 350.37 438.75 347.51 434.61 345.11",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.59,355c6.68-3.86,6.19-7.84,2.36-11l-5.73,1.84,5.71-1.34a7.85,7.85,0,0,1,2.27,3.49C451.74,350,449.5,353.28,446.59,355Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.61 351.38 426.45 353.06 429.93 355.48 425.75 353.07 427.61 351.38",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.49 347.85 420.44 349.45 423.78 351.93 419.63 349.54 421.49 347.85",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.62 345.67 403.5 338.94 404.39 345.67 416.04 346.18 404.39 346.69 403.5 353.42 402.62 346.69 390.96 346.18 402.62 345.67",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rupee--inject-93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.23,425.81a22.64,22.64,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.75,0a22.64,22.64,0,0,1,8.4,7.77h1.9V433h0c-.25,5-3.67,9.95-10.27,13.76-13.74,7.94-36,7.94-49.75,0-6.6-3.81-10.05-8.76-10.3-13.76h0v-7.18Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.23,425.81a22.64,22.64,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.75,0a22.64,22.64,0,0,1,8.4,7.77h1.9V433h0c-.25,5-3.67,9.95-10.27,13.76-13.74,7.94-36,7.94-49.75,0-6.6-3.81-10.05-8.76-10.3-13.76h0v-7.18Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.5,412.09c9,0,18,2,24.88,6a22.64,22.64,0,0,1,8.4,7.77h1.9V433h0c-.25,5-3.67,9.95-10.27,13.76-6.87,4-15.88,5.95-24.88,5.95Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.71,415.38a38.34,38.34,0,0,1,5.67,2.66,22.64,22.64,0,0,1,8.4,7.77h1.9V433h0c-.25,5-3.67,9.95-10.27,13.76a38.34,38.34,0,0,1-5.67,2.66Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.29,415.38a38.7,38.7,0,0,0-5.66,2.66,22.64,22.64,0,0,0-8.4,7.77h-1.9V433h0c.25,5,3.7,9.95,10.3,13.76a38.7,38.7,0,0,0,5.66,2.66Z",
    style: {
      fill: "#1E75FE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.38,411.45c13.73,7.93,13.73,20.79,0,28.72-12,6.94-30.57,7.81-44.23,2.6h0l-.54-.21a38.79,38.79,0,0,1-5-2.39c-11.45-6.61-13.35-16.65-5.7-24.41h0a26.91,26.91,0,0,1,5.7-4.31C369.37,403.52,391.64,403.52,405.38,411.45Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.38,411.45c13.73,7.93,13.73,20.79,0,28.72-12,6.94-30.57,7.81-44.23,2.6h0l-.54-.21a38.79,38.79,0,0,1-5-2.39c-11.45-6.61-13.35-16.65-5.7-24.41h0a26.91,26.91,0,0,1,5.7-4.31C369.37,403.52,391.64,403.52,405.38,411.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.93,415.76a15.36,15.36,0,0,0-3.68,12.53c1.21,7,11,12.86,14.36,14.27a38.79,38.79,0,0,1-5-2.39C344.18,433.56,342.28,423.52,349.93,415.76Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.08,435.85a15.35,15.35,0,0,0,3.68-12.52c-1.22-7-11-12.86-14.36-14.27a37.5,37.5,0,0,1,5,2.39C416.83,418.06,418.73,428.1,411.08,435.85Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 380.34,
    cy: 425.78,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 380.34,
    cy: 425.78,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.12,431.42c-2.63-4.86-1.77-10.21,2.57-14.76a21.44,21.44,0,0,1,2.77-2.42,27,27,0,0,1,2.65-1.75c.52-.3,1.05-.59,1.61-.87-1.36,2.24-.86,4.63,6.84,5.08,15.07.88-4,15.28-4,15.28S351.82,427.29,349.12,431.42Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.68,427.44c-2.26-.26-3.38-2.58-2.51-5.2s3.43-4.53,5.69-4.28,3.38,2.58,2.5,5.2S352.94,427.69,350.68,427.44Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.51,439.44c.75-5.6,25.21-21.09,25.21-21.09s5.42-2.18,3.62-6a27.49,27.49,0,0,1,2.62,1.69q.84.62,1.59,1.26c7.28,6.31,7.29,14.59,0,20.9q-.75.64-1.59,1.26a28.31,28.31,0,0,1-2.43,1.58c-.83.49-1.69.94-2.59,1.36-.71.34-1.45.65-2.2.95s-1.51.57-2.3.83a48.48,48.48,0,0,1-7.29,1.75q-.82.14-1.65.24a55.2,55.2,0,0,1-7.29.45,54,54,0,0,1-8.93-.73S375.21,443.12,374.51,439.44Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.51,439.44c.75-5.6,25.21-21.09,25.21-21.09s5.42-2.18,3.62-6a27.49,27.49,0,0,1,2.62,1.69q.84.62,1.59,1.26c7.28,6.31,7.29,14.59,0,20.9q-.75.64-1.59,1.26a28.31,28.31,0,0,1-2.43,1.58c-.83.49-1.69.94-2.59,1.36-.71.34-1.45.65-2.2.95s-1.51.57-2.3.83a48.48,48.48,0,0,1-7.29,1.75q-.82.14-1.65.24a55.2,55.2,0,0,1-7.29.45,54,54,0,0,1-8.93-.73S375.21,443.12,374.51,439.44Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.57,415.84c9.13,5.26,9.5,13.67,1.11,19.19-.35.24-.73.47-1.11.69-9.52,5.5-24.93,5.5-34.45,0s-9.51-14.39,0-19.88c.39-.23.79-.44,1.19-.65C373.88,410.35,388.45,410.57,397.57,415.84Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.57,415.84c9.13,5.26,9.5,13.67,1.11,19.19-.35.24-.73.47-1.11.69-9.52,5.5-24.93,5.5-34.45,0s-9.51-14.39,0-19.88c.39-.23.79-.44,1.19-.65C373.88,410.35,388.45,410.57,397.57,415.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 380.33,
    cy: 425.78,
    rx: 23.28,
    ry: 13.44,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 380.33,
    cy: 425.78,
    rx: 23.28,
    ry: 13.44,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.8,420c-9.1-5.25-23.84-5.25-32.93,0-3.72,2.15-5.92,4.84-6.59,7.63.67,2.8,2.87,5.49,6.59,7.64,9.09,5.25,23.83,5.25,32.93,0,3.72-2.15,5.91-4.84,6.59-7.64C402.71,424.86,400.52,422.17,396.8,420Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.8,420c-9.1-5.25-23.84-5.25-32.93,0-3.72,2.15-5.92,4.84-6.59,7.63.67,2.8,2.87,5.49,6.59,7.64,9.09,5.25,23.83,5.25,32.93,0,3.72-2.15,5.91-4.84,6.59-7.64C402.71,424.86,400.52,422.17,396.8,420Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.88,429.38a3.82,3.82,0,0,0,.33-1.57c0-.44,0-2.28,0-2.76a3.33,3.33,0,0,0-.45-1.64l2.33-1.35V419.3l-3.38-1.95-2,1.13v-2.26l-3.38-2-17,9.8v2.76l3.38,1.95,2-1.13v2.27l3.38,1.95,8.68-5,.18.18a7.73,7.73,0,0,1-1.8,1.36l-3.08,1.77v2.77l3.55,2.05,14.3,1,1.4.1,5.13-3v-2.76l-6.54-.45Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.75,416.22l-3.38-2-17,9.8,3.38,1.95,3.85-2.22a10.54,10.54,0,0,1,5.09-1.61,6.57,6.57,0,0,1,1.4.12l-8.38,4.84,3.38,2,8.68-5c1.63,1.48.73,2.94-1.62,4.3l-3.08,1.77,3.55,2,14.3,1,1.4.09,5.13-3-6.54-.45-9.14-.62c2.8-2.34,3.53-5.31.28-7.62l4-2.32-3.38-1.95-4.32,2.49a11.68,11.68,0,0,0-2.78-.56v-.1Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.75,416.22l-3.38-2-17,9.8,3.38,1.95,3.85-2.22a10.54,10.54,0,0,1,5.09-1.61,6.57,6.57,0,0,1,1.4.12l-8.38,4.84,3.38,2,8.68-5c1.63,1.48.73,2.94-1.62,4.3l-3.08,1.77,3.55,2,14.3,1,1.4.09,5.13-3-6.54-.45-9.14-.62c2.8-2.34,3.53-5.31.28-7.62l4-2.32-3.38-1.95-4.32,2.49a11.68,11.68,0,0,0-2.78-.56v-.1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.39 424.07 377.32 414.91 380.75 416.21 377.37 414.26 360.39 424.07",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.39 419.84 382.74 417.94 386.09 419.3 382.71 417.35 378.39 419.84",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.79 429.24 395.94 430.67 392.33 433.27 397.47 430.31 381.79 429.24",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.79,424.09c3.49,2-.16,4.12-2.28,5.35l-1.35.77,2.48,2-3.55-2,3.08-1.77C378.52,427,379.42,425.57,377.79,424.09Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.11 429.1 366.5 427.2 374.11 422.31 365.73 427.15 369.11 429.1",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.52,414.12a22.72,22.72,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.74,0a22.72,22.72,0,0,1,8.4,7.77H417v7.19h0c-.25,5-3.67,9.95-10.28,13.76-13.73,7.93-36,7.93-49.74,0-6.61-3.81-10.05-8.76-10.3-13.76h0v-7.19Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.52,414.12a22.72,22.72,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.74,0a22.72,22.72,0,0,1,8.4,7.77H417v7.19h0c-.25,5-3.67,9.95-10.28,13.76-13.73,7.93-36,7.93-49.74,0-6.61-3.81-10.05-8.76-10.3-13.76h0v-7.19Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.79,400.41c9,0,18,2,24.87,5.94a22.64,22.64,0,0,1,8.4,7.77H417v7.19h0c-.25,5-3.67,9.95-10.28,13.76-6.87,4-15.87,5.95-24.87,5.95Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,403.7a39.73,39.73,0,0,1,5.66,2.65,22.64,22.64,0,0,1,8.4,7.77H417v7.19h0c-.25,5-3.67,9.95-10.28,13.76a37.66,37.66,0,0,1-5.66,2.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.58,403.7a39.73,39.73,0,0,0-5.66,2.65,22.72,22.72,0,0,0-8.4,7.77h-1.9v7.19h0c.25,5,3.7,9.95,10.3,13.76a37.66,37.66,0,0,0,5.66,2.65Z",
    style: {
      fill: "#1E75FE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.66,399.77c13.74,7.93,13.74,20.79,0,28.72-12,6.93-30.57,7.8-44.22,2.6h0l-.55-.21a38.65,38.65,0,0,1-5-2.39c-11.45-6.62-13.36-16.66-5.71-24.41h0a26.58,26.58,0,0,1,5.7-4.31C370.66,391.84,392.93,391.84,406.66,399.77Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.66,399.77c13.74,7.93,13.74,20.79,0,28.72-12,6.93-30.57,7.8-44.22,2.6h0l-.55-.21a38.65,38.65,0,0,1-5-2.39c-11.45-6.62-13.36-16.66-5.71-24.41h0a26.58,26.58,0,0,1,5.7-4.31C370.66,391.84,392.93,391.84,406.66,399.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.21,404.08a15.4,15.4,0,0,0-3.67,12.53c1.21,7,11,12.85,14.35,14.27a38.65,38.65,0,0,1-5-2.39C345.47,421.87,343.56,411.83,351.21,404.08Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.37,424.17a15.36,15.36,0,0,0,3.68-12.53c-1.22-7-11-12.85-14.36-14.26a37.37,37.37,0,0,1,5,2.39C418.12,406.38,420,416.42,412.37,424.17Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 381.62,
    cy: 414.1,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 381.62,
    cy: 414.1,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.41,419.74c-2.63-4.86-1.77-10.22,2.57-14.76a20.79,20.79,0,0,1,2.77-2.42,28.1,28.1,0,0,1,2.64-1.75c.53-.3,1.06-.6,1.62-.87-1.36,2.23-.87,4.63,6.84,5.08,15.06.88-4,15.28-4,15.28S353.1,415.61,350.41,419.74Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,415.75c-2.27-.25-3.39-2.58-2.51-5.19s3.43-4.53,5.69-4.28,3.38,2.58,2.5,5.2S354.23,416,352,415.75Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.8,427.76c.74-5.6,25.21-21.09,25.21-21.09s5.42-2.18,3.62-6a28.82,28.82,0,0,1,2.62,1.69q.84.62,1.59,1.26c7.28,6.3,7.29,14.59,0,20.9-.49.43-1,.85-1.58,1.26a28.31,28.31,0,0,1-2.43,1.58c-.83.48-1.7.94-2.59,1.36-.71.33-1.46.65-2.21.95s-1.51.57-2.29.82a47.43,47.43,0,0,1-7.3,1.76l-1.64.23a56.29,56.29,0,0,1-16.22-.27S376.5,431.44,375.8,427.76Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.8,427.76c.74-5.6,25.21-21.09,25.21-21.09s5.42-2.18,3.62-6a28.82,28.82,0,0,1,2.62,1.69q.84.62,1.59,1.26c7.28,6.3,7.29,14.59,0,20.9-.49.43-1,.85-1.58,1.26a28.31,28.31,0,0,1-2.43,1.58c-.83.48-1.7.94-2.59,1.36-.71.33-1.46.65-2.21.95s-1.51.57-2.29.82a47.43,47.43,0,0,1-7.3,1.76l-1.64.23a56.29,56.29,0,0,1-16.22-.27S376.5,431.44,375.8,427.76Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.86,404.15c9.12,5.27,9.49,13.68,1.11,19.2-.35.24-.73.47-1.12.69-9.51,5.49-24.93,5.49-34.44,0s-9.52-14.39,0-19.89c.38-.22.79-.44,1.19-.64C375.17,398.67,389.73,398.89,398.86,404.15Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.86,404.15c9.12,5.27,9.49,13.68,1.11,19.2-.35.24-.73.47-1.12.69-9.51,5.49-24.93,5.49-34.44,0s-9.52-14.39,0-19.89c.38-.22.79-.44,1.19-.64C375.17,398.67,389.73,398.89,398.86,404.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 381.62,
    cy: 414.1,
    rx: 23.28,
    ry: 13.44,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 381.62,
    cy: 414.1,
    rx: 23.28,
    ry: 13.44,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.08,408.34c-9.09-5.25-23.83-5.25-32.92,0-3.72,2.15-5.92,4.84-6.6,7.63.68,2.79,2.88,5.49,6.6,7.63,9.09,5.25,23.83,5.25,32.92,0,3.72-2.14,5.92-4.84,6.6-7.63C404,413.18,401.8,410.49,398.08,408.34Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.08,408.34c-9.09-5.25-23.83-5.25-32.92,0-3.72,2.15-5.92,4.84-6.6,7.63.68,2.79,2.88,5.49,6.6,7.63,9.09,5.25,23.83,5.25,32.92,0,3.72-2.14,5.92-4.84,6.6-7.63C404,413.18,401.8,410.49,398.08,408.34Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.17,417.7a3.82,3.82,0,0,0,.33-1.57c0-.44,0-2.28,0-2.76a3.47,3.47,0,0,0-.45-1.65l2.33-1.34v-2.76L384,405.67l-2,1.13v-2.27l-3.38-1.95-17,9.81v2.76l3.37,2,2-1.13v2.26l3.38,1.95,8.68-5,.17.17a7.33,7.33,0,0,1-1.79,1.36l-3.09,1.78v2.77l3.56,2.05,14.29,1,1.4.09,5.13-3v-2.76l-6.53-.45Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,404.53l-3.38-1.95-17,9.81,3.37,1.95,3.85-2.23a10.56,10.56,0,0,1,5.1-1.6,6.68,6.68,0,0,1,1.4.12L367,415.47l3.38,1.95,8.68-5c1.62,1.48.73,2.94-1.62,4.29l-3.09,1.78,3.56,2,14.29,1,1.4.09,5.13-3-6.53-.45-9.14-.62c2.8-2.35,3.53-5.31.28-7.62l4-2.32L384,405.67l-4.32,2.49a11.84,11.84,0,0,0-2.78-.57v-.09Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,404.53l-3.38-1.95-17,9.81,3.37,1.95,3.85-2.23a10.56,10.56,0,0,1,5.1-1.6,6.68,6.68,0,0,1,1.4.12L367,415.47l3.38,1.95,8.68-5c1.62,1.48.73,2.94-1.62,4.29l-3.09,1.78,3.56,2,14.29,1,1.4.09,5.13-3-6.53-.45-9.14-.62c2.8-2.35,3.53-5.31.28-7.62l4-2.32L384,405.67l-4.32,2.49a11.84,11.84,0,0,0-2.78-.57v-.09Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.68 412.38 378.6 403.23 382.03 404.53 378.65 402.58 361.68 412.38",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.68 408.16 384.02 406.25 387.38 407.62 384 405.67 379.68 408.16",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.08 417.56 397.22 418.99 393.62 421.59 398.75 418.63 383.08 417.56",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.08,412.41c3.49,2-.17,4.12-2.29,5.34l-1.34.78,2.48,2-3.56-2,3.09-1.78C379.81,415.35,380.7,413.89,379.08,412.41Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.4 417.42 367.79 415.52 375.4 410.63 367.02 415.47 370.4 417.42",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.33,405.5a22.72,22.72,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.75,0a22.72,22.72,0,0,1,8.4,7.77h1.9v7.19h0c-.25,5-3.67,9.95-10.27,13.76-13.74,7.93-36,7.93-49.75,0-6.6-3.81-10.05-8.77-10.3-13.76h0V405.5Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.33,405.5a22.72,22.72,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.75,0a22.72,22.72,0,0,1,8.4,7.77h1.9v7.19h0c-.25,5-3.67,9.95-10.27,13.76-13.74,7.93-36,7.93-49.75,0-6.6-3.81-10.05-8.77-10.3-13.76h0V405.5Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.6,391.78c9,0,18,2,24.88,6a22.72,22.72,0,0,1,8.4,7.77h1.9v7.19h0c-.25,5-3.67,9.95-10.27,13.76-6.87,4-15.87,5.95-24.88,5.95Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.82,395.08a39.73,39.73,0,0,1,5.66,2.65,22.72,22.72,0,0,1,8.4,7.77h1.9v7.19h0c-.25,5-3.67,9.95-10.27,13.76a37.66,37.66,0,0,1-5.66,2.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.4,395.08a39.34,39.34,0,0,0-5.67,2.65,22.72,22.72,0,0,0-8.4,7.77h-1.9v7.19h0c.26,5,3.7,9.95,10.3,13.76a37.32,37.32,0,0,0,5.67,2.65Z",
    style: {
      fill: "#1E75FE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.48,391.15c13.73,7.93,13.73,20.78,0,28.71-12,6.94-30.57,7.81-44.23,2.61h0l-.54-.22a37.5,37.5,0,0,1-5-2.39c-11.45-6.61-13.35-16.65-5.7-24.4h0a26.26,26.26,0,0,1,5.7-4.31C362.47,383.22,384.74,383.22,398.48,391.15Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.48,391.15c13.73,7.93,13.73,20.78,0,28.71-12,6.94-30.57,7.81-44.23,2.61h0l-.54-.22a37.5,37.5,0,0,1-5-2.39c-11.45-6.61-13.35-16.65-5.7-24.4h0a26.26,26.26,0,0,1,5.7-4.31C362.47,383.22,384.74,383.22,398.48,391.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,395.46A15.39,15.39,0,0,0,339.35,408c1.22,7,11,12.85,14.36,14.26a37.5,37.5,0,0,1-5-2.39C337.28,413.25,335.38,403.21,343,395.46Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.18,415.55A15.38,15.38,0,0,0,407.86,403c-1.22-7-11-12.85-14.36-14.26a37.5,37.5,0,0,1,5,2.39C409.93,397.76,411.83,407.8,404.18,415.55Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 373.44,
    cy: 405.48,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 373.44,
    cy: 405.48,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.22,411.12c-2.62-4.86-1.77-10.22,2.57-14.76a22.27,22.27,0,0,1,2.77-2.43,28.94,28.94,0,0,1,2.65-1.74c.52-.31,1.06-.6,1.61-.87-1.36,2.23-.86,4.63,6.84,5.08,15.07.88-4,15.28-4,15.28S344.92,407,342.22,411.12Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.78,407.13c-2.26-.25-3.38-2.58-2.5-5.19s3.42-4.53,5.68-4.28,3.38,2.58,2.51,5.19S346,407.38,343.78,407.13Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.62,419.13c.74-5.59,25.2-21.09,25.2-21.09s5.42-2.17,3.62-6a27.49,27.49,0,0,1,2.62,1.69c.57.41,1.09.82,1.59,1.26,7.28,6.3,7.29,14.59,0,20.9q-.75.65-1.59,1.26a28.31,28.31,0,0,1-2.43,1.58c-.83.48-1.69.93-2.59,1.35-.71.34-1.45.66-2.2.95s-1.51.58-2.29.83a47.7,47.7,0,0,1-7.3,1.75l-1.64.24a55.47,55.47,0,0,1-7.3.46,56.24,56.24,0,0,1-8.93-.73S368.32,422.81,367.62,419.13Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.62,419.13c.74-5.59,25.2-21.09,25.2-21.09s5.42-2.17,3.62-6a27.49,27.49,0,0,1,2.62,1.69c.57.41,1.09.82,1.59,1.26,7.28,6.3,7.29,14.59,0,20.9q-.75.65-1.59,1.26a28.31,28.31,0,0,1-2.43,1.58c-.83.48-1.69.93-2.59,1.35-.71.34-1.45.66-2.2.95s-1.51.58-2.29.83a47.7,47.7,0,0,1-7.3,1.75l-1.64.24a55.47,55.47,0,0,1-7.3.46,56.24,56.24,0,0,1-8.93-.73S368.32,422.81,367.62,419.13Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.67,395.53c9.13,5.27,9.5,13.68,1.11,19.2q-.52.36-1.11.69c-9.52,5.49-24.93,5.49-34.45,0s-9.51-14.4,0-19.89c.39-.22.79-.44,1.2-.64C367,390.05,381.55,390.26,390.67,395.53Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.67,395.53c9.13,5.27,9.5,13.68,1.11,19.2q-.52.36-1.11.69c-9.52,5.49-24.93,5.49-34.45,0s-9.51-14.4,0-19.89c.39-.22.79-.44,1.2-.64C367,390.05,381.55,390.26,390.67,395.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 373.43,
    cy: 405.48,
    rx: 23.28,
    ry: 13.44,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 373.43,
    cy: 405.48,
    rx: 23.28,
    ry: 13.44,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.9,399.72c-9.09-5.25-23.84-5.25-32.93,0-3.72,2.15-5.91,4.84-6.59,7.63.68,2.79,2.87,5.49,6.59,7.63,9.09,5.25,23.84,5.25,32.93,0,3.72-2.14,5.91-4.84,6.59-7.63C395.81,404.56,393.62,401.87,389.9,399.72Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.9,399.72c-9.09-5.25-23.84-5.25-32.93,0-3.72,2.15-5.91,4.84-6.59,7.63.68,2.79,2.87,5.49,6.59,7.63,9.09,5.25,23.84,5.25,32.93,0,3.72-2.14,5.91-4.84,6.59-7.63C395.81,404.56,393.62,401.87,389.9,399.72Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,409.08a3.85,3.85,0,0,0,.33-1.57c0-.44,0-2.28,0-2.76a3.36,3.36,0,0,0-.45-1.65l2.33-1.34V399l-3.38-1.95-2,1.13v-2.27l-3.38-2-17,9.8v2.77l3.38,2,2-1.14v2.27l3.38,1.95,8.69-5,.17.17a7.46,7.46,0,0,1-1.8,1.36l-3.08,1.78v2.76l3.55,2.05,14.3,1,1.4.09,5.13-3V410l-6.54-.45Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.85,395.91l-3.38-2-17,9.8,3.38,1.95,3.85-2.22a10.42,10.42,0,0,1,5.09-1.6,6.72,6.72,0,0,1,1.41.12l-8.39,4.84,3.38,1.95,8.69-5c1.62,1.48.72,2.93-1.63,4.29l-3.08,1.78,3.55,2.05,14.3,1,1.4.1,5.13-3-6.54-.45-9.14-.62c2.8-2.35,3.53-5.31.28-7.62l4-2.32-3.38-1.95-4.32,2.49a11.84,11.84,0,0,0-2.78-.57v-.1Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.85,395.91l-3.38-2-17,9.8,3.38,1.95,3.85-2.22a10.42,10.42,0,0,1,5.09-1.6,6.72,6.72,0,0,1,1.41.12l-8.39,4.84,3.38,1.95,8.69-5c1.62,1.48.72,2.93-1.63,4.29l-3.08,1.78,3.55,2.05,14.3,1,1.4.1,5.13-3-6.54-.45-9.14-.62c2.8-2.35,3.53-5.31.28-7.62l4-2.32-3.38-1.95-4.32,2.49a11.84,11.84,0,0,0-2.78-.57v-.1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.49 403.76 370.42 394.61 373.85 395.91 370.47 393.96 353.49 403.76",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.49 399.54 375.84 397.63 379.19 399 375.81 397.05 371.49 399.54",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.89 408.94 389.04 410.37 385.44 412.97 390.57 410.01 374.89 408.94",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.9,403.79c3.48,2-.17,4.12-2.29,5.34l-1.35.78,2.48,2-3.55-2.05,3.08-1.78C371.62,406.72,372.52,405.27,370.9,403.79Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.21 408.8 359.6 406.9 367.21 402.01 358.83 406.85 362.21 408.8",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.72 401.71 343.61 394.99 344.5 401.71 356.15 402.23 344.5 402.74 343.61 409.47 342.72 402.74 331.07 402.23 342.72 401.71",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.12,421.09a22.34,22.34,0,0,1,10.24-5c15.09-3.4,35.18,3.77,44.85,16a23,23,0,0,1,4.92,10.37l1.71.61-2.45,7.09h0c-1.93,4.84-6.71,8.63-14,10.27-15.09,3.4-35.18-3.77-44.85-16-4.65-5.89-6.07-11.88-4.59-16.9h0l2.46-7.09Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.12,421.09a22.34,22.34,0,0,1,10.24-5c15.09-3.4,35.18,3.77,44.85,16a23,23,0,0,1,4.92,10.37l1.71.61-2.45,7.09h0c-1.93,4.84-6.71,8.63-14,10.27-15.09,3.4-35.18-3.77-44.85-16-4.65-5.89-6.07-11.88-4.59-16.9h0l2.46-7.09Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.81,418.27c8.12,2.9,15.56,7.75,20.4,13.88a23,23,0,0,1,4.92,10.37l1.71.61-2.45,7.09h0c-1.94,4.84-6.72,8.63-14,10.27-7.55,1.7-16.34.76-24.46-2.14Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459,427.71a35.75,35.75,0,0,1,4.2,4.44,23,23,0,0,1,4.92,10.37l1.71.61-2.45,7.09h0c-1.94,4.84-6.72,8.63-14,10.27a35.52,35.52,0,0,1-6,.79Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.37,415.34a34.53,34.53,0,0,0-6,.79,22.34,22.34,0,0,0-10.24,5l-1.71-.61L404,427.57h0c-1.48,5-.06,11,4.59,16.9a35.75,35.75,0,0,0,4.2,4.44Z",
    style: {
      fill: "#1E75FE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.46,425.65c9.68,12.24,5.28,24.93-9.82,28.34-13.2,3-30.23-2.14-40.76-11.67h0l-.42-.39a35.88,35.88,0,0,1-3.67-4c-8.07-10.21-6.35-20.73,3.2-25.92h0a25.89,25.89,0,0,1,6.62-2.42C435.7,406.23,455.79,413.4,465.46,425.65Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.46,425.65c9.68,12.24,5.28,24.93-9.82,28.34-13.2,3-30.23-2.14-40.76-11.67h0l-.42-.39a35.88,35.88,0,0,1-3.67-4c-8.07-10.21-6.35-20.73,3.2-25.92h0a25.89,25.89,0,0,1,6.62-2.42C435.7,406.23,455.79,413.4,465.46,425.65Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,412.05a16.8,16.8,0,0,0-7.6,11.18c-1.29,7.28,5.51,16.23,8.07,18.7a35.88,35.88,0,0,1-3.67-4C402.72,427.76,404.44,417.24,414,412.05Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.26,451.57a16.8,16.8,0,0,0,7.6-11.18c1.29-7.28-5.51-16.23-8.07-18.7a35,35,0,0,1,3.67,4C473.53,435.86,471.81,446.38,462.26,451.57Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.57,437.46c-9-11.39-4.91-23.19,9.13-26.35s32.7,3.5,41.69,14.89,4.91,23.18-9.12,26.35S421.57,448.84,412.57,437.46Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.57,437.46c-9-11.39-4.91-23.19,9.13-26.35s32.7,3.5,41.69,14.89,4.91,23.18-9.12,26.35S421.57,448.84,412.57,437.46Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.91,427.24c-.71-5.64,1.9-10.65,7.36-13.73A21.24,21.24,0,0,1,418.6,412a26.79,26.79,0,0,1,3-.86c.58-.14,1.16-.25,1.75-.35-2,1.77-2.36,4.3,4.43,7.22,13.29,5.72-8.85,13.78-8.85,13.78S411.75,424,407.91,427.24Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.67,423.81c-1.95-1-2.16-3.63-.48-5.93s4.64-3.37,6.59-2.39,2.17,3.63.48,5.93S412.63,424.79,410.67,423.81Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.07,443.33c2.58-5.28,29.93-12.7,29.93-12.7s5.64-.4,5.31-4.72a26.32,26.32,0,0,1,1.78,2.51c.37.59.71,1.17,1,1.75,4.42,8.57,1.59,16.75-7.14,20.63-.59.27-1.22.51-1.86.74-.87.29-1.77.55-2.73.77s-1.85.38-2.8.51c-.76.1-1.54.18-2.31.23s-1.56.07-2.36.07a42,42,0,0,1-7.18-.62c-.52-.09-1-.18-1.56-.29a49.92,49.92,0,0,1-14.53-5.49A4,4,0,0,0,428.07,443.33Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.07,443.33c2.58-5.28,29.93-12.7,29.93-12.7s5.64-.4,5.31-4.72a26.32,26.32,0,0,1,1.78,2.51c.37.59.71,1.17,1,1.75,4.42,8.57,1.59,16.75-7.14,20.63-.59.27-1.22.51-1.86.74-.87.29-1.77.55-2.73.77s-1.85.38-2.8.51c-.76.1-1.54.18-2.31.23s-1.56.07-2.36.07a42,42,0,0,1-7.18-.62c-.52-.09-1-.18-1.56-.29a49.92,49.92,0,0,1-14.53-5.49A4,4,0,0,0,428.07,443.33Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.92,427.46c6.43,8.14,3.89,16.55-5.55,19.31-.41.11-.82.22-1.25.32-10.45,2.36-24.36-2.61-31.06-11.09s-3.66-17.27,6.8-19.63c.42-.1.86-.18,1.3-.25C437.44,414.42,450.5,419.32,456.92,427.46Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.92,427.46c6.43,8.14,3.89,16.55-5.55,19.31-.41.11-.82.22-1.25.32-10.45,2.36-24.36-2.61-31.06-11.09s-3.66-17.27,6.8-19.63c.42-.1.86-.18,1.3-.25C437.44,414.42,450.5,419.32,456.92,427.46Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 437.98,
    cy: 431.73,
    rx: 14.04,
    ry: 22.29,
    transform: "translate(-117.53 695.58) rotate(-69.99)",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 437.98,
    cy: 431.73,
    rx: 14.04,
    ry: 22.29,
    transform: "translate(-117.53 695.58) rotate(-69.99)",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.8,431.35c-6.41-8.11-19.7-12.86-29.7-10.61-4.08.93-7,2.88-8.55,5.41-.34,3,.72,6.34,3.34,9.66,6.4,8.1,19.69,12.85,29.69,10.6,4.09-.92,7-2.87,8.55-5.41C458.47,438,457.41,434.66,454.8,431.35Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.8,431.35c-6.41-8.11-19.7-12.86-29.7-10.61-4.08.93-7,2.88-8.55,5.41-.34,3,.72,6.34,3.34,9.66,6.4,8.1,19.69,12.85,29.69,10.6,4.09-.92,7-2.87,8.55-5.41C458.47,438,457.41,434.66,454.8,431.35Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,436.42a4.39,4.39,0,0,0,.84-1.44c.14-.43.78-2.25.94-2.73a4,4,0,0,0,.16-1.76l2.55-.58.95-2.73-2.38-3-2.16.49.77-2.24-2.38-3-18.66,4.2-.94,2.73,2.38,3,2.16-.48-.78,2.24,2.38,3,9.55-2.15.09.22a7.21,7.21,0,0,1-2.09.77l-3.38.76-.95,2.73,2.51,3.16,12.56,5.56,1.23.54,5.64-1.27.94-2.73-5.74-2.54Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.62,422.42l-2.38-3-18.66,4.2,2.38,3,4.23-1a9.49,9.49,0,0,1,5.14.06,5.72,5.72,0,0,1,1.23.57l-9.21,2.08,2.37,3,9.55-2.15c1,2-.35,3.13-2.94,3.72l-3.38.76,2.5,3.17L445,442.44l1.23.54,5.64-1.27-5.74-2.54-8-3.56c3.33-1.41,5-4.11,2.86-7.43l4.42-1-2.38-3-4.75,1.07a10.51,10.51,0,0,0-2.31-1.45l0-.1Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.62,422.42l-2.38-3-18.66,4.2,2.38,3,4.23-1a9.49,9.49,0,0,1,5.14.06,5.72,5.72,0,0,1,1.23.57l-9.21,2.08,2.37,3,9.55-2.15c1,2-.35,3.13-2.94,3.72l-3.38.76,2.5,3.17L445,442.44l1.23.54,5.64-1.27-5.74-2.54-8-3.56c3.33-1.41,5-4.11,2.86-7.43l4.42-1-2.38-3-4.75,1.07a10.51,10.51,0,0,0-2.31-1.45l0-.1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.58 423.61 438.98 420.03 441.62 422.42 439.24 419.4 420.58 423.61",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.26 425.24 442.83 424.76 445.39 427.19 443.01 424.17 438.26 425.24",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.11 435.61 450.38 441.58 446.24 442.99 451.88 441.71 438.11 435.61",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.27,429.24c2.46,3.11-1.56,4-3.89,4.54l-1.48.33,1.55,2.78-2.5-3.17,3.38-.76C435.92,432.37,437.23,431.23,436.27,429.24Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.73 431.39 425.02 428.67 433.56 426.3 424.35 428.38 426.73 431.39",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.57 418.13 414.67 411.77 413.17 418.7 423.51 422.95 412.82 419.71 409.72 426.06 411.22 419.14 400.89 414.88 411.57 418.13",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Yen--inject-93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.31,430.85a22.64,22.64,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.74,0a22.67,22.67,0,0,1,8.41,7.77h1.9V438h0c-.25,5-3.67,10-10.28,13.77-13.73,7.93-36,7.93-49.74,0-6.6-3.82-10-8.77-10.3-13.77h0v-7.18Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.31,430.85a22.64,22.64,0,0,1,8.4-7.77c13.74-7.93,36-7.93,49.74,0a22.67,22.67,0,0,1,8.41,7.77h1.9V438h0c-.25,5-3.67,10-10.28,13.77-13.73,7.93-36,7.93-49.74,0-6.6-3.82-10-8.77-10.3-13.77h0v-7.18Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.58,417.13c9,0,18,2,24.87,5.95a22.67,22.67,0,0,1,8.41,7.77h1.9V438h0c-.25,5-3.67,10-10.28,13.77-6.86,4-15.87,5.94-24.87,5.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.79,420.43a36.76,36.76,0,0,1,5.66,2.65,22.67,22.67,0,0,1,8.41,7.77h1.9V438h0c-.25,5-3.67,10-10.28,13.77a38.73,38.73,0,0,1-5.66,2.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.37,420.43a37.66,37.66,0,0,0-5.66,2.65,22.64,22.64,0,0,0-8.4,7.77h-1.9V438h0c.25,5,3.7,10,10.3,13.77a39.73,39.73,0,0,0,5.66,2.65Z",
    style: {
      fill: "#1E75FE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.46,416.49c13.73,7.93,13.73,20.79,0,28.72-12,6.94-30.58,7.81-44.23,2.6h0l-.55-.21a38,38,0,0,1-5-2.39c-11.45-6.61-13.36-16.65-5.7-24.4h0a26.91,26.91,0,0,1,5.7-4.31C113.45,408.56,135.72,408.56,149.46,416.49Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.46,416.49c13.73,7.93,13.73,20.79,0,28.72-12,6.94-30.58,7.81-44.23,2.6h0l-.55-.21a38,38,0,0,1-5-2.39c-11.45-6.61-13.36-16.65-5.7-24.4h0a26.91,26.91,0,0,1,5.7-4.31C113.45,408.56,135.72,408.56,149.46,416.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,420.81a15.31,15.31,0,0,0-3.68,12.52c1.21,7,11,12.86,14.35,14.27a38,38,0,0,1-5-2.39C88.26,438.6,86.35,428.56,94,420.81Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.16,440.9a15.39,15.39,0,0,0,3.68-12.53c-1.22-7-11-12.86-14.36-14.27a38,38,0,0,1,5,2.39C160.91,423.11,162.81,433.14,155.16,440.9Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.6,
    cy: 430.82,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.6,
    cy: 430.82,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.39,436.46c-2.63-4.86-1.78-10.21,2.56-14.75a22.27,22.27,0,0,1,2.77-2.43,26.39,26.39,0,0,1,2.65-1.74c.52-.31,1.06-.6,1.61-.88-1.36,2.24-.86,4.63,6.84,5.08,15.07.88-4,15.29-4,15.29S96.08,432.34,93.39,436.46Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.94,432.48c-2.26-.26-3.38-2.58-2.5-5.2s3.42-4.53,5.68-4.28,3.39,2.58,2.51,5.2S97.2,432.73,94.94,432.48Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.78,444.48c.74-5.6,25.2-21.09,25.2-21.09s5.43-2.18,3.62-6a28.2,28.2,0,0,1,2.62,1.69q.85.61,1.59,1.26c7.28,6.31,7.29,14.59,0,20.9-.49.43-1,.85-1.59,1.26a25.92,25.92,0,0,1-2.42,1.58c-.83.49-1.7.94-2.6,1.36-.71.34-1.45.66-2.2.95s-1.51.57-2.29.83a48.9,48.9,0,0,1-7.3,1.75l-1.64.24a57.24,57.24,0,0,1-7.3.46,55.18,55.18,0,0,1-8.93-.74S119.48,448.16,118.78,444.48Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.78,444.48c.74-5.6,25.2-21.09,25.2-21.09s5.43-2.18,3.62-6a28.2,28.2,0,0,1,2.62,1.69q.85.61,1.59,1.26c7.28,6.31,7.29,14.59,0,20.9-.49.43-1,.85-1.59,1.26a25.92,25.92,0,0,1-2.42,1.58c-.83.49-1.7.94-2.6,1.36-.71.34-1.45.66-2.2.95s-1.51.57-2.29.83a48.9,48.9,0,0,1-7.3,1.75l-1.64.24a57.24,57.24,0,0,1-7.3.46,55.18,55.18,0,0,1-8.93-.74S119.48,448.16,118.78,444.48Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.83,420.88c9.13,5.27,9.5,13.67,1.12,19.2-.36.23-.73.46-1.12.69-9.51,5.49-24.93,5.49-34.45,0s-9.51-14.4,0-19.89c.39-.23.79-.44,1.2-.65C118.15,415.39,132.71,415.61,141.83,420.88Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.83,420.88c9.13,5.27,9.5,13.67,1.12,19.2-.36.23-.73.46-1.12.69-9.51,5.49-24.93,5.49-34.45,0s-9.51-14.4,0-19.89c.39-.23.79-.44,1.2-.65C118.15,415.39,132.71,415.61,141.83,420.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.6,
    cy: 430.82,
    rx: 23.28,
    ry: 13.44,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.6,
    cy: 430.82,
    rx: 23.28,
    ry: 13.44,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.06,425.07c-9.09-5.25-23.84-5.25-32.93,0-3.72,2.14-5.91,4.83-6.59,7.63.68,2.79,2.87,5.48,6.59,7.63,9.09,5.25,23.84,5.25,32.93,0,3.72-2.15,5.91-4.84,6.59-7.63C147,429.9,144.78,427.21,141.06,425.07Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.06,425.07c-9.09-5.25-23.84-5.25-32.93,0-3.72,2.14-5.91,4.83-6.59,7.63.68,2.79,2.87,5.48,6.59,7.63,9.09,5.25,23.84,5.25,32.93,0,3.72-2.15,5.91-4.84,6.59-7.63C147,429.9,144.78,427.21,141.06,425.07Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.89,438.42l1.86-1.08v2.15l4.11,2.37L128,438.3l6.74,3.89,4.72-2.72V436.7l-4.35-2.51,4.12-2.38v-2.76l-4.12-2.37-1.85,1.07V425.6l-4.08-2.35-2.6,1.5-3.37-5.92-4.93,2.84v2.76l3.7,5.44c-.62-.15-1.28-.3-1.81-.41L109,427.06l-5.16,3v2.77l8,1.52v1.73Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.25,418.83l-4.93,2.84,4.32,6.35c.54.86,1.59,2.24,1.59,2.28l-.14.07c-.07,0-2.43-.62-3.88-.91L109,427.06l-5.16,3L114.07,432l-2.26,1.31,4.08,2.35,4.32-2.49,2.8.53-5.26,3,4.11,2.38,6.18-3.57,6.74,3.9,4.72-2.73-6.74-3.89,6.51-3.76-4.12-2.37-5.6,3.23-.91-1.62,4.66-2.69-4.08-2.35-2.6,1.5Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.25,418.83l-4.93,2.84,4.32,6.35c.54.86,1.59,2.24,1.59,2.28l-.14.07c-.07,0-2.43-.62-3.88-.91L109,427.06l-5.16,3L114.07,432l-2.26,1.31,4.08,2.35,4.32-2.49,2.8.53-5.26,3,4.11,2.38,6.18-3.57,6.74,3.9,4.72-2.73-6.74-3.89,6.51-3.76-4.12-2.37-5.6,3.23-.91-1.62,4.66-2.69-4.08-2.35-2.6,1.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.32 421.67 122.9 419.7 126.62 424.75 123.25 418.83 118.32 421.67",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.62 424.75 129.35 423.78 133.3 425.6 129.22 423.25 126.62 424.75",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.55 429.91 135.15 426.68 139.27 429.05 135.31 427.27 129.55 429.91",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.76 432.81 138.6 436.59 134.78 439.43 139.5 436.7 132.76 432.81",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.82 430.04 109.05 427.6 124.09 430.38 108.98 427.06 103.82 430.04",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.13,420.11a22.67,22.67,0,0,1,8.41-7.77c13.73-7.93,36-7.93,49.74,0a22.64,22.64,0,0,1,8.4,7.77h1.9v7.18h0c-.26,5-3.68,9.95-10.28,13.76-13.74,7.94-36,7.94-49.74,0-6.61-3.81-10.05-8.76-10.31-13.76h0v-7.18Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.13,420.11a22.67,22.67,0,0,1,8.41-7.77c13.73-7.93,36-7.93,49.74,0a22.64,22.64,0,0,1,8.4,7.77h1.9v7.18h0c-.26,5-3.68,9.95-10.28,13.76-13.74,7.94-36,7.94-49.74,0-6.61-3.81-10.05-8.76-10.31-13.76h0v-7.18Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.4,406.39c9,0,18,2,24.88,5.95a22.64,22.64,0,0,1,8.4,7.77h1.9v7.18h0c-.26,5-3.68,9.95-10.28,13.76-6.87,4-15.87,5.95-24.88,5.95Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.62,409.68a38.7,38.7,0,0,1,5.66,2.66,22.64,22.64,0,0,1,8.4,7.77h1.9v7.18h0c-.26,5-3.68,9.95-10.28,13.76a38.7,38.7,0,0,1-5.66,2.66Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.2,409.68a38.22,38.22,0,0,0-5.66,2.66,22.67,22.67,0,0,0-8.41,7.77h-1.9v7.18h0c.26,5,3.7,9.95,10.31,13.76a38.22,38.22,0,0,0,5.66,2.66Z",
    style: {
      fill: "#1E75FE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.28,405.75c13.74,7.93,13.73,20.79,0,28.72-12,6.94-30.57,7.81-44.22,2.6h0l-.54-.21a38,38,0,0,1-5-2.39c-11.46-6.62-13.36-16.65-5.71-24.41h0a27,27,0,0,1,5.71-4.31C109.27,397.82,131.54,397.82,145.28,405.75Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.28,405.75c13.74,7.93,13.73,20.79,0,28.72-12,6.94-30.57,7.81-44.22,2.6h0l-.54-.21a38,38,0,0,1-5-2.39c-11.46-6.62-13.36-16.65-5.71-24.41h0a27,27,0,0,1,5.71-4.31C109.27,397.82,131.54,397.82,145.28,405.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.83,410.06a15.39,15.39,0,0,0-3.68,12.53c1.22,7,11,12.86,14.36,14.27a38,38,0,0,1-5-2.39C84.08,427.85,82.18,417.82,89.83,410.06Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,430.15a15.31,15.31,0,0,0,3.68-12.52c-1.21-7-11-12.86-14.35-14.27a38,38,0,0,1,5,2.39C156.73,412.36,158.64,422.4,151,430.15Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.42,
    cy: 420.08,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.42,
    cy: 420.08,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.21,425.72c-2.63-4.86-1.77-10.21,2.57-14.76a20.79,20.79,0,0,1,2.77-2.42,26.86,26.86,0,0,1,2.64-1.75c.53-.3,1.06-.59,1.61-.87-1.36,2.24-.86,4.63,6.84,5.08,15.07.88-4,15.28-4,15.28S91.9,421.59,89.21,425.72Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.76,421.74c-2.26-.26-3.38-2.58-2.5-5.2S91.69,412,94,412.26s3.38,2.58,2.5,5.2S93,422,90.76,421.74Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.6,433.74c.74-5.6,25.21-21.09,25.21-21.09s5.42-2.18,3.62-6a27.31,27.31,0,0,1,2.61,1.69q.86.61,1.59,1.26c7.29,6.31,7.3,14.59,0,20.9q-.74.64-1.59,1.26a28.1,28.1,0,0,1-2.42,1.58c-.83.49-1.7.94-2.59,1.36-.72.34-1.46.65-2.21.95s-1.51.57-2.29.83a48.61,48.61,0,0,1-7.3,1.75c-.54.09-1.09.17-1.64.24a55.35,55.35,0,0,1-7.3.45,53.87,53.87,0,0,1-8.92-.73S115.3,437.42,114.6,433.74Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.6,433.74c.74-5.6,25.21-21.09,25.21-21.09s5.42-2.18,3.62-6a27.31,27.31,0,0,1,2.61,1.69q.86.61,1.59,1.26c7.29,6.31,7.3,14.59,0,20.9q-.74.64-1.59,1.26a28.1,28.1,0,0,1-2.42,1.58c-.83.49-1.7.94-2.59,1.36-.72.34-1.46.65-2.21.95s-1.51.57-2.29.83a48.61,48.61,0,0,1-7.3,1.75c-.54.09-1.09.17-1.64.24a55.35,55.35,0,0,1-7.3.45,53.87,53.87,0,0,1-8.92-.73S115.3,437.42,114.6,433.74Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.66,410.14c9.12,5.26,9.49,13.67,1.11,19.19-.36.24-.73.47-1.12.69-9.51,5.5-24.93,5.5-34.44,0s-9.52-14.39,0-19.88c.39-.23.79-.44,1.2-.65C114,404.65,128.53,404.87,137.66,410.14Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.66,410.14c9.12,5.26,9.49,13.67,1.11,19.19-.36.24-.73.47-1.12.69-9.51,5.5-24.93,5.5-34.44,0s-9.52-14.39,0-19.88c.39-.23.79-.44,1.2-.65C114,404.65,128.53,404.87,137.66,410.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.42,
    cy: 420.08,
    rx: 23.28,
    ry: 13.44,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.42,
    cy: 420.08,
    rx: 23.28,
    ry: 13.44,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.88,414.32c-9.09-5.25-23.83-5.25-32.93,0-3.71,2.15-5.91,4.84-6.59,7.63.68,2.8,2.88,5.49,6.59,7.64,9.1,5.25,23.84,5.25,32.93,0,3.72-2.15,5.92-4.84,6.59-7.64C142.8,419.16,140.6,416.47,136.88,414.32Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.88,414.32c-9.09-5.25-23.83-5.25-32.93,0-3.71,2.15-5.91,4.84-6.59,7.63.68,2.8,2.88,5.49,6.59,7.64,9.1,5.25,23.84,5.25,32.93,0,3.72-2.15,5.92-4.84,6.59-7.64C142.8,419.16,140.6,416.47,136.88,414.32Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.72,427.67l1.85-1.07v2.14l4.12,2.38,6.17-3.56,6.75,3.89,4.72-2.72V426L131,423.45l4.11-2.38v-2.76L131,415.93,129.12,417v-2.14L125,412.51l-2.6,1.5-3.37-5.92-4.92,2.84v2.76l3.69,5.44c-.62-.15-1.27-.31-1.8-.41l-11.24-2.4-5.16,3v2.77l8,1.51v1.74Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.07,408.09l-4.92,2.84,4.31,6.35c.54.85,1.59,2.24,1.59,2.27l-.14.08c-.06,0-2.42-.62-3.87-.91l-11.24-2.4-5.16,3,10.26,1.95-2.26,1.3,4.08,2.36,4.32-2.49,2.8.52-5.27,3,4.12,2.38,6.17-3.57,6.75,3.9,4.72-2.73-6.75-3.89,6.51-3.76L131,415.93l-5.6,3.24-.91-1.62,4.65-2.69L125,412.51l-2.6,1.5Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.07,408.09l-4.92,2.84,4.31,6.35c.54.85,1.59,2.24,1.59,2.27l-.14.08c-.06,0-2.42-.62-3.87-.91l-11.24-2.4-5.16,3,10.26,1.95-2.26,1.3,4.08,2.36,4.32-2.49,2.8.52-5.27,3,4.12,2.38,6.17-3.57,6.75,3.9,4.72-2.73-6.75-3.89,6.51-3.76L131,415.93l-5.6,3.24-.91-1.62,4.65-2.69L125,412.51l-2.6,1.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.15 410.93 118.73 408.96 122.44 414.01 119.07 408.09 114.15 410.93",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.44 414.01 125.18 413.04 129.12 414.86 125.04 412.51 122.44 414.01",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.38 419.17 130.98 415.93 135.09 418.31 131.13 416.53 125.38 419.17",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.58 422.07 134.42 425.85 130.61 428.69 135.33 425.96 128.58 422.07",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.64 419.3 104.88 416.86 119.91 419.63 104.81 416.32 99.64 419.3",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.29,410.83a22.64,22.64,0,0,1,8.4-7.77c13.73-7.93,36-7.93,49.74,0a22.64,22.64,0,0,1,8.4,7.77h1.9V418h0c-.25,5-3.67,9.95-10.28,13.77-13.74,7.93-36,7.93-49.74,0C93.08,428,89.64,423,89.39,418h0v-7.18Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.29,410.83a22.64,22.64,0,0,1,8.4-7.77c13.73-7.93,36-7.93,49.74,0a22.64,22.64,0,0,1,8.4,7.77h1.9V418h0c-.25,5-3.67,9.95-10.28,13.77-13.74,7.93-36,7.93-49.74,0C93.08,428,89.64,423,89.39,418h0v-7.18Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.56,397.11c9,0,18,2,24.87,5.95a22.64,22.64,0,0,1,8.4,7.77h1.9V418h0c-.25,5-3.67,9.95-10.28,13.77-6.87,4-15.87,5.94-24.87,5.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.77,400.41a37.66,37.66,0,0,1,5.66,2.65,22.64,22.64,0,0,1,8.4,7.77h1.9V418h0c-.25,5-3.67,9.95-10.28,13.77a39.73,39.73,0,0,1-5.66,2.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.35,400.41a37.66,37.66,0,0,0-5.66,2.65,22.64,22.64,0,0,0-8.4,7.77h-1.9V418h0c.25,5,3.69,9.95,10.3,13.77a39.73,39.73,0,0,0,5.66,2.65Z",
    style: {
      fill: "#1E75FE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.43,396.47c13.74,7.93,13.74,20.79,0,28.72-12,6.94-30.57,7.81-44.22,2.6h0l-.55-.21a38.65,38.65,0,0,1-5-2.39c-11.46-6.61-13.36-16.65-5.71-24.4h0a26.91,26.91,0,0,1,5.7-4.31C113.42,388.54,135.69,388.54,149.43,396.47Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.43,396.47c13.74,7.93,13.74,20.79,0,28.72-12,6.94-30.57,7.81-44.22,2.6h0l-.55-.21a38.65,38.65,0,0,1-5-2.39c-11.46-6.61-13.36-16.65-5.71-24.4h0a26.91,26.91,0,0,1,5.7-4.31C113.42,388.54,135.69,388.54,149.43,396.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,400.79a15.35,15.35,0,0,0-3.68,12.52c1.22,7,11,12.86,14.36,14.27a38.65,38.65,0,0,1-5-2.39C88.23,418.58,86.33,408.54,94,400.79Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.14,420.87a15.38,15.38,0,0,0,3.68-12.52c-1.22-7-11-12.86-14.36-14.27a38.65,38.65,0,0,1,5,2.39C160.89,403.08,162.79,413.12,155.14,420.87Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.57,
    cy: 410.8,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.57,
    cy: 410.8,
    rx: 32.7,
    ry: 18.88,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.36,416.44c-2.63-4.86-1.77-10.21,2.57-14.75a21.48,21.48,0,0,1,2.77-2.43,27,27,0,0,1,2.65-1.75c.52-.3,1.05-.59,1.61-.87-1.36,2.24-.86,4.63,6.84,5.08,15.07.88-4,15.28-4,15.28S96.05,412.32,93.36,416.44Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.92,412.46c-2.27-.26-3.39-2.58-2.51-5.2s3.43-4.53,5.69-4.28,3.38,2.58,2.5,5.2S97.18,412.71,94.92,412.46Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.75,424.46c.74-5.6,25.21-21.09,25.21-21.09s5.42-2.18,3.62-6a27.49,27.49,0,0,1,2.62,1.69q.84.62,1.59,1.26c7.28,6.31,7.29,14.59,0,20.9-.49.43-1,.85-1.58,1.26a26.1,26.1,0,0,1-2.43,1.58c-.83.49-1.7.94-2.59,1.36-.71.34-1.45.65-2.2.95s-1.52.57-2.3.83a48.32,48.32,0,0,1-7.3,1.75c-.54.09-1.09.17-1.64.24a57.12,57.12,0,0,1-7.3.46,55.06,55.06,0,0,1-8.92-.74S119.45,428.14,118.75,424.46Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.75,424.46c.74-5.6,25.21-21.09,25.21-21.09s5.42-2.18,3.62-6a27.49,27.49,0,0,1,2.62,1.69q.84.62,1.59,1.26c7.28,6.31,7.29,14.59,0,20.9-.49.43-1,.85-1.58,1.26a26.1,26.1,0,0,1-2.43,1.58c-.83.49-1.7.94-2.59,1.36-.71.34-1.45.65-2.2.95s-1.52.57-2.3.83a48.32,48.32,0,0,1-7.3,1.75c-.54.09-1.09.17-1.64.24a57.12,57.12,0,0,1-7.3.46,55.06,55.06,0,0,1-8.92-.74S119.45,428.14,118.75,424.46Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.81,400.86c9.12,5.27,9.49,13.67,1.11,19.2-.35.23-.73.46-1.11.69-9.52,5.49-24.94,5.49-34.45,0s-9.52-14.4,0-19.89c.39-.23.79-.44,1.19-.65C118.12,395.37,132.68,395.59,141.81,400.86Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.81,400.86c9.12,5.27,9.49,13.67,1.11,19.2-.35.23-.73.46-1.11.69-9.52,5.49-24.94,5.49-34.45,0s-9.52-14.4,0-19.89c.39-.23.79-.44,1.19-.65C118.12,395.37,132.68,395.59,141.81,400.86Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.57,
    cy: 410.8,
    rx: 23.28,
    ry: 13.44,
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.57,
    cy: 410.8,
    rx: 23.28,
    ry: 13.44,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,405c-9.1-5.24-23.84-5.24-32.93,0-3.72,2.14-5.92,4.83-6.59,7.63.67,2.79,2.87,5.48,6.59,7.63,9.09,5.25,23.83,5.25,32.93,0,3.71-2.15,5.91-4.84,6.59-7.63C147,409.88,144.75,407.19,141,405Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,405c-9.1-5.24-23.84-5.24-32.93,0-3.72,2.14-5.92,4.83-6.59,7.63.67,2.79,2.87,5.48,6.59,7.63,9.09,5.25,23.83,5.25,32.93,0,3.71-2.15,5.91-4.84,6.59-7.63C147,409.88,144.75,407.19,141,405Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.5 403.65 97.39 396.92 98.28 403.65 109.93 404.16 98.28 404.67 97.39 411.4 96.5 404.67 84.85 404.16 96.5 403.65",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.87,418.39l1.86-1.07v2.15l4.11,2.37,6.17-3.56,6.75,3.89,4.72-2.72v-2.77l-4.35-2.51,4.11-2.38V409l-4.11-2.38-1.86,1.08v-2.15l-4.08-2.35-2.59,1.5-3.38-5.92-4.92,2.84v2.76l3.69,5.44c-.61-.15-1.27-.3-1.8-.41L109,407l-5.16,3v2.77l8,1.51V416Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.22,398.81l-4.92,2.84,4.32,6.35c.54.85,1.58,2.24,1.58,2.28l-.13.07c-.07,0-2.43-.62-3.88-.91L109,407l-5.16,3,10.25,2-2.26,1.3,4.08,2.36,4.32-2.49,2.8.52-5.26,3,4.11,2.38,6.17-3.57,6.75,3.9,4.72-2.73-6.75-3.89,6.51-3.76-4.11-2.38-5.6,3.24-.91-1.62,4.65-2.69-4.08-2.35-2.59,1.5Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.22,398.81l-4.92,2.84,4.32,6.35c.54.85,1.58,2.24,1.58,2.28l-.13.07c-.07,0-2.43-.62-3.88-.91L109,407l-5.16,3,10.25,2-2.26,1.3,4.08,2.36,4.32-2.49,2.8.52-5.26,3,4.11,2.38,6.17-3.57,6.75,3.9,4.72-2.73-6.75-3.89,6.51-3.76-4.11-2.38-5.6,3.24-.91-1.62,4.65-2.69-4.08-2.35-2.59,1.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.3 401.65 122.88 399.68 126.6 404.73 123.22 398.81 118.3 401.65",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.6 404.73 129.33 403.76 133.27 405.58 129.19 403.23 126.6 404.73",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.53 409.89 135.13 406.65 139.24 409.03 135.28 407.25 129.53 409.89",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.74 412.79 138.57 416.57 134.76 419.41 139.48 416.68 132.74 412.79",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.8 410.02 109.03 407.58 124.07 410.35 108.96 407.04 103.8 410.02",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.16,420.52a24.88,24.88,0,0,0-10.78-5.27C66.72,411.5,46.65,418.56,37.55,431a21.69,21.69,0,0,0-4.36,10.59l-1.71.61,3,7.33h0c2.3,5,7.42,9,15,10.79,15.66,3.75,35.73-3.31,44.83-15.76,4.37-6,5.43-12.14,3.59-17.32h0l-3-7.33Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.16,420.52a24.88,24.88,0,0,0-10.78-5.27C66.72,411.5,46.65,418.56,37.55,431a21.69,21.69,0,0,0-4.36,10.59l-1.71.61,3,7.33h0c2.3,5,7.42,9,15,10.79,15.66,3.75,35.73-3.31,44.83-15.76,4.37-6,5.43-12.14,3.59-17.32h0l-3-7.33Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.51,417.05c-8.12,2.86-15.41,7.73-20,14a21.69,21.69,0,0,0-4.36,10.59l-1.71.61,3,7.33h0c2.3,5,7.42,9,15,10.79,7.83,1.87,16.76,1.05,24.88-1.81Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.56,426.51a33.22,33.22,0,0,0-4,4.5,21.69,21.69,0,0,0-4.36,10.59l-1.71.61,3,7.33h0c2.3,5,7.42,9,15,10.79a36.2,36.2,0,0,0,6.2.91Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.18,414.33a37.37,37.37,0,0,1,6.2.92,24.88,24.88,0,0,1,10.78,5.27l1.71-.6,3,7.33h0c1.84,5.18.78,11.33-3.59,17.32a33.83,33.83,0,0,1-4,4.5Z",
    style: {
      fill: "#1E75FE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.83,424.28c-9.1,12.45-3.78,25.58,11.87,29.33,13.7,3.27,30.78-1.72,40.93-11.36h0l.4-.39a31.42,31.42,0,0,0,3.49-4c7.59-10.38,5.16-21.23-4.94-26.72h0a27.66,27.66,0,0,0-6.92-2.6C64,404.78,43.93,411.83,34.83,424.28Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.83,424.28c-9.1,12.45-3.78,25.58,11.87,29.33,13.7,3.27,30.78-1.72,40.93-11.36h0l.4-.39a31.42,31.42,0,0,0,3.49-4c7.59-10.38,5.16-21.23-4.94-26.72h0a27.66,27.66,0,0,0-6.92-2.6C64,404.78,43.93,411.83,34.83,424.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.58,411.12a19.24,19.24,0,0,1,8.49,11.63c1.79,7.51-4.59,16.6-7,19.11a31.42,31.42,0,0,0,3.49-4C99.11,427.46,96.68,416.61,86.58,411.12Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.78,451a19.23,19.23,0,0,1-8.5-11.63c-1.79-7.51,4.59-16.6,7-19.11a32,32,0,0,0-3.49,4C27.24,434.67,29.68,445.52,39.78,451Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.15,
    cy: 431.04,
    rx: 31.26,
    ry: 20.75,
    transform: "translate(-125.08 38.16) rotate(-17.26)",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.15,
    cy: 431.04,
    rx: 31.26,
    ry: 20.75,
    transform: "translate(-125.08 38.16) rotate(-17.26)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.61,426.91c.36-5.8-2.63-11-8.41-14.25a23,23,0,0,0-3.5-1.6,27.6,27.6,0,0,0-3.11-.95c-.6-.14-1.2-.27-1.81-.38,2.15,1.85,2.69,4.46-4.06,7.36-13.22,5.67,9.94,14.32,9.94,14.32S89.48,423.55,93.61,426.91Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.56,423.33c1.93-1,2-3.7.11-6.1s-5-3.54-6.89-2.56-2,3.7-.11,6.1S88.63,424.31,90.56,423.33Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,443.14c-3-5.48-31.43-13.55-31.43-13.55s-5.79-.5-5.73-4.94a26.31,26.31,0,0,0-1.66,2.55c-.34.6-.64,1.2-.91,1.79-4,8.75-.54,17.21,8.64,21.34.62.29,1.28.55,1.95.79a29.43,29.43,0,0,0,2.84.84c.95.23,1.92.42,2.9.57.78.11,1.58.2,2.38.27s1.6.1,2.41.11a41.91,41.91,0,0,0,7.3-.52c.52-.08,1.05-.17,1.57-.28a46.71,46.71,0,0,0,6.77-1.84,45.05,45.05,0,0,0,7.74-3.58A4.41,4.41,0,0,1,74,443.14Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,443.14c-3-5.48-31.43-13.55-31.43-13.55s-5.79-.5-5.73-4.94a26.31,26.31,0,0,0-1.66,2.55c-.34.6-.64,1.2-.91,1.79-4,8.75-.54,17.21,8.64,21.34.62.29,1.28.55,1.95.79a29.43,29.43,0,0,0,2.84.84c.95.23,1.92.42,2.9.57.78.11,1.58.2,2.38.27s1.6.1,2.41.11a41.91,41.91,0,0,0,7.3-.52c.52-.08,1.05-.17,1.57-.28a46.71,46.71,0,0,0,6.77-1.84,45.05,45.05,0,0,0,7.74-3.58A4.41,4.41,0,0,1,74,443.14Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.51,426.35c-6,8.27-2.9,17,6.93,19.95.42.13.85.25,1.3.35,10.84,2.6,24.73-2.29,31-10.91S85.4,418,74.56,415.43c-.45-.1-.9-.2-1.35-.28C62.59,413.24,49.56,418.08,43.51,426.35Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.51,426.35c-6,8.27-2.9,17,6.93,19.95.42.13.85.25,1.3.35,10.84,2.6,24.73-2.29,31-10.91S85.4,418,74.56,415.43c-.45-.1-.9-.2-1.35-.28C62.59,413.24,49.56,418.08,43.51,426.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.15,
    cy: 431.04,
    rx: 22.26,
    ry: 14.78,
    transform: "translate(-125.08 38.16) rotate(-17.26)",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.15,
    cy: 431.04,
    rx: 22.26,
    ry: 14.78,
    transform: "translate(-125.08 38.16) rotate(-17.26)",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.94,430.38c6-8.24,19.31-12.91,29.67-10.44,4.24,1,7.33,3.07,9.09,5.71.55,3.06-.32,6.51-2.78,9.88-6,8.24-19.31,12.91-29.67,10.43-4.24-1-7.33-3.07-9.1-5.7C42.61,437.19,43.48,433.75,45.94,430.38Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.94,430.38c6-8.24,19.31-12.91,29.67-10.44,4.24,1,7.33,3.07,9.09,5.71.55,3.06-.32,6.51-2.78,9.88-6,8.24-19.31,12.91-29.67,10.43-4.24-1-7.33-3.07-9.1-5.7C42.61,437.19,43.48,433.75,45.94,430.38Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.69 417.57 86.11 410.98 88.09 418.13 77.8 422.34 88.52 419.17 92.1 425.76 90.11 418.61 100.41 414.4 89.69 417.57",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.13,436l-2.11-.5.88,2.19-2.72,3.73-7-1.69-4.47,6.12-5.38-1.29-1.14-2.82L55,437.82l-4.69-1.12-1.14-2.82,2.73-3.73,2.11.51-.89-2.19,2.71-3.7,3,.71.59-7.11L65,419.71l1.15,2.82-1.09,6.72c.5-.35,1-.71,1.46-1l9.13-6,5.88,1.41,1.15,2.82-6.58,4.09.72,1.77Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.41,418.37,65,419.71l-1.26,7.85c-.14,1-.51,2.79-.49,2.83l.15,0c.06,0,1.93-1.4,3.12-2.16l9.13-6,5.88,1.41-8.43,5.24,2.57.61-2.7,3.7L68.07,432l-2.31,1.42,6,1.43L69,438.62l-7-1.68-4.47,6.12-5.38-1.29,4.47-6.12-7.42-1.77,2.73-3.73,6.38,1.53.15-1.94-5.31-1.27,2.71-3.7,3,.71Z",
    style: {
      fill: "#1E75FE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.41,418.37,65,419.71l-1.26,7.85c-.14,1-.51,2.79-.49,2.83l.15,0c.06,0,1.93-1.4,3.12-2.16l9.13-6,5.88,1.41-8.43,5.24,2.57.61-2.7,3.7L68.07,432l-2.31,1.42,6,1.43L69,438.62l-7-1.68-4.47,6.12-5.38-1.29,4.47-6.12-7.42-1.77,2.73-3.73,6.38,1.53.15-1.94-5.31-1.27,2.71-3.7,3,.71Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.02 419.71 60.08 419.15 58.82 425.48 59.41 418.37 65.02 419.71",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.82 425.48 55.95 425.36 53.16 428.47 55.86 424.77 58.82 425.48",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.31 431.68 51.93 430.15 49.2 433.88 52.04 430.81 58.31 431.68",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.62 435.65 52.92 441.36 57.53 443.06 52.15 441.77 56.62 435.65",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.55 423.66 75.83 422.82 63.42 430.42 75.67 422.25 81.55 423.66",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-93"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chartacter--inject-93"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.25,394.63l-2.17-17.91,20.55,1.07s-.18,9.74-.39,15.25c-.13,3.27,4.34,9.25,4.34,9.25s-9.57,5.3-14.76,3.57-8-8.13-8-9.54S264.25,394.63,264.25,394.63Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.08,422c.32,0,.91,3.31-.8,4.79-2,1.7-7.86,4.57-15.77,3.86s-12.24-2.86-15.46-5.23-7.75-5.71-11.33-6.34c-3.33-.58-7-1.87-8.06-2.8s-1.06-5.18-1.06-5.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.24,394.6a1.25,1.25,0,0,0-1.16,1c-.2,1.18-.36,4.6-.83,6.54-.64,2.7-1,8.19-.46,10.36s5.94,3.52,9.42,4.64a44.45,44.45,0,0,1,11.37,6.25c3.78,2.74,11.66,5.47,16.79,5.28,6.07-.23,12.86-2.28,14.34-5,1.84-3.32,3.14-7.15-6-10.78-1.72-.69-7.81-3.82-9.89-5-5.62-3.08-9.59-5.94-12.3-11.62a3.23,3.23,0,0,0-1.35-1.72,3.09,3.09,0,0,0-1.76-.09c-1.49.24-7.45,1.2-8.8,1.85-1.19.58-2.89,1.26-2.82,2.7a4.69,4.69,0,0,0,.38,1.47c.12.29.22.68-.05.86s-.61,0-.85-.19a21.68,21.68,0,0,1-2.51-2.65,8.82,8.82,0,0,0-1.47-1.32,15.88,15.88,0,0,1-1.57-.88C264.18,395.91,264.29,395.28,264.24,394.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.58,423.42c-1.61-1.16-3.31-2.28-5-3.28h0s10.77,5.69,15,2.83c2.71-1.85,1.33-4,1.24-4.63s9.5-5.81,12.17-6.19h0c.76.36,1.39.65,1.79.81,9.12,3.63,7.82,7.46,6,10.78-1.48,2.68-6.38,4.89-14.23,5.13C294.35,429,286.36,426.16,282.58,423.42Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,416.37c5.67,1.92,3.31,3,1.74,3.23s-11.14-4.6-17-8.68c-6.13-4.25-10.06-9-12.33-10.55-.85-.58-1.77-1.3-2.59-2,.12-1.16.21-2.21.3-2.77a1.25,1.25,0,0,1,1.16-1c.05.68-.06,1.31.5,1.81a15.88,15.88,0,0,0,1.57.88,8.82,8.82,0,0,1,1.47,1.32,21.68,21.68,0,0,0,2.51,2.65C275.35,406.91,287.31,414.45,293,416.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.29,418.84a.55.55,0,0,1-.35-.1.5.5,0,0,1-.1-.73c1.53-1.86,8.89-6.39,13-6.09a.53.53,0,0,1,.51.55.54.54,0,0,1-.6.48c-3.86-.27-10.84,4.22-12,5.69A.57.57,0,0,1,294.29,418.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.32,416.18a.58.58,0,0,1-.35-.11.49.49,0,0,1-.1-.72c1.53-1.86,8.88-6.39,13-6.09a.53.53,0,0,1,.51.55.54.54,0,0,1-.6.48C297.94,410,291,414.5,289.75,416A.55.55,0,0,1,289.32,416.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.36,413.67a.59.59,0,0,1-.36-.11.51.51,0,0,1-.1-.73c1.53-1.86,8.89-6.39,13-6.09a.52.52,0,1,1-.08,1c-3.86-.27-10.85,4.21-12.06,5.68A.57.57,0,0,1,284.36,413.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.74,410.76a.55.55,0,0,1-.35-.1.49.49,0,0,1-.1-.73c1.52-1.86,8.9-6.38,13-6.09a.52.52,0,0,1,.5.56.54.54,0,0,1-.59.48c-3.86-.27-10.85,4.21-12.06,5.68A.53.53,0,0,1,279.74,410.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.21,407.86a.59.59,0,0,1-.34-.1.5.5,0,0,1-.12-.73c2.1-2.63,9.84-6.46,14-6.17a.54.54,0,0,1,.51.56.57.57,0,0,1-.6.48c-3.72-.27-11.13,3.41-13,5.75A.58.58,0,0,1,275.21,407.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.79,405l4.45-17.06L207.3,385l-.71,16.45s-2.15,5.9-.84,8.05,15.23,4.4,16.51,3S223.79,405,223.79,405Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.15,442.06c-.61,5.27-1.71,8.68-4,11.54s-6.34,3.34-10.36,1.93-9.11-4.49-10-9.22-.55-7.84.62-12.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.59,401.42c-1.68-.08-1.25,7.14-2.57,14.17-1.41,7.54-4.15,10.39-5.38,16.56-1.41,7-1.14,10.3,1.48,15s12.46,10.17,17.71,4.57c4.29-4.58,4.73-10.17,4.71-17.39,0-7.45-.09-12.7.52-18.28.59-5.34,2.15-10.08.72-10.86-.15.78-.31,1.76-.47,2.53-.12.58-.43,3.47-1.37,3.38a10.62,10.62,0,0,1,.08-2,2.3,2.3,0,0,0-.37-1.79,7.83,7.83,0,0,0-2.7-1.37c-1.64-.49-4.56-1.1-6.22-1.44-.83-.17-1.67-.31-2.51-.4a6.91,6.91,0,0,0-2.13,0,1.31,1.31,0,0,0-1,.61,2,2,0,0,0-.12.81,5,5,0,0,1-.29,1.45c-.07.2-.25.44-.48.36a.44.44,0,0,1-.25-.47c0-.86.19-1.48.28-2.48,0-.46.16-1.09.19-1.55S206.53,401.88,206.59,401.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.12,430.15c-.21,1-1.54,7.75.51,9.24,2.21,1.62,3.72-3.61,3.72-3.61s5.42-.8,13.05,3.17c-.45,1.06.57,4.88,2.74,4.37s3.38-8.27,3.4-8.37c0,6.91-.55,12.32-4.71,16.76-5.25,5.6-15.08.12-17.71-4.57s-2.89-7.95-1.48-15C198.78,431.44,198.94,430.78,199.12,430.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.94,436.31c-.16,2.59-3,1.36-2.95-2.32s2.74-12.09,3-18.4c.49-8.65.89-14.25,2.57-14.17l0,.27-.39,3.6a12.51,12.51,0,0,0-.17,1.54c-.31,5.29-.37,15.56-1.13,20.34A74.34,74.34,0,0,0,203.94,436.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.51,438.77a74.24,74.24,0,0,0,2-8.91c.81-4.72,3.64-14.18,5-19.27a11.3,11.3,0,0,0,.72-2.88c.15-.71.3-1.62.44-2.36,0-.06,0-.11,0-.16,1,.58.67,4.67.13,6.79s-1.21,4.4-1.89,7.44c-1.74,6-1.91,15-3,18.45S214.83,441.25,215.51,438.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.56,439.18a.73.73,0,0,1-.23-.09,23,23,0,0,0-12.84-2.76.69.69,0,0,1-.74-.49.51.51,0,0,1,.47-.62,24.05,24.05,0,0,1,13.74,3,.53.53,0,0,1,.22.77A.6.6,0,0,1,216.56,439.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.23,433.72a.8.8,0,0,1-.2-.07,28.41,28.41,0,0,0-14.38-3.1.69.69,0,0,1-.73-.5.52.52,0,0,1,.5-.61,29.41,29.41,0,0,1,15.19,3.28.55.55,0,0,1,.26.77A.61.61,0,0,1,218.23,433.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.31,425.25a.67.67,0,0,1-.5-.43.5.5,0,0,1,.42-.65c7.62-1.34,14.87,3,15.18,3.14a.54.54,0,0,1,.22.78.63.63,0,0,1-.84.12c-.07,0-7.12-4.2-14.21-2.95A.62.62,0,0,1,204.31,425.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,420.26a.67.67,0,0,1-.5-.42.5.5,0,0,1,.41-.66,22.25,22.25,0,0,1,15.49,3.14.54.54,0,0,1,.17.78.66.66,0,0,1-.87.08c-.06,0-6.62-4.41-14.42-2.91A.87.87,0,0,1,205,420.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.78,414.66a.67.67,0,0,1-.5-.42.49.49,0,0,1,.4-.66c7.86-1.62,15.28,3.1,15.59,3.3a.55.55,0,0,1,.19.78.64.64,0,0,1-.86.1c-.07-.05-7.23-4.61-14.54-3.1A.66.66,0,0,1,205.78,414.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,225.56c-3.36,41.73-5.39,98.88-5.39,98.88-.3,3.16-2.5,8.59-4,24.22-1.63,16.49-1.37,39.77-1.37,39.77s11,6.21,20.17,3.14c0,0,8.6-36.59,13.34-56,4.49-18.38,10.79-46.38,10.79-46.38l5.33,27.68s-.67,11.9-.36,20.22c.36,9.69,6.29,46.75,6.29,46.75s10.9,7.11,20.39-.28c0,0,2.1-54.32,2.41-66,.6-22.84,3.38-67.21.53-96.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.45,289.18l4.79-29.68s11.05-1.6,16.72-6.79c0,0-3.67,6.88-14.09,9.53l-4.76,27,2.67,27.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.9,388.89c2.27,3.12,12.41,6.26,20.57,3.45l1.44-6.41c-6.17,2-16.86.05-21.87-4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.66,384.81c2.77,2.66,13,4,20.59-.21l.33-6.57c-5.74,3-16.28,3.17-21.9.05Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-93"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.8,146.92c8.6,1.21,10.11,3.38,23,14.24,10.49,8.86,16.09,12.61,16.09,12.61s10.94,13,11.41,15.53,1.44,8.31-3.58,11.6c-3.2,2.09-7,.27-9,.49-4.17.46-6.78-2.91-8.53-3.92-11.84-6.87-21.36-13.14-21.36-13.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.17,138.53c-1.78-1-2.07.62-2.67.84,0,0,1.78-2.11-1.28-3.88-1.88-1.09-2.76,1.55-2.8,1.2,0-.16,2.18-5.54,4-10.1,1.69-4.34.16-5.55-.54-5.88s-1.42,0-3,3.13-6.23,12.61-7.28,14.58-1.83,2.89-2.55.36c-.68-2.37-1.3-4.62-2.7-6.05-2.34-2.4-4.12-1.31-3.73.55.55,2.62.55,5.69,1,10,.22,2.23.3,4.33.58,5.86.86,5.36-2.23,7.87-5.9,12.15-3,3.49-6.09,6.37-13,13.4-6.54,6.67-6.07,22.14.52,24.77,7.56,3,10.5-1,15.84-9.43,4.52-7.15,10.71-20.14,12.4-23.15s2.29-4.85,4.67-6.35c3.23-2,4.65-4.2,6.41-7.38.85-1.52,2.45-4.32,3.48-6.58s1.13-3.87-.17-4.82c-1.76-1.28-2.24.67-2.42.46S353.69,140,351.17,138.53Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.87,149.85c-.61-.86,0-2.44,0-2.44a3,3,0,0,1-1.41,1.24,2.18,2.18,0,0,1-2.5-1.09,3.14,3.14,0,0,1,.32-2.06,3.52,3.52,0,0,1-1.51.86c-1,.26-1.83-.34-2.2-1.5s1-4.09,2.34-6.76a13.23,13.23,0,0,0-2.1,3,7.16,7.16,0,0,0-1.21,3.63,7.47,7.47,0,0,0-2.82-2.29c2.47,2.36,4.28,8.82,3.28,13.12a9.47,9.47,0,0,0,.82-8.51,1.92,1.92,0,0,0,2.26-.19,2.27,2.27,0,0,0,1.35,2.38,2.21,2.21,0,0,0,2.48,0s-.29,1,1,1.62,2.28-.07,3-1.32A2,2,0,0,1,348.87,149.85Z",
    style: {
      fill: "#9a4a4d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--chest--inject-93",
    d: "M236.54,144.2c-10.85,2.6-14.09,3.71-19.22,5,0,0-8.92,9.32-1.77,43.63.91,4.4,1.59,17.52,1.62,28.29,0,7.66-.29,12.69-.58,18,0,0,14.69,10.05,45.06,6.5C285.5,242.85,287,233.89,287,233.89s.18-29-1.16-46.74c-1.75-23.24-9.16-37-11.89-40.17-.86-.49-17.1-2.72-17.1-2.72Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.71,97.89s-3.49.52-5.46,5.13c-1,2.32-1.52,6.45,2.5,17.84a46.77,46.77,0,0,0,6.52,12.42,5.75,5.75,0,0,0,3.52,2.42l-.89-8.92-.79-6.21s4.66-4.92,4.76-9.43c.13-5.8-2.35-8.9-2.35-8.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.52,98.28c-2.69-8.47,15.75-18.86,25.06-12.3,3.61-4.31,11.39-1.8,11.86,2.91,2.92-1.17,6.83,3.27,5.3,6.66,2.19-.63,5.61,2.84,3.28,5.72-1.69,2.07-1.3,3.91,1.24,4.41-.4,3-5.81,3.1-6.65.8-.14,1.77-1.4.9-2.73-.28-9.24-.68-18.85.15-28.21,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.53,128.55c4.63,2.25,6.74-1.43,6.74-1.43l.74,20.13c8.89,11.92,32.56,7.09,22.84-1.84l-.05-5.67a31.5,31.5,0,0,0,4-.43,10.68,10.68,0,0,0,8.67-8c1.79-6.59,1.69-17.16-.8-28.37-.48-2.17-1.41-4.53-3.39-5.51-4.92-2.43-9.46,1.09-16.3,3.78-2.83,1.11-9.71,1.61-11.52.75,2.39,2.65,1,9.51.39,11.68-.91,3.13-2.23,4.66-2.88,4.8-2.8.59-3.13-1.82-4.39-3.14a5.14,5.14,0,0,0-8,1.86A8.46,8.46,0,0,0,226.53,128.55Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.31,134.45c1,4.55,7.11,7.53,17.51,7.77l0-2.48a47.42,47.42,0,0,1-7.62-.68C244.31,138.26,239.31,134.45,239.31,134.45Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.91,107.88l-4,2.9a2.61,2.61,0,0,1,.58-3.55A2.4,2.4,0,0,1,248.91,107.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,107.88l-4.56-2a2.38,2.38,0,0,1,3.19-1.36A2.63,2.63,0,0,1,267,107.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.84,125.54l7,1.19a3.39,3.39,0,0,1-4,3A3.72,3.72,0,0,1,250.84,125.54Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.19,129.64a3.62,3.62,0,0,0-3.57-2.77,3.1,3.1,0,0,0-.69.08,3.69,3.69,0,0,0,2.92,2.73A3.33,3.33,0,0,0,255.19,129.64Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.75,114.57a2,2,0,1,0,1.93-2.09A2,2,0,0,0,247.75,114.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,112.36a2,2,0,1,0,1.93-2.09A1.83,1.83,0,0,0,262,112.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.89,109.43l2.23,13,7-2.76C262.85,114.7,258.86,111.61,255.89,109.43Z",
    style: {
      fill: "#9a4a4d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.53,257c-3.55,1.16-8.33-3.12-9.65-4.62s.15-5.26.79-8.4-.37-8.38,3.57-7.06S212.67,248.34,205.53,257Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.38,150.08c-8.86,1.65-13.46,2.94-19.53,14.83-6.55,12.81-17.89,31.49-19.27,37.14-1.28,5.26-4.11,9.09,1.9,16.77,5.5,7,22.62,25.32,25.14,28,2.22,2.37,1.33,9.47-6,8.71,0,0,5.77,4.7,8.8,4,2.62-.57,6.68-3.05,10.16-11.21,2.2-5.14,0-9-3.85-14.5-4.63-6.53-14.81-24.87-14.81-24.87L217.7,180.4S226.25,158.62,217.38,150.08Z",
    style: {
      fill: "#b16668"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M217.32,149.18c-9.41,2.11-12.78,2.4-20.88,16.83s-16.68,29.35-19,36.84-2.51,9.55,1.54,15.63c1.72,2.63,2.86,2,2.86,2l-1.37-1.69A17.61,17.61,0,0,1,192,210.48c7.89-1.49,9.82,2,9.82,2l.71,1.26s.58-.8-.53-2.72l-1.27-2.18s12.75-18.83,17.07-25S226.72,155.25,217.32,149.18Z",
    style: {
      fill: "#37474f"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Currency--inject-93"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--dollar--inject-93"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "191.59 133.01 192.13 132.3 170.55 115.63 170.55 94.71 169.66 94.71 169.66 116.07 169.83 116.21 191.59 133.01",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,132.66a2.11,2.11,0,1,1-2.11-2.13A2.11,2.11,0,0,1,194,132.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.1,
    cy: 60.93,
    rx: 33.52,
    ry: 33.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.1,95.21a34.28,34.28,0,1,1,34-34.28A34.19,34.19,0,0,1,170.1,95.21Zm0-67.55a33.28,33.28,0,1,0,33,33.27A33.19,33.19,0,0,0,170.1,27.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--dollar--inject-93"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.97
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.1,87.25a26.32,26.32,0,1,1,26.33-26.32A26.35,26.35,0,0,1,170.1,87.25Zm0-51.56a25.24,25.24,0,1,0,25.25,25.24A25.27,25.27,0,0,0,170.1,35.69Z",
    style: {
      fill: "#1E75FE"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.97
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173,80.74h-5.17a.51.51,0,0,1-.5-.5V76.4c-3.62-.57-7.95-2.45-9-8.07a.5.5,0,0,1,.36-.57l6.21-1.67a.47.47,0,0,1,.4.06.51.51,0,0,1,.22.35,4.4,4.4,0,0,0,3.94,3.82,6.76,6.76,0,0,0,1,.08c1.37,0,3.67-.37,3.67-2.83s-2-2.94-5.53-3.79l-1.71-.43a13.87,13.87,0,0,1-5.46-2.5,8.33,8.33,0,0,1-.73-.72l0,0a8.18,8.18,0,0,1-1.91-5.67c0-4.86,2.94-8.1,8.08-8.93V41.63a.51.51,0,0,1,.5-.5h5.17a.5.5,0,0,1,.5.5v3.9a13.71,13.71,0,0,1,2.69.72,9.27,9.27,0,0,1,5.85,6.63.5.5,0,0,1-.36.61l-5.94,1.62a.53.53,0,0,1-.39-.06.5.5,0,0,1-.23-.32,3.82,3.82,0,0,0-3.49-3.22,7.7,7.7,0,0,0-1.75-.07c-2.07.13-3.21,1.08-3.21,2.66a2.3,2.3,0,0,0,.48,1.55,3.39,3.39,0,0,0,1.26.91l.05,0a26.73,26.73,0,0,0,4,1.21A34.08,34.08,0,0,1,175.94,59l.06,0c2.55,1,5.91,3,5.91,8.21a.76.76,0,0,1,0,.15c0,4.82-3.1,8.12-8.44,9v3.85A.51.51,0,0,1,173,80.74Zm-4.67-1h4.17V76a.49.49,0,0,1,.43-.49c5.14-.75,8-3.65,8-8.18,0-3.69-1.64-5.94-5.32-7.38l0,0h0a34,34,0,0,0-3.74-1.12,27.12,27.12,0,0,1-4.16-1.25l-.06,0a4.58,4.58,0,0,1-1.66-1.21,3.32,3.32,0,0,1-.7-2.18c0-2.13,1.55-3.5,4.14-3.66a9.19,9.19,0,0,1,2,.08A4.8,4.8,0,0,1,175.51,54l5-1.35a8.26,8.26,0,0,0-5.1-5.48,13.23,13.23,0,0,0-2.9-.72A.51.51,0,0,1,172,46V42.13h-4.17v3.78a.5.5,0,0,1-.38.49l-.1,0c-4.9.67-7.6,3.51-7.6,8a7.29,7.29,0,0,0,1.62,5l.05,0a5.13,5.13,0,0,0,.66.66,12.8,12.8,0,0,0,5.07,2.29c.57.16,1.14.29,1.69.43,3.24.78,6.29,1.51,6.29,4.76,0,2.4-1.74,3.83-4.67,3.83a7.47,7.47,0,0,1-1.19-.09,5.4,5.4,0,0,1-4.67-4.12L159.4,68.6c1.1,4.9,5.18,6.44,8.46,6.87a.49.49,0,0,1,.43.49Z",
    style: {
      fill: "#1E75FE"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--rupee--inject-93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.86,172a2.12,2.12,0,1,1-2.12-2.12A2.12,2.12,0,0,1,173.86,172Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.74 220.55 111.06 219.96 152.69 171.55 171.75 171.55 171.75 172.46 153.1 172.46 111.74 220.55",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.17,
    cy: 241.27,
    rx: 33.52,
    ry: 33.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.17,275.54a34.28,34.28,0,1,1,34-34.27A34.19,34.19,0,0,1,85.17,275.54Zm0-67.55a33.28,33.28,0,1,0,33,33.28A33.2,33.2,0,0,0,85.17,208Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--rupee--inject-93"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.97
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.17,267.59a26.33,26.33,0,1,1,26.32-26.33A26.35,26.35,0,0,1,85.17,267.59Zm0-51.57a25.25,25.25,0,1,0,25.24,25.24A25.27,25.27,0,0,0,85.17,216Z",
    style: {
      fill: "#1E75FE"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.97
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.9,259.87H84.46a.5.5,0,0,1-.39-.18L74,247a.51.51,0,0,1-.11-.31v-5.15a.5.5,0,0,1,.5-.5h4.47c3.22,0,5.16-1.06,5.91-3.22H72.86a.5.5,0,0,1-.5-.5v-4.9a.5.5,0,0,1,.5-.5H84.09a2.81,2.81,0,0,0-.29-.31c-1.07-1-2.82-1.54-5.36-1.54H72.86a.5.5,0,0,1-.5-.5v-4.9a.5.5,0,0,1,.5-.5H97.48a.5.5,0,0,1,.5.5v4.9a.5.5,0,0,1-.5.5H90.79a11.13,11.13,0,0,1,.79,1.85h5.9a.5.5,0,0,1,.5.5v4.9a.5.5,0,0,1-.5.5H92.09c-.66,4.53-4.17,8-9.32,9.19l9.52,12.08a.49.49,0,0,1,.06.52A.48.48,0,0,1,91.9,259.87Zm-7.2-1h6.17L81.49,247a.51.51,0,0,1-.08-.49.54.54,0,0,1,.38-.32c4.16-.76,8.8-3.51,9.37-8.92a.49.49,0,0,1,.49-.45H97v-3.9H91.22a.5.5,0,0,1-.48-.35A7.35,7.35,0,0,0,89.56,230a.55.55,0,0,1-.15-.36.5.5,0,0,1,.16-.36l.12-.12a.52.52,0,0,1,.35-.14H97v-3.9H73.36v3.9h5.08c2.81,0,4.79.6,6.06,1.82a4.87,4.87,0,0,1,1,1.31.48.48,0,0,1,0,.48.5.5,0,0,1-.43.24H73.36v3.9H85.45a.51.51,0,0,1,.49.61c-.69,3.06-3.07,4.61-7.06,4.61h-4v4.47Z",
    style: {
      fill: "#1E75FE"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--lira--inject-93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.4,187.43a2.12,2.12,0,1,0,2.12-2.13A2.13,2.13,0,0,0,340.4,187.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.17 220.51 356.15 187.88 342.51 187.88 342.51 186.98 356.56 186.98 384.85 219.92 384.17 220.51",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 410.74,
    cy: 241.23,
    rx: 33.52,
    ry: 33.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.74,275.5a34.27,34.27,0,1,1,34-34.27A34.18,34.18,0,0,1,410.74,275.5Zm0-67.54a33.27,33.27,0,1,0,33,33.27A33.18,33.18,0,0,0,410.74,208Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--lira--inject-93"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.97
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.74,267.55a26.33,26.33,0,1,1,26.32-26.32A26.35,26.35,0,0,1,410.74,267.55Zm0-51.57A25.25,25.25,0,1,0,436,241.23,25.27,25.27,0,0,0,410.74,216Z",
    style: {
      fill: "#1E75FE"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.97
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.43,259h-9a.5.5,0,0,1-.5-.5V247.34l-2.75.61a.53.53,0,0,1-.42-.1.51.51,0,0,1-.19-.39v-5.89a.49.49,0,0,1,.39-.48l3-.66v-1.74l-2.75.6a.46.46,0,0,1-.42-.1.47.47,0,0,1-.19-.38V233a.5.5,0,0,1,.39-.49l3-.65v-7.91a.51.51,0,0,1,.5-.5h6.88a.51.51,0,0,1,.5.5v6.16l5.07-1.11a.52.52,0,0,1,.42.1.51.51,0,0,1,.19.39v5.88a.49.49,0,0,1-.39.49L409.81,237v1.75l5.07-1.11a.52.52,0,0,1,.42.1.51.51,0,0,1,.19.39V244a.51.51,0,0,1-.39.49l-5.29,1.19V252h1.33c6.37,0,7.94-3.77,8.6-7.06a.49.49,0,0,1,.23-.33.56.56,0,0,1,.4-.06l6.28,1.78a.49.49,0,0,1,.35.57C426.18,251.4,423.07,259,411.43,259Zm-8.5-1h8.5c7.92,0,13.06-3.87,14.5-10.91l-5.32-1.51c-1.16,4.94-4.27,7.34-9.47,7.34h-1.83a.5.5,0,0,1-.5-.5v-7.22a.49.49,0,0,1,.39-.48l5.29-1.2v-4.82l-5.08,1.11a.53.53,0,0,1-.42-.1.53.53,0,0,1-.18-.39v-2.77a.49.49,0,0,1,.39-.49l5.29-1.15v-4.86l-5.08,1.11a.53.53,0,0,1-.42-.1.5.5,0,0,1-.18-.39v-6.28h-5.88v7.81a.5.5,0,0,1-.39.49l-3,.65v4.81l2.76-.61a.53.53,0,0,1,.42.1.5.5,0,0,1,.18.39v2.77a.49.49,0,0,1-.39.49l-3,.66v4.86l2.76-.61a.47.47,0,0,1,.42.1.48.48,0,0,1,.18.39Z",
    style: {
      fill: "#1E75FE"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--euro--inject-93"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "307.31 133.01 306.76 132.3 328.35 115.63 328.35 94.71 329.24 94.71 329.24 116.07 329.07 116.21 307.31 133.01",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.93,132.66a2.11,2.11,0,1,0,2.11-2.13A2.11,2.11,0,0,0,304.93,132.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 328.8,
    cy: 60.93,
    rx: 33.52,
    ry: 33.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.79,95.21a34.28,34.28,0,1,1,34-34.28A34.19,34.19,0,0,1,328.79,95.21Zm0-67.55a33.28,33.28,0,1,0,33,33.27A33.18,33.18,0,0,0,328.79,27.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--euro--inject-93"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.97
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.8,87.25a26.32,26.32,0,1,1,26.32-26.32A26.36,26.36,0,0,1,328.8,87.25Zm0-51.56A25.24,25.24,0,1,0,354,60.93,25.27,25.27,0,0,0,328.8,35.69Z",
    style: {
      fill: "#1E75FE"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.97
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.16,79.13C322,79.13,317,75.45,315,68.76h-2.37a.5.5,0,0,1-.5-.5v-6a.5.5,0,0,1,.5-.5h1.31V60.11h-1.26a.5.5,0,0,1-.5-.5V53.69a.5.5,0,0,1,.5-.5h2.1c1.81-6.94,6.53-10.46,14-10.46s12.32,3.5,13.74,10.12a.5.5,0,0,1-.36.59l-6.35,1.71a.49.49,0,0,1-.39,0,.57.57,0,0,1-.23-.3c-.72-2.76-2-5.3-6.46-5.3-3.16,0-5.05,1.14-6.05,3.69H331a.5.5,0,0,1,.5.5v5.92a.5.5,0,0,1-.5.5h-9.23v.13c0,.55,0,1.07,0,1.56H331a.5.5,0,0,1,.5.5v6a.5.5,0,0,1-.5.5h-8c1.05,2.21,2.87,3.16,6,3.16,3.32,0,5.27-1.27,6.32-4.12a.5.5,0,0,1,.61-.31l6.35,1.76a.49.49,0,0,1,.31.25.45.45,0,0,1,0,.39C341.44,73.34,338.17,79.13,329.16,79.13ZM313.08,67.76h2.24a.5.5,0,0,1,.48.37c1.84,6.54,6.46,10,13.36,10,8,0,11.1-4.83,12.31-8.06l-5.41-1.5c-1.64,3.89-4.81,4.35-7.09,4.35-3.76,0-6-1.42-7.17-4.48a.5.5,0,0,1,.46-.68h8.21v-5h-9.18a.5.5,0,0,1-.5-.46c-.05-.66-.05-1.36-.05-2.1v-.63a.5.5,0,0,1,.5-.5h9.23V54.19H322a.48.48,0,0,1-.4-.2.55.55,0,0,1-.08-.45c1.06-3.44,3.36-5,7.23-5,4.88,0,6.51,2.87,7.29,5.56l5.42-1.46c-1.44-5.89-5.7-8.87-12.66-8.87-7.23,0-11.53,3.29-13.16,10.08a.49.49,0,0,1-.48.38h-2v4.92h1.26a.5.5,0,0,1,.5.5V62.3a.5.5,0,0,1-.5.5h-1.31Z",
    style: {
      fill: "#1E75FE"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pound--inject-93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.68,148.92a2.12,2.12,0,1,1-2.12-2.12A2.12,2.12,0,0,1,183.68,148.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.56 149.38 149.57 149.38 137.94 140.12 99.7 140.12 99.7 139.21 138.25 139.21 149.88 148.47 181.56 148.47 181.56 149.38",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.17,
    cy: 139.67,
    rx: 33.52,
    ry: 33.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.17,173.94a34.28,34.28,0,1,1,34-34.27A34.19,34.19,0,0,1,66.17,173.94Zm0-67.55a33.28,33.28,0,1,0,33,33.28A33.19,33.19,0,0,0,66.17,106.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pound--inject-93"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.97
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.17,166A26.33,26.33,0,1,1,92.5,139.66,26.36,26.36,0,0,1,66.17,166Zm0-51.57a25.25,25.25,0,1,0,25.25,25.24A25.27,25.27,0,0,0,66.17,114.42Z",
    style: {
      fill: "#1E75FE"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.97
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79,156.37H53.43a.5.5,0,0,1-.5-.5v-6a.5.5,0,0,1,.41-.49c2.44-.48,2.87-1.8,2.87-4.4,0-.58,0-1.2-.08-1.85,0-.22,0-.45,0-.68H53.38a.5.5,0,0,1-.5-.5V136.6a.5.5,0,0,1,.5-.5h2c-.18-1.9-.34-3.7-.34-5.37,0-6.34,4.33-10.28,11.3-10.28,7.37,0,11.63,3.47,12.68,10.3a.5.5,0,0,1-.37.56L72.49,133a.51.51,0,0,1-.4-.07.51.51,0,0,1-.22-.35c-.53-3.64-2-5.19-5-5.19s-4.49,1.56-4.49,4.93a33.75,33.75,0,0,0,.29,3.8H72.7a.5.5,0,0,1,.5.5v5.33a.5.5,0,0,1-.5.5H63.48a21.41,21.41,0,0,1,.19,2.48,7.83,7.83,0,0,1-1,4.44H79a.5.5,0,0,1,.5.5v6A.5.5,0,0,1,79,156.37Zm-25-1H78.46v-5h-17a.51.51,0,0,1-.49-.36.49.49,0,0,1,.23-.56c1-.62,1.52-2.13,1.52-4.52a24.27,24.27,0,0,0-.25-2.92.52.52,0,0,1,.13-.39.48.48,0,0,1,.37-.17H72.2V137.1h-10a.5.5,0,0,1-.5-.44,38,38,0,0,1-.35-4.36c0-3.88,1.9-5.93,5.49-5.93,3.36,0,5.26,1.75,5.94,5.5L78,130.46c-1.07-6.06-4.88-9-11.61-9-6.45,0-10.3,3.47-10.3,9.28,0,1.73.18,3.63.37,5.63v.19a.51.51,0,0,1-.12.39.52.52,0,0,1-.37.16h-2.1v4.33h2.68a.5.5,0,0,1,.5.48c0,.38,0,.76.07,1.14,0,.67.08,1.31.08,1.91,0,2.75-.56,4.61-3.28,5.29Z",
    style: {
      fill: "#1E75FE"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--yen--inject-93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364,142.48a2.11,2.11,0,1,0,2.11-2.13A2.12,2.12,0,0,0,364,142.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.79 142.93 366.12 142.93 366.12 142.03 386.48 142.03 398.1 132.77 417.29 132.77 417.29 133.67 398.41 133.67 386.79 142.93",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.82,
    cy: 133.22,
    r: 33.42,
    transform: "translate(-16.66 182.66) rotate(-22.5)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.82,167.14a33.92,33.92,0,1,1,33.92-33.92A34,34,0,0,1,450.82,167.14Zm0-66.84a32.92,32.92,0,1,0,32.92,32.92A33,33,0,0,0,450.82,100.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--yen--inject-93"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.97
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.82,159.47a26.25,26.25,0,1,1,26.24-26.25A26.28,26.28,0,0,1,450.82,159.47Zm0-51.41A25.17,25.17,0,1,0,476,133.22,25.19,25.19,0,0,0,450.82,108.06Z",
    style: {
      fill: "#1E75FE"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.97
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.23,151.85H447.4a.5.5,0,0,1-.5-.5V142.1h-8.42a.5.5,0,0,1-.5-.5v-5.94a.5.5,0,0,1,.5-.5h6.79l-.85-1.68h-5.94a.51.51,0,0,1-.5-.5v-5.9a.5.5,0,0,1,.5-.5h2.46l-4.61-9.13a.48.48,0,0,1,0-.48.5.5,0,0,1,.43-.24h7.45a.5.5,0,0,1,.46.29l5.12,11.11c.43.9,1,2.22,1.31,3.1v0c.36-.88.91-2.2,1.34-3.13L457.28,117a.51.51,0,0,1,.46-.3h7.12a.49.49,0,0,1,.42.24.48.48,0,0,1,0,.48l-4.6,9.13h2.94a.5.5,0,0,1,.5.5V133a.5.5,0,0,1-.5.5h-6.42l-.86,1.68h7.28a.5.5,0,0,1,.5.5v5.94a.5.5,0,0,1-.5.5h-8.91v9.25A.5.5,0,0,1,454.23,151.85Zm-6.33-1h5.83V141.6a.5.5,0,0,1,.5-.5h8.91v-4.94h-7.59a.5.5,0,0,1-.43-.24.5.5,0,0,1,0-.49l1.37-2.68a.48.48,0,0,1,.44-.27h6.23v-4.9h-3.26a.49.49,0,0,1-.42-.24.5.5,0,0,1,0-.49l4.61-9.12h-6l-4.7,10.76c-.43.92-1,2.23-1.32,3.1s-.4,1-.49,1.06a.5.5,0,0,1-.35.14H451a.5.5,0,0,1-.35-.14c-.09-.09-.09-.09-.41-.89s-.9-2.27-1.35-3.2l-5-10.83h-6.32l4.6,9.12a.5.5,0,0,1,0,.49.49.49,0,0,1-.42.24H439v4.9h5.74a.5.5,0,0,1,.45.27l1.36,2.68a.5.5,0,0,1,0,.49.49.49,0,0,1-.42.24H439v4.94h8.42a.5.5,0,0,1,.5.5Z",
    style: {
      fill: "#1E75FE"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/currency.7eaf6065a9bd3897b6cab16820ed5655.svg";
export { ForwardRef as ReactComponent };